import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { unstable_batchedUpdates } from 'react-dom';
import { updatedDiff } from 'deep-object-diff';
import { AnimatedItem } from '../../components/animations/AnimatedItem';
import { Grid, Typography, Button, CircularProgress, Drawer, Tooltip, Tabs, Tab, Checkbox, FormControlLabel, IconButton, Snackbar, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import moment from 'moment';
import { mainTheme } from '../../Theme';
import {
    UpdateEnquiryMutation,
    CreateEnquiryMutation,
    EnquiryDetailsQueryParams,
    retrieveEnquiryDetailsData,
    FollowUpEnquiryMutation,
    fetchTenantData,
    TenantData,
    fetchHomeCountry,
    OptionData,
    CompleteCreateClientMutation,
    CreateMeetingBookingTaskMutation,
    AppUser,
    fetchAppUserData,
    AppUserData,
    EmailTemplateCountQueryParams,
    retrieveEmailTemplateCount,
    EmailTemplateData,
    EnquiryDefaultConfig,
    retrieveGeneralInfoData,
    GeneralInfoDataParams,
    GeneralInfoData,
    Financials,
    LinkEnquiryMutation,
    // fetchTenantTimezoneData,
    UpdateEnquiryQualityMutation,
    UpdateEnquiryQualityParams,
    UpdateEnquiryLikelihoodMutation,
    UpdateLikelihoodParams,
    UploadEnquiryMatterDocumentMutation,
    DeleteEnquiryMutation,
    // EnquirySummaryQueryParams,
    // retrieveEnquirySummaryData,
} from '../EnquirySummaryRepository';
import { Form, FormSpy, FieldInputProps, AnyObject } from 'react-final-form';
import { FieldValidator, FormApi, SubmissionErrors, ValidationErrors } from 'final-form';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { IDownShiftItem } from 'mui-downshift';
import { client } from '../..';
import { showNotification } from '../../App';
// import { EnquirySummaryContext } from '../EnquirySummaryContext';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { EnquiryDetail, EnquiryData, Actions } from '../models/Enquiry';
import { IAreaOfLawAutoCompleteItem } from '../selectors/AreaOfLawSelector';
// import { ActionTypeSelector } from '../selectors/ActionType';
// import { OutcomeSelector } from '../selectors/OutcomeSelector';
import { DocumentFile } from '../../types/DocumentFile';
import { ToggleChip } from '../radio/ToggleChip';
import { HeaderWidgetSkeleton } from './components/HeaderWidgetSkeleton';
import { SaveButtonWithValidationSummary, resolveFieldLabel } from './components/SaveButtonWithValidationSummary';
import { UnsavedDetailsFollowUpDialog } from './components/UnsavedDetailsFollowUpDialog';
import { CustomFieldsSection } from './components/CustomFieldsSection';
import { ShowWhenScrolledPast } from './components/ShowWhenScrolledPast';
import { EnquiryJourneyTimelineWidget } from '../common/EnquiryJourneyTimelineWidget';
import { EnquiryNextFollowUpWidget } from '../common/EnquiryNextFollowUpWidget';
import { getDaysOpen } from '../common/journeyData';
import { ContactDetailsPanel } from './panels/ContactDetailsPanel';
import { OrganisationPanel } from './panels/OrganisationPanel';
import { OtherSidePanel } from './panels/OtherSidePanel';
import { OtherDetails2Panel } from './panels/OtherDetails2Panel';
import { OtherDetailsPanel } from './panels/OtherDetailsPanel';
import { EnquiryValuePanel } from './panels/EnquiryValuePanel';
import { EnquiryDetailsPanel } from './panels/EnquiryDetailsPanel';
import { RiskAssessedPanel } from './panels/RiskAssessedPanel';
import { DigitalTrackingPanel } from './panels/DigitalTrackingPanel';
import { DocumentsPanel } from './panels/DocumentsPanel';
import { DetailedEnquiryNotesPanel } from './panels/DetailedEnquiryNotesPanel';
import { useStableCallback } from './panels/useStableCallback';
import { useDebouncedStableCallback } from './panels/useDebouncedStableCallback';
import { EnquiryListNavigation } from '../hooks/useEnquiryListNavigation';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { CreateClientDialog } from '../dialogs/CreateClientDialog';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import { OrganisationIAutoCompleteItem } from '../selectors/OrganisationSelector';
import { IndividualNameSummary } from '../selectors/IndividualSelector';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { CurrencySymbolData, retrieveCurrencySymbolData } from '../../ClientAndContactDetails/referrals/ReferralsDetailsRepository';
import { EmailTemplateTypeEnum, EmailTemplateMessageTypeEnum } from '../../emailTemplatesConfiguration/EmailTemplateRespository';
import { retrieveDefaultFollowUpTemplate } from '../selectors/EmailTemplateSelector';
import { BookMeetingEmailDialog } from '../dialogs/BookMeetingEmailDialog';
import { Alert, Rating } from '@material-ui/lab';
import { Address, PlaceType } from '../selectors/AddressSelector';
import { CustomTableContentProps, ValueTypeEnum } from '../../components/CustomTable';
import { MarkClientAndMatterCreatedDialog } from '../dialogs/MarkClientAndMatterCreatedDialog';
import { useHistory } from 'react-router-dom';
import { validateUrl } from '../../helpers/validationHelper';
import { buildEnquiryInitialValues, getFirstAddressOfEachType } from './enquiryInitialValues';
import { DuplicateContactInfoPopup } from './components/DuplicateContactInfoPopup';
import { PickedFormValues } from './components/PickedFormValues';
import { detectUpdatedTab, createEnquiryInput, updateEnquiryInput, buildEnquiryFormValues, getFollowUpDueDefaultValue as getFollowUpDueDefaultValueFor } from './enquiryFormMapping';
import { AssignmentPanel } from './panels/AssignmentPanel';
import { ProceedingPanel } from './panels/ProceedingPanel';
import { ActivityTabSection } from './components/ActivityTabSection';
import { prefetchCannedNotes } from './components/useCannedNotes';
import { EnquiryFormTourHost } from './enquiryFormTour';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';
import { MatterTabSection } from './components/MatterTabSection';
import { EnquiryFormDrawerSkeleton } from './components/EnquiryFormDrawerSkeleton';
import { EnquiryAiHeaderBadge, AiChatDialogOpenWatcher } from './components/EnquiryAiHeaderBadge';
import { EnquiryRatingBadge } from './components/EnquiryRatingBadge';
import { LightTooltip } from './components/LightTooltip';
import { useStyles } from './enquiryFormDrawerStyles';
import { EnquiryFormTab, WIDE_LAYOUT_DRAWER_WIDTH, WIDE_LAYOUT_DRAWER_MIN_WIDTH, MEDIUM_LAYOUT_DRAWER_WIDTH, MEDIUM_LAYOUT_DRAWER_MIN_WIDTH, getActivitiesTabFields, DetailsTabPanelKey, DETAILS_TAB_PANEL_KEYS, getDetailsTabFields } from './enquiryFormDrawerConstants';
import { formatAuPhoneForDisplay, ContactLine, AddContactFieldLink } from './components/ContactLine';
// import { EntityTypeEnum, UserStaffAndTeamAutoCompleteSelector } from '../selectors/UserStaffAndTeamAutoCompleteSelector';
import { retrieveTimezoneOptionData, TimezoneOption, TimezoneOptionData } from '../../lookupConfiguration/selectors/TimezoneSelector';
// import { RegionSettingsData } from '../../firmSettingConfiguration/tabs/RegionalTab';
import { LeadDetailsHistoryData, LeadDetailsHistoryQueryParams, RemoveAutoFollowUp, retrieveLeadDetailsHistoryData, TaskDetails, TaskSummaryList } from '../../leadsDetail/LeadsDetailRepository';
import { EntityTypeEnum } from '../selectors/UserStaffAndTeamAutoCompleteSelector';
import { useRegionSettings } from '../../hooks/useRegionSettings';
import { getApplicationTerminology, retrieveQueryData } from '../../helpers/commonHelper';
import { useTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';
import { TaskSummary } from '../../tasksSummary/TasksSummaryRepository';
import { EventAndCampaignAttendeeSummary } from '../../eventsAndCampaignsAttendee/EventsAndCampaignsAttendeeRepositories';
import { NameSummary, PartyAddressesData, PartyAddressesParams, PartyAddressesQuery } from '../../nameSummary/NameSummaryRepository';
import { EventsAndCampaignIAutoCompleteItem } from '../../notesSummary/selectors/EventsAndCampaignSelector';
import { Partydetails } from '../../ClientAndContactDetails/ClientAndContactDetailsRepositories';
import { DateType } from '@date-io/type';
import { useQuery } from 'react-apollo';
import {
    ContactEnquiry,
    ContactMatterList,
    CrmDuplicateCheckQuery,
    DuplicateCheck,
    DuplicateCheckData,
    DuplicateCheckParams
} from '../../hooks/useCrmDuplicateCheck';
import { CustomFieldKeyProps } from '../../enquiryCustomFields/common/getField';
import { CustomFieldByHierarchy, CustomFieldByHierarchyData, CustomFieldByHierarchyQuery, CustomFieldByHierarchyQueryParams } from '../../enquiryCustomFields/CustomFieldRepositores';
import { useHomeCountry } from '../../hooks/useHomeCountry';
import { useTenant } from '../../hooks/useTenant';
import { SmokeBallCreateMatterDialog } from '../dialogs/SmokeBallCreateMatterDialog';
import { ActionStepCreateMatterDialog } from '../dialogs/ActionStepCreateMatterDialog';
import { HistoryFileV2 } from '../common/HistoryFileV2';
import { AffinityCreateMatterDialog } from '../dialogs/AffinityCreateMatterDialog';
import { useIsQuickViewPinned, QUICK_VIEW_WIDTH } from '../../userDashboard/quickView/QuickViewDrawer';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import GavelIcon from '@material-ui/icons/Gavel';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { DocumentAiEnquirySummary } from '../../documentAi/AiDocumentChatContext';
// DEBUG: Field is the original component unless the render-count flag is on (see helpers/renderCountDebug)
import { Field } from '../../helpers/renderCountDebug';

// import RenderCount from '../helpers/RenderCount';

// The values the drawer's own shell markup (root width, custom-field warning dialog, "update contact" alert,
// further-details layout) reads. Everything else gets the complete values locally - see PickedFormValues.
// The values the header (identity, quality / likelihood badges, meeting-booking email dialog) reads.
const pickHeaderValues = (values: AnyObject) => ({
    isBookMeetingEmailDialogOpen: values.isBookMeetingEmailDialogOpen,
    guid: values.guid,
    followUpAction: values.followUpAction,
    followUpActionSystemName: values.followUpActionSystemName,
    isSendConfirmation: values.isSendConfirmation,
    email: values.email,
    staff: values.staff,
    officeLocation: values.officeLocation,
    timezone: values.timezone,
    startTime: values.startTime,
    endTime: values.endTime,
    isAllDay: values.isAllDay,
    meetingNotes: values.meetingNotes,
    feeApplicable: values.feeApplicable,
    assignedTo: values.assignedTo,
    isSendMeetingDefaultReminderEmail: values.isSendMeetingDefaultReminderEmail,
    isSendMeetingDefaultReminderSms: values.isSendMeetingDefaultReminderSms,
    periodMeetingDefaultReminder: values.periodMeetingDefaultReminder,
    firstName: values.firstName,
    lastName: values.lastName,
    organisation: values.organisation,
    isClosed: values.isClosed,
    phone: values.phone,
    mobile: values.mobile,
    internalNotes: values.internalNotes,
    assignedToName: values.assignedToName,
    areaOfLaw: values.areaOfLaw,
});

// The values the save / follow-up action bar (actionButton) reads at render time.
const pickActionButtonValues = (values: AnyObject) => ({
    followUpSystemAction: values.followUpSystemAction,
    staff: values.staff,
    officeLocation: values.officeLocation,
    timezone: values.timezone,
    startTime: values.startTime,
    endTime: values.endTime,
    isSavedDirectly: values.isSavedDirectly,
    isSentAcknowledgementEmail: values.isSentAcknowledgementEmail,
    isKeyOpportunity: values.isKeyOpportunity,
});

const pickDrawerShellValues = (values: AnyObject) => ({
    practiceAreaGuidID: values.practiceAreaGuidID,
    showCustomFieldWarning: values.showCustomFieldWarning,
    tempPracticeAreaGuidID: values.tempPracticeAreaGuidID,
    tempAreaOfLaw: values.tempAreaOfLaw,
    isContactDetailsChanged: values.isContactDetailsChanged,
    isUpdateContacts: values.isUpdateContacts,
});

// EnquiryFormTab used to be declared (and exported) in this file
export { EnquiryFormTab };

// The class map useStyles() returns - exported so panels split out of this file can type their `classes` prop.
export type EnquiryFormClasses = ReturnType<typeof useStyles>;

interface BookingMeetingProps {
    staff: IAutoCompleteItem | null;
    startTime: Date | null;
    endTime: Date | null;
    isAllDay: boolean;
    officeLocation: IAutoCompleteItem | null;
    feeApplicable: number | null;
    isSendConfirmation: boolean;
    meetingNotes: string | null;
    timezone: IAutoCompleteItem | null;
    isBookMeetingEmailDialogOpen: boolean;
    periodMeetingDefaultReminder: IAutoCompleteItem | null;
    isSendMeetingDefaultReminderSms: boolean;
    isSendMeetingDefaultReminderEmail: boolean;
}

interface BotIntegrationProps {
    followUpBotUrl: string | null;
}

export interface EnquiryCustomFieldMutation {
    entityType: number | null;
    entityGuid: string | null;
    customFieldGuid: string | null;
    customFieldGroupGuid?: string | null;
    textValue: string | null;
    multiLineTextValue: string | null;
    integerValue: number | null;
    numberValue: number | null;
    currencyValue: number | null;
    dateValue: Date | null;
    dateTimeValue: Date | null;
    boolValue: boolean | null;
    customFieldLookupListItemGuid: string | null;
    lookupListName?: string | null;
    emailValue?: string | null; // Added Email field
    // documentGuid: string | null;
}

export interface EnquiryCustomFieldProps {
    tempPracticeAreaGuidID?: string | null;
    tempAreaOfLaw?: string | null;
    showCustomFieldWarning?: boolean;
    customField?: {
        [key: string]: {
            [key: string]: CustomFieldKeyProps;
        }
    }
    enquiryCustomField?: EnquiryCustomFieldMutation[];
}

export interface EnquiryDigitalTrackingState {
    clickThroughUrl: string | null;
    utmSource: string | null;
    utmMedium: string | null;
    utmCampaign: string | null;
    utmContent: string | null;
    utmKeyword: string | null;
    googleClickIdentifier: string | null;
    facebookClickIdentifier: string | null;
}

export interface Enquiry extends BookingMeetingProps, BotIntegrationProps, EnquiryCustomFieldProps, EnquiryDigitalTrackingState {
    handleCreateAndClose: boolean | undefined;
    handleCreateAndNew: boolean | undefined;
    handleUpdate: boolean | undefined;
    // showDiscard: boolean;
    // isFormChanged: boolean;
    isAssignmentExpand: boolean;

    guid?: string;
    firstName: string;
    lastName: string;
    individualSelector: IndividualNameSummary | null;
    email: string;
    gender: string | null;
    initialEnquiryDate: Date | null;
    phone: string;
    mobile: string;
    source: IAutoCompleteItem | null;
    office: IAutoCompleteItem | null;
    sourceNotes: string;

    organisationSelector: OrganisationIAutoCompleteItem | null;
    organisation: string;
    positionAtOrganisation: string;

    natureOfEnquiry: string;
    practiceAreaGuidID: string | null;
    areaOfLaw: string | null;

    internalNotes: string | null;
    files: DocumentFile[];

    assignedTo: string | null;
    assignedToName: string | null;
    assignedBy: string | null;
    assignedByName: string | null;
    dateAssigned: Date | null;
    followUpDueDate: Date | null;
    assignmentFollowUpDueReminder: IAutoCompleteItem | null;

    followUpAction: string | null;
    followUpActionSystemName: string | null;
    followUpSystemAction: string | null;
    followUpDate: Date | null;

    outcome: string | null;
    outcomeDate: Date | null;
    outcomeNotes: string | null;
    reason: string | null;
    reasonGuidID: string | null;
    followUpNotes: string | null;
    hasFollowUpNotesMentions: boolean;
    isClosed: boolean;
    isKeyOpportunity: boolean;
    isNotProceeding: boolean;
    notProceedingReason: string | null;
    notProceedingReasonGuid: string | null;
    followUpDueReminder: IAutoCompleteItem | null;

    referrerGuid: string | null;
    referrerName: string | null;
    isReferrerFromDataSource: boolean | null;
    isShowReferrer: boolean;

    isNameSwitched: boolean;
    isOrganisationSwitched: boolean;
    nameGuid: string | null;
    organisationGuid: string | null;

    emailTemplate: IAutoCompleteItem | null;

    isContactDetailsChanged: boolean;
    isUpdateContacts: boolean;
    isSentAcknowledgementEmail: boolean;

    /*
    When to update Follow Up Due Date when doing a Internal Notes action
    1. @Mention and no follow up due date change - Do not change previous follow up due date
    2. @Mention and follow up due date change - Update follow up due date
    3. No @Mention and no follow up due date change - Change follow up due date - Because, the user clicked on the Internal Notes option
    4. No @Mention and follow up due date change - Change follow up due date
    */
    updateFollowUpDueForInternalNote: boolean;
    outcomeDateChanged: boolean;

    // Other details fields
    estimatedFees: number | null;
    isEstimatedFeesIncludesTax: boolean;
    estimatedDisbursements: number | null;
    isEstimatedDisbursementsIncludesTax: boolean;
    enquiryQuality: number | null;
    likelihoodToProceed: number | null;
    clientFirstName: string | null;
    clientLastName: string | null;
    dOB: Date | DateType | null;
    isMarketingConsent: boolean;
    isConflictCheckPerformed: boolean;
    isTermsAndConditionsApproved: boolean;
    isIdentityCheckPerformed: boolean;
    isPrivacyStatementProvided: boolean;
    addressName: string | null;
    floor: string | null;
    number: string | null;
    street: string | null;
    street2: string | null;
    suburb: string | null;
    state: string | null;
    postcode: string | null;
    country: string | null;
    pOBox: string | null;
    postalSuburb: string | null;
    postalState: string | null;
    postalPostCode: string | null;
    postalCountry: string | null;
    isNoConflict: boolean;

    isShowNotProceedingReferrer: boolean;
    isNotProceedingReferrerSwitched: boolean;
    referredToFirmSelector: IAutoCompleteItem | null;
    referredToFirmGuid: string | null;
    referredToFirmName: string | null;
    notProceedingOutcomeNotes: string | null;

    isShowNotProceedingReferrerInProceeding: boolean;
    isNotProceedingReferrerSwitchedInProceeding: boolean;
    referredToFirmSelectorInProceeding: IAutoCompleteItem | null;
    referredToFirmGuidInProceeding: string | null;
    referredToFirmNameInProceeding: string | null;
    notProceedingOutcomeNotesInProceeding: string | null;

    clientRelationshipToEnquirer: string | null;

    matterId: number | null;
    matterGuid: string | null; // Saved Matter Guid
    matterTitle: string | null;
    matterFileNumber: string | null;

    // tslint:disable-next-line: no-any
    matterSelector: IAutoCompleteItem | null | any; // Selector in Matter Tab

    pOBoxType: string | null;
    enquiryNotes: string | null;

    otherPartyFirstName: string | null;
    otherPartyLastName: string | null;
    otherPartyNotes: string | null;
    otherPartyEmail: string | null;
    otherPartyPhone: string | null;
    otherPartyMobile: string | null;
    otherPartyOrganisation: string | null;
    otherPartyDOB: Date | null;
    otherPartyAddressName: string | null;
    otherPartyFloor: string | null;
    otherPartyNumber: string | null;
    otherPartyStreet: string | null;
    otherPartyStreet2: string | null;
    otherPartySuburb: string | null;
    otherPartyState: string | null;
    otherPartyPostcode: string | null;
    otherPartyCountry: string | null;

    otherPartyPOBoxType: string | null;
    otherPartyPOBox: string | null;
    otherPartyPostalSuburb: string | null;
    otherPartyPostalState: string | null;
    otherPartyPostalPostCode: string | null;
    otherPartyPostalCountry: string | null;
    isOtherPartyNameSwitched: boolean;
    otherPartyNameGuid: string | null;
    otherPartyOrganisationGuid: string | null;
    otherPartyIndividualSelector: IndividualNameSummary | null;

    isSavedDirectly: boolean;

    isRiskAssessed: boolean | null;
    riskLevelSelector: IAutoCompleteItem | null;
    riskNotes: string | null;

    secondClientFirstName: null | string;
    secondClientLastName: null | string;
    secondClientRelationshipToEnquirer: null | string;
    secondClientGender: null | string;
    secondClientSuburb: null | string;
    secondClientState: null | string;
    secondClientPostCode: null | string;
    secondClientIsMarketingConsent: boolean;
    secondClientIsTermsAndConditionsApproved: boolean;
    secondClientIsPrivacyStatementProvided: boolean;
    secondClientIsConflictCheckPerformed: boolean;
    secondClientIsIdentityCheckPerformed: boolean;
    secondClientIsNoConflict: boolean;
    secondClientCountry: null | string;
    secondClientAddressName: null | string;
    secondClientFloor: null | string;
    secondClientNumber: null | string;
    secondClientStreet1: null | string;
    secondClientStreet2: null | string;
    secondClientDOB: Date | null;
    secondClientPOBoxType: null | string;
    secondClientPOBox: null | string;
    secondClientPostalSuburb: null | string;
    secondClientPostalState: null | string;
    secondClientPostalPostCode: null | string;
    secondClientPostalCountry: null | string;

    responseText: null | string;

    // events and campaigns
    eventAndCampaignSelector: EventsAndCampaignIAutoCompleteItem | null;
    eventsAndCampaignNotes: string | null;

    // new fields
    title: string | null;
    otherPartyTitle: string | null;

    clientTitle: string | null;
    clientGuid: string | null;
    clientEmail: string | null;
    clientPhone: string | null;
    clientMobile: string | null;

    secondClientTitle: string | null;
    secondClientGuid: string | null;
    secondClientEmail: string | null;
    secondClientPhone: string | null;
    secondClientMobile: string | null;

    isClientNameSwitched: boolean;
    isSecondClientNameSwitched: boolean;

    clientIndividualSelector: IndividualNameSummary | null;
    secondClientIndividualSelector: IndividualNameSummary | null;

    tabEdited?: 'detailsTab' | 'activityTab';

    // auto follow ups
    autoFollowUpEmailTemplate: IAutoCompleteItem | null;
    isAutoFollowUp: boolean | null;
}

export interface EnquiryFormProps {
    guid?: string;
    formAction: string;
    assignedBy: string | null;
    assignedByName: string | null;
    onDialogClose?: () => void;
    isEnquiryFormOpen: boolean;
    isRefreshData?: boolean;
    isKeyOpportunity: boolean;
    enquiryDefaultConfig?: EnquiryDefaultConfig;
    homeCountry: string;
    pOBoxType: string | null;
    taskSummary?: TaskSummary;
    eventAndCampaignAttendeeSummary?: EventAndCampaignAttendeeSummary;
    nameSummary?: NameSummary;
    partyDetails?: Partydetails;
    /** Shifts the drawer's right edge left by this many px, so it opens starting from
     * another right-anchored panel's own left edge instead of the viewport's - explicit
     * request from QuickViewDrawer.tsx, so the record and Quick View are both visible at
     * once instead of this drawer covering it. Omit for the normal full-right-edge anchor. */
    anchorOffset?: number;
    // Explicit addition (enquiry prev/next navigation spec): undefined whenever the drawer was
    // opened without a list-row click (e.g. the /enquiriesSummary/:id direct-link case) - the
    // whole prev/next UI (Task 5) and its keyboard shortcuts simply don't render/attach then.
    listNavigation?: EnquiryListNavigation;
    // Explicit bug report: set by EnquirySummaryPage when this instance only exists because the
    // user stepped prev/next (the drawer is keyed by guid, so each step remounts it) - skips the
    // Drawer's own enter animations so the backdrop/panel don't flicker out and back in.
    skipEnterTransition?: boolean;
}

export interface EnquiryFormState {
    isFormChanged: boolean;
    showDiscard: boolean;
    // showTabsSaveAlert: boolean;
    tab: EnquiryFormTab;
    isEmailNotification: boolean;
    isCreateClientOpen: boolean;
    isCreateClient: boolean;
    isMarkClientMatterCreatedOpen: boolean;
    sourceSystem: string;
    homeCountry: string;
    isExpandDrawer: boolean;
    currency: string;
    // tenantTimezone: IAutoCompleteItem | null;
    isSendEmailDialogOpen: boolean;
    hideSendAcknowledgement: boolean;
    generalInfoData?: CustomTableContentProps[];
    matterClientName?: string;
    financials: Financials | null;

    isFormSubmit: boolean;
    // Explicit request: "Add phone"/"Add email" (shown when the header's contact lines are
    // empty), and "Add mobile" (shown by the Follow Up panel's "Send SMS requires a mobile
    // number" warning) switch to the Details tab, expand Contact Details, then focus this field
    // once it's actually in the DOM - cleared once the focus effect fires, or on form reset.
    pendingFocusField: 'phone' | 'email' | 'mobile' | null;
    // Explicit addition (enquiry prev/next navigation spec): which action to resume once the
    // user confirms "discard changes" - onDiscardChanges (below) branches on this instead of
    // always resuming onEnquiryFormClosed().
    pendingNavigation: 'close' | 'prev' | 'next' | null;
    isContactDetailsPanelExpand: boolean;
    isEnquiryDetailsPanelExpand: boolean;
    isAssignPanelExpand: boolean;
    isOtherContactDetailsPanelExpand: boolean;
    isOtherDetailsPanelExpand: boolean;
    isOther2DetailsPanelExpand: boolean;
    isPostalAddressPanelExpand: boolean;
    isClient2PostalAddressPanelExpand: boolean;
    isOtherSidePanelExpand: boolean;
    isOtherSidePostalAddressPanelExpand: boolean;
    isDetailedEnquiryNotesPanelExpand: boolean;
    isDigitalTrackingPanelExpand: boolean;
    isOrganisationPanelExpand: boolean;
    isEnquiryValuePanelExpand: boolean;

    enquiryQuality: number | null;
    likelihoodToProceed: number | null;
    timezone: TimezoneOption[];
    isBookMeetingFromHistoryActivity: boolean;

    customFieldByHierarchy?: CustomFieldByHierarchy[];

    duplicateCheck: DuplicateCheck | null;
    // Was sketched as hasDuplicate?: 'yes'|'no'|'checking' below but never wired up - explicit
    // request for a loading indicator on the Check Duplicates button. duplicateCheck !== null
    // already tells us "checked"; this only needs to cover "checking" itself.
    isDuplicateChecking: boolean;
    // True for a few seconds right after a check completes - explicit request: rather than a
    // separate result chip, the button's own text/icon/colour swaps to the result briefly,
    // then reverts to "Check Duplicates" once this flips back to false (see the setTimeout in
    // onDataDupicateCheckRetrieved).
    isShowingDuplicateResult: boolean;
    // Explicit request for a loading state on the Matter tab's Upload Documents button -
    // dedicated flag rather than the shared isSubmitting (used by several other actions in
    // this drawer, so it would show "Uploading" for unrelated saves too).
    isUploadingMatterDocument: boolean;
    isOverflowMenuOpen: boolean;
    isDeleteConfirmOpen: boolean;
}

// tslint:disable-next-line: no-any
// interface PreviousReferrerState {
//     referrerGuid: string | null;
//     referrerName: string | null;
//     sourceGuid: string | null; // Should match with the source, if we want to re-populate the same old value again
//     sourceNotes?: string;
// }

/*
 * EnquiryFormDrawer - create / edit an enquiry.
 *
 * Where things live
 *   drawers/panels/             one memoised component per Details-tab accordion (contact, organisation, address, assignment ...)
 *   drawers/components/         the other pieces: Activity and Matter tabs, header widgets, custom fields, save button, skeletons
 *   enquiryFormMapping.ts       pure mapping between the loaded enquiry, the form values and the mutation inputs
 *   enquiryFormDrawerStyles.ts  the makeStyles hook for this drawer
 *   enquiryFormDrawerConstants  layout widths, tab field lists, the EnquiryFormTab enum
 *   enquiryInitialValues.ts     default form values for a new enquiry
 *
 * Reading order inside the component: setup -> loaded data -> data loading -> validators -> save -> handlers
 * -> stable callbacks -> render helpers -> layout flags -> render.
 *
 * Performance rule of thumb: the <Form> itself only subscribes to submitting / pristine / errors. Anything that
 * needs form values subscribes to just the ones it reads (PickedFormValues, or a panel's own FormSpy) and
 * handlers read form.getState().values when they fire - nothing re-renders the whole drawer per keystroke.
 */
export const EnquiryFormDrawer: React.FunctionComponent<EnquiryFormProps> = (props) => {
    // ----------------------------------------------------------------------------------------------------
    // Setup: styles, queries and local UI state
    // ----------------------------------------------------------------------------------------------------

    const classes = useStyles();
    // raised each time the form's tour button is pressed (the tour itself is drawn by EnquiryFormTourHost)
    const [tourRequestId, setTourRequestId] = useState(0);

    const countryQuery = useHomeCountry();

    const tenantQuery = useTenant();

    const { t } = useTranslation() as {
        t: (key: keyof TranslationTextList) => string;
    };
    const [isLoading, setIsLoading] = useState(true);
    const [isActivityLoading, setIsActivityLoading] = useState(true);
    const [isCustomFieldLoading, setIsCustomFieldLoading] = useState(true);
    // Explicit request: the Matter column (3rd column, wide layout) had no loading flag at all -
    // it rendered unconditionally with state.generalInfoData, which stays undefined until
    // fetchMatterDetails resolves, so there was nothing covering that gap. Same
    // isActivityLoading/isCustomFieldLoading pattern: starts true, fetchMatterDetails itself
    // flips it false once resolved (success or error) or immediately if there's no matter linked
    // to fetch in the first place - see onDataRetrieved's own call site.
    const [isMatterLoading, setIsMatterLoading] = useState(true);
    const [appUser, setAppUser] = useState<AppUser>();
    const history = useHistory();

    const regionSettings = useRegionSettings();

    // Docks the Create Matter/Client dialogs opened from within this drawer beside a
    // pinned Quick View, same as this drawer itself does via props.anchorOffset.
    const isQuickViewPinned = useIsQuickViewPinned();

    // Explicit bug report: "the enquiry 3 column layout is moving outside the page" once Quick
    // View is docked. Root cause - only QuickViewDrawer.tsx's own usage of this component (the
    // "open a record from Quick View itself" flow) passes anchorOffset, always QUICK_VIEW_WIDTH
    // regardless of pinned state, per that call site's own comment. This component's other ~12
    // callers (the enquiry grid, task boards, etc.) never pass it at all - so opening an enquiry
    // from any of THOSE while Quick View happens to be docked in the background (it survives
    // navigation while pinned) left this Drawer anchored at the bare viewport edge, with no idea
    // Quick View's own QUICK_VIEW_WIDTH is already claimed on the right. Falling back to
    // isQuickViewPinned here (reactive - the hook re-renders on dock/undock) fixes every caller
    // at once instead of updating all ~12 individually, and still defers to an explicit
    // props.anchorOffset when a caller (QuickViewDrawer.tsx) has a reason to pass its own.
    const effectiveAnchorOffset = props.anchorOffset ?? (isQuickViewPinned ? QUICK_VIEW_WIDTH : undefined);

    // Explicit bug report: typing into the AI chat dialog's own compose box (and even
    // drag-selecting its analysis text) silently failed while this Drawer was open. Root cause:
    // AiChatDialog.tsx portals straight to document.body, outside this Drawer's own MUI Modal -
    // MUI's Modal/Drawer keeps a focus trap (Unstable_TrapFocus) that snaps focus back to itself
    // the instant document.activeElement moves outside its own root, since it has no way to know
    // the AI panel is a legitimate, deliberately-non-modal companion surface rather than stray
    // focus loss. disableEnforceFocus/disableAutoFocus only while a maximized AI session exists
    // (regardless of which enquiry it belongs to, since the floating panel can overlap any
    // drawer) - everywhere else this Drawer keeps its normal focus containment.
    //
    // Local state fed by AiChatDialogOpenWatcher below (not a direct useAiDocumentChat() call
    // here) - see that component's own comment for why: this Drawer is huge, and the AI
    // context's value changes on every AI progress tick app-wide, so subscribing directly at
    // this top level made the whole Drawer re-render on every tick, not just when this boolean
    // actually changes.
    const [isAiChatDialogOpen, setIsAiChatDialogOpen] = useState(false);

    const isCreateForm = props.formAction === 'edit' ? false : true;

    // Explicit addition (enquiry prev/next navigation spec): the breadcrumb below only appears once the
    // infoPanel header card has scrolled out from under the sticky headerBar. That scroll state lives in
    // <ShowWhenScrolledPast> (not here) so scrolling does not re-render the whole drawer.
    // Explicit fix (final-fix-wave finding C1): these were plain useRef objects, but the main
    // content tree (including this infoPanel div) sits behind a loading gate that initially
    // renders EnquiryFormDrawerSkeleton instead - so on first mount, infoPanelRef.current was
    // null and the IntersectionObserver effect below bailed out. Since props.isEnquiryFormOpen
    // becomes true on first render and never changes again while open, the effect never re-ran
    // once the real content (and the real ref) actually mounted. Callback-ref state fixes this:
    // the setter itself fires when the DOM node attaches, so the effect can depend on that.
    const [drawerPaperNode, setDrawerPaperNode] = useState<HTMLDivElement | null>(null);
    const [infoPanelNode, setInfoPanelNode] = useState<HTMLDivElement | null>(null);
    const overflowMenuAnchorRef = useRef<HTMLButtonElement | null>(null);

    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);
    // Explicit request: in the 2 and 3 column layouts the main Save is for the Details only and the Follow Up section has its own
    // Save follow-up. The follow-up section's required-field rules therefore apply only once Save follow-up has been pressed
    // (attempted), and never to a press of the main Save (suspended for the length of that click). See followUpFieldValidator.
    const followUpValidationAttemptedRef = useRef(false);
    // true while a follow-up save is on its way to the server (see onSaveFollowUp)
    const isSavingFollowUpRef = useRef(false);
    // true while a Re-Open is on its way to the server (see reOpenEnquiry)
    const isReOpeningRef = useRef(false);
    const followUpValidationSuspendedRef = useRef(false);
    const [snackbar, setSnackbar] = useState<{ open: boolean; message: string | null; severity?: 'success' | 'error' }>({ open: false, message: null });

    const [state, setState] = useState<EnquiryFormState>({
        isFormChanged: false,
        showDiscard: false,
        // showTabsSaveAlert: false,
        tab: EnquiryFormTab.details,
        isEmailNotification: true,
        isCreateClient: false,
        sourceSystem: '',
        homeCountry: '',
        isCreateClientOpen: false,
        isExpandDrawer: false,
        currency: '$',
        // tenantTimezone: null,
        isSendEmailDialogOpen: false,
        hideSendAcknowledgement: true,
        generalInfoData: undefined,
        financials: null,
        isMarkClientMatterCreatedOpen: false,
        matterClientName: '',
        pendingFocusField: null,
        pendingNavigation: null,
        isContactDetailsPanelExpand: isCreateForm,
        isEnquiryDetailsPanelExpand: isCreateForm,
        isDetailedEnquiryNotesPanelExpand: false,
        isDigitalTrackingPanelExpand: false,
        isOrganisationPanelExpand: false,
        isEnquiryValuePanelExpand: false,
        isAssignPanelExpand: false,
        isFormSubmit: false,
        enquiryQuality: null,
        likelihoodToProceed: null,
        isOtherContactDetailsPanelExpand: false,
        isOtherDetailsPanelExpand: false,
        isOther2DetailsPanelExpand: false,
        isClient2PostalAddressPanelExpand: false,
        isPostalAddressPanelExpand: false,
        isOtherSidePostalAddressPanelExpand: false,
        timezone: [],
        isOtherSidePanelExpand: false,
        isBookMeetingFromHistoryActivity: false,
        customFieldByHierarchy: [],
        duplicateCheck: null,
        isDuplicateChecking: false,
        isShowingDuplicateResult: false,
        isUploadingMatterDocument: false,
        isOverflowMenuOpen: false,
        isDeleteConfirmOpen: false,
        // hasDuplicate: 'checking'
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    // The labels of the Details fields that are changed but not saved, while the "they will be lost" warning is up (empty = no warning). The follow-up
    // that is waiting for the answer is kept in the ref, so "Save follow-up anyway" can carry straight on with it.
    const [unsavedDetailsFieldLabels, setUnsavedDetailsFieldLabels] = useState<string[]>([]);
    const pendingFollowUpSaveRef = useRef<{ form: FormApi<any>, values: AnyObject } | null>(null); // tslint:disable-line: no-any

    // Explicit request: on a wide enough window, show Details/Activity/Follow-Up (or Matter)
    // side by side instead of behind separate tabs - purely a layout decision, never on for the
    // create form (isWideLayout below also requires props.guid) since that flow's Activity/
    // Follow-Up/Matter tabs don't apply yet anyway.
    // +40 leaves the same breathing room as the drawer's own capped maxWidth below
    // (min(WIDE_LAYOUT_DRAWER_WIDTH, calc(100vw - 40px))) - without it the drawer would already
    // be clipping its own last column right as this flips true.
    // Explicit bug report: this used to compare against the bare window width, so a docked
    // Quick View (which doesn't fire a resize event - it only shifts <main> over via margin,
    // see AppContent.tsx) left this still reporting "wide enough" even though
    // effectiveAnchorOffset px of that width is no longer available, pushing the 3-column
    // layout's own right edge outside the visible page. Subtracting effectiveAnchorOffset here
    // (and recomputing - not just on resize, but whenever it itself changes, i.e. on dock/
    // undock) makes the 3-column layout drop back to tabs once docked eats into the room it
    // needs, and come back once undocked frees that width again - without needing an actual
    // window resize either way.
    // Explicit request: gated on WIDE_LAYOUT_DRAWER_MIN_WIDTH (assumes the middle column can
    // shrink to its own floor - see that constant's own comment), not the full WIDE_LAYOUT_
    // DRAWER_WIDTH, so 3-column layout stays on in more cases - tabsContentAreaWideMiddleShrink
    // (applied only while Activity is showing in the middle) is what actually does the
    // shrinking at render time; this is just the "is there enough room for the shrunk version
    // at all" gate.
    const [isWideViewport, setIsWideViewport] = useState(
        () => window.innerWidth - (effectiveAnchorOffset ?? 0) >= WIDE_LAYOUT_DRAWER_MIN_WIDTH + 40
    );

    useEffect(() => {
        const recalculateIsWideViewport = () => setIsWideViewport(
            window.innerWidth - (effectiveAnchorOffset ?? 0) >= WIDE_LAYOUT_DRAWER_MIN_WIDTH + 40
        );
        recalculateIsWideViewport();
        window.addEventListener('resize', recalculateIsWideViewport);
        return () => window.removeEventListener('resize', recalculateIsWideViewport);
    // tslint:disable-next-line: align
    }, [effectiveAnchorOffset]);

    // Explicit request: same gating/recompute reasoning as isWideViewport just above, against
    // MEDIUM_LAYOUT_DRAWER_MIN_WIDTH instead - "is there enough room for the 2-column layout's
    // own shrunk-left-column floor". isMediumLayout below only takes effect once isWideLayout
    // is already false, so this doesn't change when 3-column layout itself applies.
    const [isMediumViewport, setIsMediumViewport] = useState(
        () => window.innerWidth - (effectiveAnchorOffset ?? 0) >= MEDIUM_LAYOUT_DRAWER_MIN_WIDTH + 40
    );

    useEffect(() => {
        const recalculateIsMediumViewport = () => setIsMediumViewport(
            window.innerWidth - (effectiveAnchorOffset ?? 0) >= MEDIUM_LAYOUT_DRAWER_MIN_WIDTH + 40
        );
        recalculateIsMediumViewport();
        window.addEventListener('resize', recalculateIsMediumViewport);
        return () => window.removeEventListener('resize', recalculateIsMediumViewport);
    // tslint:disable-next-line: align
    }, [effectiveAnchorOffset]);

    // The firm's canned notes are asked for from the server each time an enquiry opens (network first, kept in the cache), so they are ready by the time
    // the Follow Up notes field's picker is used.
    useEffect(() => {
        if (props.isEnquiryFormOpen) {
            prefetchCannedNotes();
        }
    }, [props.isEnquiryFormOpen]);

    // Explicit addition (enquiry prev/next navigation spec): [ and ] step prev/next through the
    // same guarded handlers the buttons use. Ignored while the user is typing in any input/
    // textarea/select/contenteditable element (covers the mention-enabled rich-text fields too).
    useEffect(() => {
        if (!props.isEnquiryFormOpen || !props.listNavigation) {
            return;
        }
        const handleKeyDown = (event: KeyboardEvent) => {
            const target = event.target as HTMLElement | null;
            const tagName = target?.tagName;
            const isTypingTarget = tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || !!target?.isContentEditable;
            if (isTypingTarget) {
                return;
            }
            if (event.key === '[') {
                onPrevClick();
            } else if (event.key === ']') {
                onNextClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    // Explicit fix (final-fix-wave finding C2): onPrevClick/onNextClick close over
    // state.isFormChanged/state.showDiscard, but neither was in this dependency array, so the
    // attached listener kept calling a stale version of those handlers after the drawer's own
    // state changed (e.g. editing a field after the listener was first attached) - letting [ / ]
    // navigate away without the discard-confirm guard that the button click path already gets
    // (buttons always use the current render's handler). Adding both here recreates the listener
    // (and its closure) whenever either changes.
    // tslint:disable-next-line: align
    }, [props.isEnquiryFormOpen, props.listNavigation, state.isFormChanged, state.showDiscard]);

    // ----------------------------------------------------------------------------------------------------
    // Loaded data
    // ----------------------------------------------------------------------------------------------------

    const [enquiryActionData, setEnquiryActionData] = useState<Actions>();

    const [leadDetailsHistory, setLeadDetailsHistory] = useState<TaskSummaryList>({
        tasks: [],
        actualRowCountForSearch: 0,
        recordCount: 0
    });

    // Used for InitialData and fetching saved enquiry
    const [enquiryDetail, setEnquiryDetails] = useState<EnquiryDetail>({
        guid: props.guid,
        createdDate: moment().toDate(),
        createdByName: '',
        lastUpdated: moment().toDate(),
        isClosed: false,
        isContactCreated: false,
        isMatterCreated: false,
        firstName: '',
        lastName: '',
        email: '',
        gender: 'Unknown',
        initialEnquiryDate: moment().toDate(),
        phone: '',
        mobile: '',
        sourceGuidID: null,
        source: '',
        isSourceReferrer: false,
        officeGuidID: null,
        office: '',
        sourceNotes: '',

        organisation: '',
        positionAtOrganisation: '',

        areaOfLaw: '',
        practiceAreaGuidID: '',
        natureOfEnquiry: '',

        internalNotes: null,
        files: [],

        assignedTo: null,
        assignedToName: null, // Display Name
        assignedToEmailAddress: null,
        assignedBy: null,
        assignedByName: null, // Display Name
        assignedByEmailAddress: null,
        dateAssigned: moment().toDate(),
        followUpDueDate: null,
        assignmentReminderOffset: null,

        followUpActionGuidID: null,
        followUpAction: null,
        followUpActionSystemName: null,
        followUpSystemAction: null,
        followUpDate: null,
        outcomeGuidID: null,
        outcome: null,
        outcomeDate: null,
        outcomeNotes: '',
        reason: null,
        reasonGuidID: null,
        followUpNotes: null,
        isKeyOpportunity: props.isKeyOpportunity,
        referrerGuid: null,
        referrerName: null,
        isReferrerFromDataSource: null,
        nameGuid: null,
        nameTitle: null,
        organisationGuid: null,

        estimatedFees: null,
        isEstimatedFeesIncludesTax: false,
        estimatedDisbursements: null,
        isEstimatedDisbursementsIncludesTax: false,
        enquiryQuality: null,
        likelihoodToProceed: null,
        clientFirstName: null,
        clientLastName: null,
        dOB: null,
        isMarketingConsent: true,
        isTermsAndConditionsApproved: false,
        isPrivacyStatementProvided: false,
        isConflictCheckPerformed: false,
        isNoConflict: false,
        isIdentityCheckPerformed: false,
        addressName: null,
        floor: null,
        number: null,
        street: null,
        clientAddressStreet2: null,
        suburb: null,
        state: null,
        postcode: null,
        country: null,
        pOBoxType: props.pOBoxType ? props.pOBoxType : null,
        pOBox: null,
        postalSuburb: null,
        postalState: null,
        postalPostCode: null,
        postalCountry: null,
        referredToFirmGuid: null,
        referredToFirmName: '',
        notProceedingOutcomeNotes: null,
        clientRelationshipToEnquirer: null,
        matterId: null,
        matterGuid: null,
        matterTitle: null,
        matterFileNumber: null,
        assignedToIsStaff: false,
        assignedToStaffGuid: null,
        assignedToStaffName: null,
        otherPartyFirstName: null,
        otherPartyLastName: null,
        otherPartyNotes: null,
        otherPartyEmail: null,
        otherPartyPhone: null,
        otherPartyMobile: null,
        otherPartyOrganisation: null,
        enquiryNotes: null,
        integrationContactId: null,
        integrationClientId: null,
        integrationOtherPartyId: null,
        integrationMatterId: null,
        tempIntegrationMatterId: null,
        integrationMatterDocumentId: null,
        otherPartyDOB: null,
        otherPartyAddressName: null,
        otherPartyFloor: null,
        otherPartyNumber: null,
        otherPartyStreet: null,
        otherPartyStreet2: null,
        otherPartySuburb: null,
        otherPartyState: null,
        otherPartyPostcode: null,
        otherPartyCountry: null,

        otherPartyPOBoxType: props.pOBoxType ? props.pOBoxType : null,
        otherPartyPOBox: null,
        otherPartyPostalSuburb: null,
        otherPartyPostalState: null,
        otherPartyPostalPostCode: null,
        otherPartyPostalCountry: null,
        otherPartyNameGuid: null,
        otherPartyOrganisationGuid: null,

        isRiskAssessed: null,
        riskLevelGuid: null,
        riskLevel: null,
        riskNotes: null,

        secondClientFirstName: null,
        secondClientLastName: null,
        secondClientRelationshipToEnquirer: null,
        secondClientGender: 'Unknown',
        secondClientSuburb: null,
        secondClientState: null,
        secondClientPostCode: null,
        secondClientIsMarketingConsent: true,
        secondClientIsTermsAndConditionsApproved: false,
        secondClientIsPrivacyStatementProvided: false,
        secondClientIsConflictCheckPerformed: false,
        secondClientIsIdentityCheckPerformed: false,
        secondClientIsNoConflict: false,
        secondClientCountry: null,
        secondClientAddressName: null,
        secondClientFloor: null,
        secondClientNumber: null,
        secondClientStreet1: null,
        secondClientStreet2: null,
        secondClientDOB: null,
        secondClientPOBoxType: props.pOBoxType ? props.pOBoxType : null,
        secondClientPOBox: null,
        secondClientPostalSuburb: null,
        secondClientPostalState: null,
        secondClientPostalPostCode: null,
        secondClientPostalCountry: null,
        secondClientGuid: null,

        responseText: null,

        eventAndCampaignGuid: null,
        eventAndCampaignName: null,
        eventAndCampaignNotes: null,
        eventAndCampaignNotesGuid: null,

        isNameFromDataSource: null,
        isOrganisationFromDataSource: null,
        isOtherSideFromDataSource: null,
        isSecondClientFromDataSource: null,

        // new fields
        title: null,
        otherPartyTitle: null,

        clientTitle: null,
        clientGuid: null,
        clientEmail: null,
        clientPhone: null,
        clientMobile: null,

        secondClientTitle: null,
        secondClientEmail: null,
        secondClientPhone: null,
        secondClientMobile: null,

        customFields: [],

        clickThroughUrl: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmContent: null,
        utmKeyword: null,
        googleClickIdentifier: null,
        facebookClickIdentifier: null,
        
        assignedToStaffSourceId: null,
        clientSourceId: null,
        nameSourceId: null,
        otherPartySourceId: null,
        secondClientSourceId: null,
        organisationSourceId: null,
        
        assignedToAttribute: null,
    });

    // Explicit addition (enquiry prev/next navigation spec): scoped to the real edit case only -
    // "New Enquiry" (isCreateForm) is left untouched, not in the spec. Captures whatever title
    // was there before (not a hardcoded "RedView Web") and restores exactly that on close/unmount,
    // so this stays correct even if the app's own base title changes later.
    useEffect(() => {
        if (isCreateForm || !props.isEnquiryFormOpen || !enquiryDetail?.firstName) {
            return;
        }
        const previousTitle = document.title;
        const fullName = enquiryDetail.lastName ? `${enquiryDetail.firstName} ${enquiryDetail.lastName}` : enquiryDetail.firstName;
        document.title = `${fullName} · Enquiry`;
        return () => {
            document.title = previousTitle;
        };
    // tslint:disable-next-line: align
    }, [isCreateForm, props.isEnquiryFormOpen, enquiryDetail?.firstName, enquiryDetail?.lastName]);

    const getReminderValue = (isAssignment: boolean) => {
        if (isAssignment && enquiryDetail && enquiryDetail.assignmentReminderOffset) {
            return { label: enquiryDetail.assignmentReminderOffset, value: enquiryDetail.assignmentReminderOffset };
        } else if (props.enquiryDefaultConfig && props.enquiryDefaultConfig.reminder) {
            return { label: props.enquiryDefaultConfig.reminder, value: props.enquiryDefaultConfig.reminder };
        } else {
            return { label: 'None', value: 'None' };
        }
    };

    // ----------------------------------------------------------------------------------------------------
    // Data loading (fetches and their on-retrieved handlers)
    // ----------------------------------------------------------------------------------------------------

    const onGetCustomFields = (input: CustomFieldByHierarchyQueryParams, form?: FormApi<Enquiry>) => {

        setIsCustomFieldLoading(true);

        const params: CustomFieldByHierarchyQueryParams = {
            ...input
        };

        retrieveQueryData<CustomFieldByHierarchyQueryParams, CustomFieldByHierarchyData>(
            CustomFieldByHierarchyQuery,
            params,
            false,
            (data) => onDataGetCustomFieldsRetrieved(data, form),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
                setIsLoading(false);
            }
        );
    };

    const onDataGetCustomFieldsRetrieved = (data: CustomFieldByHierarchyData, form?: FormApi<Enquiry>) => {
        const { customFieldByHierarchy } = data.crm

        setState((prevState) => {
            return {
                ...prevState,
                customFieldByHierarchy: customFieldByHierarchy,
                // Explicit bug report: switching to an area of law with no custom field groups
                // configured removes the Further Details tab/column entirely (see
                // isFurtherDetailsAvailable), but nothing here ever moved prevState.tab off of
                // it - so a user who had Further Details selected landed on a tab/column that no
                // longer exists, reading as "switched to Activity but it's empty" (wide layout's
                // own heading falls back to showing Activity as selected once Further Details
                // disappears, while the actual content was still gated on the stale tab value).
                tab: (customFieldByHierarchy.length === 0 && prevState.tab === EnquiryFormTab.customFields)
                    ? EnquiryFormTab.activity
                    : prevState.tab,
            };
        });

        setIsCustomFieldLoading(false);
    };

    useEffect(() => {
        checkEmailTemplateCount(null);
        fetchCurrency();
        // tslint:disable-next-line: align
    }, []);

    useEffect(() => {
        // - Ran only once
        // If we recieve a guid, then fetch EnquiryDetail
        if (props.guid) {
            setIsLoading(true);
            setIsActivityLoading(true);
            fetchAppUserOnEffect();
            fetchEnquiryDetails(props.guid);
            fetchTenantDataOnEffect();
            fetchHomeCountryOnEffect();
            // fetchTenantTimezone();
            fetchTimezone();
            fetchLeadDetailsHistory(props.guid);
        } else {
            setIsLoading(false);
            setIsActivityLoading(false);
        }
        // tslint:disable-next-line: align
    }, [props.isRefreshData, props.guid]);

    const shouldExecuteQuery =
        props.nameSummary ||
            (props.eventAndCampaignAttendeeSummary && (props.eventAndCampaignAttendeeSummary.entityTypeId === 0 || props.eventAndCampaignAttendeeSummary.entityTypeId === 2)) ||
            props.partyDetails
            ? true
            : false;

    const partyAddressesQuery = useQuery<PartyAddressesData, PartyAddressesParams>(PartyAddressesQuery, {
        variables: {
            ...(props.nameSummary && {
                nameId: props.nameSummary.nameId,
                isFromDataSource: props.nameSummary.isFromDataSource
            }) as PartyAddressesParams,
            ...(props.eventAndCampaignAttendeeSummary && {
                nameId: (props.eventAndCampaignAttendeeSummary as EventAndCampaignAttendeeSummary).nameId,
                isFromDataSource: (props.eventAndCampaignAttendeeSummary as EventAndCampaignAttendeeSummary).entityTypeId === 0
            }) as PartyAddressesParams,
            ...(props.partyDetails && {
                nameId: props.partyDetails.id,
                isFromDataSource: props.partyDetails.isFromDataSource
            }) as PartyAddressesParams
        },
        skip: !shouldExecuteQuery
    });

    // Form's State
    const initialValues: Enquiry = buildEnquiryInitialValues(props, partyAddressesQuery, getReminderValue);

    const fetchMatterDetails = (id: number) => {
        setIsMatterLoading(true);

        const generalInfoDataParams: GeneralInfoDataParams = {
            id: id
        };

        retrieveGeneralInfoData(
            generalInfoDataParams,
            true,
            (data: GeneralInfoData) => handleMatterDetailsFetch(data),
            // tslint:disable-next-line: no-any
            (reason: any) => {
                setIsMatterLoading(false);
                showNotification('Failed to Fetch App User Settings', reason, 'error');
            }
        );
    };

    const handleMatterDetailsFetch = (data: GeneralInfoData) => {
        const generalData: CustomTableContentProps[] = Object
            .entries(data.matter)
            .filter(([_, v]) => v != null && v !== undefined && v.length > 0)
            // tslint:disable-next-line: no-any
            .map((matter: any, index) => {

                let name = matter[0];
                let value = matter[1];
                let type = ValueTypeEnum.STRING;
                let hide = true;
                let order = index;

                if (matter[0] === 'id') {
                    name = 'Id';
                }
                if (matter[0] === 'matterCategory') {
                    name = 'Category';
                    hide = false;
                    order = 2;
                }
                if (matter[0] === 'country') {
                    name = 'Country';
                }
                if (matter[0] === 'family') {
                    name = 'Family';
                }
                if (matter[0] === 'fileLocation') {
                    name = 'Location';
                }
                if (matter[0] === 'fileNumber') {
                    name = 'File Number';
                }
                if (matter[0] === 'firbStatus') {
                    name = 'Status';
                }
                if (matter[0] === 'lastUpdate') {
                    name = 'Last Update';
                    type = ValueTypeEnum.DATE;
                }
                if (matter[0] === 'matterType') {
                    name = 'Matter Type';
                    hide = false;
                    order = 3;
                }
                if (matter[0] === 'property') {
                    name = 'Property';
                }
                if (matter[0] === 'propertyLabel') {
                    name = 'Property Label';
                }
                if (matter[0] === 'stage') {
                    name = 'Stage';
                }
                if (matter[0] === 'state') {
                    name = 'State';
                }
                if (matter[0] === 'status') {
                    name = 'Status';
                    hide = false;
                    order = 1;
                }
                if (matter[0] === 'description') {
                    name = 'Description';
                }
                if (name === 'title') {
                    name = 'Title';
                    hide = false;
                    order = 0;
                }
                if (name === 'images') {
                    name = 'Images';
                    // tslint:disable-next-line: no-any
                    value = matter[1].image.map((image: any) => image.location);
                    type = ValueTypeEnum.ARRAY_OF_IMAGE;
                }

                return {
                    client: {
                        value: name,
                        type: ValueTypeEnum.STRING
                    },
                    company: {
                        value: value,
                        type: type
                    },
                    hide: hide,
                    order: order
                };
            }); // .filter(a => a.items[0].value !== null && a.name !== 'id' && a.name !== '__typename');

        setState((prevState) => {
            return {
                ...prevState,
                generalInfoData: generalData,
                financials: data.matter.financials,
                matterClientName: data.matter.client
            };
        });

        setIsMatterLoading(false);
    };

    const fetchAppUserOnEffect = () => {
        fetchAppUserData(
            false,
            (data: AppUserData) => {
                handleAppUserFetch(data);
            },
            (reason) => {
                showNotification('Failed to Fetch App User Settings', reason, 'error');
            }
        );
    };

    const handleAppUserFetch = (data?: AppUserData) => {
        if (
            data !== null &&
            data?.appUser !== undefined &&
            data.appUser.isAdministrator !== undefined
        ) {
            setAppUser((prevAppUser) => {
                // Object.assign would also work
                return {
                    ...prevAppUser,
                    userId: data.appUser.userId,
                    name: data.appUser.name,
                    isAdministrator: data.appUser.isAdministrator,
                    userName: data.appUser.userName
                };
            });
        }
    };

    const fetchCurrency = () => {
        retrieveCurrencySymbolData(
            false,
            // tslint:disable-next-line: no-any
            (data: any) => onDataCurrency(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            });
    };

    const onDataCurrency = (data: CurrencySymbolData) => {
        setState((prevState) => {
            return {
                ...prevState,
                currency: data.options.currencySymbol.symbol
            };
        });
    };

    // const fetchTenantTimezone = () => {
    //     fetchTenantTimezoneData(
    //         false,
    //         // tslint:disable-next-line: no-any
    //         (data: any) => onDataTenantTimezone(data),
    //         // tslint:disable-next-line:no-any
    //         function (reason: any): void {
    //             showNotification(null, reason, 'error');
    //         });
    // };

    // const onDataTenantTimezone = (data: RegionSettingsData) => {
    //     setState((prevState) => {
    //         return {
    //             ...prevState,
    //             tenantTimezone: {
    //                 value: data.settings.systems.regionSettings.config.timeZone,
    //                 label: data.settings.systems.regionSettings.config.timeZoneDescription,
    //                 secondaryValue: data.settings.systems.regionSettings.config.baseUtcOffset
    //             }
    //         };
    //     });
    // };

    const fetchTimezone = () => {
        retrieveTimezoneOptionData(
            false,
            // tslint:disable-next-line: no-console
            (data) => onRetrieveTimezoneData(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onRetrieveTimezoneData = (data: TimezoneOptionData) => {
        setState((prevState) => {
            return {
                ...prevState,
                timezone: data.options.timezoneOption
            };
        });
    };

    const fetchLeadDetailsHistory = (guid: string) => {
        var leadQueryParams: LeadDetailsHistoryQueryParams = {
            offset: null,
            first: null,
            filter: null,
            sortColumn: 'DueDate',
            sortDirection: 'ASC',
            entityGuidID: guid
        };

        retrieveLeadDetailsHistoryData(
            leadQueryParams,
            true,
            // tslint:disable-next-line: no-any
            (data: any) => onEnquiryHistoryDataRetrieved(data),
            // tslint:disable-next-line
            function (reason: any): void {
                showNotification(null, reason, 'error');
                setIsActivityLoading(false);
            }
        );
    };

    const onEnquiryHistoryDataRetrieved = (data: LeadDetailsHistoryData) => {
        // This runs from a promise, where React 17 does not batch updates: the history, the loading flag and the
        // Create Client / Re-Open buttons (state.isCreateClient below) would each render on their own, so the column
        // showed the timeline first and the buttons a moment later. Batched, they arrive together.
        unstable_batchedUpdates(() => {
            setLeadDetailsHistory(data.task.summaryList);
            setIsActivityLoading(false);

            const summaryList = data.task.summaryList;

            // const task = summaryList.tasks[summaryList.tasks.length - 1];
            const createClientTask = summaryList.tasks.find((task: TaskDetails) => {
                return (task.taskTypeDescription.toLowerCase() === 'create client' || task.taskTypeDescription.toLowerCase() === 'create matter')
                    && task.taskStatusDescription.toLowerCase() === 'not started';
            });

            let isCreateClient = false;
            if (createClientTask) {
                isCreateClient = true;
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    isCreateClient: isCreateClient
                };
            });
        });
    };

    const onGetPartyAddresses = (form: FormApi<Enquiry>, values: AnyObject, selection: IndividualNameSummary, name: string) => {

        const params: PartyAddressesParams = {
            nameId: selection.nameId,
            isFromDataSource: selection.isFromDataSource
        };

        retrieveQueryData<PartyAddressesParams, PartyAddressesData>(
            PartyAddressesQuery,
            params,
            false,
            (data) => onDataPartyAddressesRetrieved(data, form, values, name),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
                setIsLoading(false);
            }
        );
    };

    const onDataPartyAddressesRetrieved = (data: PartyAddressesData, form: FormApi<Enquiry>, values: AnyObject, name: string) => {

        if (data && data.party.addresses.address.length === 0) {

            if (name === 'individualSelector' || name === 'clientIndividualSelector') {

                form.change('addressName', null);
                form.change('floor', null);
                form.change('number', null);
                form.change('street', null);
                // form.change('street2', street2);
                form.change('suburb', null);
                form.change('state', null);
                form.change('postcode', null);
                form.change('country', null);

            }

            if (name === 'secondClientIndividualSelector') {

                form.change('secondClientAddressName', null);
                form.change('secondClientFloor', null);
                form.change('secondClientNumber', null);
                form.change('secondClientStreet1', null);
                // form.change('secondClientStreet2', null);
                form.change('secondClientSuburb', null);
                form.change('secondClientState', null);
                form.change('secondClientPostCode', null);
                form.change('secondClientCountry', null);

            }

            if (name === 'otherPartyIndividualSelector') {
                form.change('otherPartyAddressName', null);
                form.change('otherPartyFloor', null);
                form.change('otherPartyNumber', null);
                form.change('otherPartyStreet', null);
                form.change('otherPartySuburb', null);
                form.change('otherPartyState', null);
                form.change('otherPartyPostcode', null);
                form.change('otherPartyCountry', null);
            }
        } else {

            const addresses = getFirstAddressOfEachType(data);

            addresses.forEach((address) => {
                // tslint:disable-next-line: no-shadow-variable
                const { addressType, country, floor, name: buildingName, number: buildingNumber, postcode, state: addressState, street, suburb } = address;

                if (addressType === 'Street') {

                    if (name === 'individualSelector' || name === 'clientIndividualSelector') {

                        form.change('addressName', buildingName);
                        form.change('floor', floor);
                        form.change('number', buildingNumber);
                        form.change('street', street);
                        // form.change('street2', street2);
                        form.change('suburb', suburb);
                        form.change('state', addressState);
                        form.change('postcode', postcode);
                        form.change('country', country);
                    }

                    if (name === 'secondClientIndividualSelector') {
                        form.change('secondClientAddressName', buildingName);
                        form.change('secondClientFloor', floor);
                        form.change('secondClientNumber', buildingNumber);
                        form.change('secondClientStreet1', street);
                        // form.change('secondClientStreet2', street2);
                        form.change('secondClientSuburb', suburb);
                        form.change('secondClientState', addressState);
                        form.change('secondClientPostCode', postcode);
                        form.change('secondClientCountry', country);
                    }

                    if (name === 'otherPartyIndividualSelector') {
                        form.change('otherPartyAddressName', buildingName);
                        form.change('otherPartyFloor', floor);
                        form.change('otherPartyNumber', buildingNumber);
                        form.change('otherPartyStreet', street);
                        form.change('otherPartySuburb', suburb);
                        form.change('otherPartyState', addressState);
                        form.change('otherPartyPostcode', postcode);
                        form.change('otherPartyCountry', country);
                    }
                }

                if (addressType === 'POBox') {

                    if (name === 'individualSelector') {
                        // form.change('pOBoxType', null);
                        form.change('pOBox', buildingNumber);
                        form.change('postalSuburb', suburb);
                        form.change('postalState', addressState);
                        form.change('postalPostCode', postcode);
                        form.change('postalCountry', country);
                    }

                    if (name === 'otherPartyIndividualSelector') {
                        form.change('otherPartyPOBox', buildingNumber);
                        form.change('otherPartyPostalSuburb', suburb);
                        form.change('otherPartyPostalState', addressState);
                        form.change('otherPartyPostalPostCode', postcode);
                        form.change('otherPartyPostalCountry', country);
                    }
                }
            });
        }
    };

    const fetchEnquiryDetails = (guid: string) => {
        var enquiryQueryParams: EnquiryDetailsQueryParams = {
            guid: guid,
        };

        retrieveEnquiryDetailsData(
            enquiryQueryParams,
            true,
            (data) => onDataRetrieved(data),
            // tslint:disable-next-line
            function (reason: any): void {
                showNotification(null, reason, 'error');
                setIsLoading(false);
                setIsActivityLoading(false);
            }
        );
    };

    const checkEmailTemplateCount = (areaOfLaw: string | null, form?: FormApi<Enquiry>) => {
        var emailTemplateCountQueryParams: EmailTemplateCountQueryParams = {
            emailType: EmailTemplateTypeEnum[EmailTemplateTypeEnum.NEW_ENQUIRY_RESPONSE],
            areaOfLaw: areaOfLaw === null ? '' : areaOfLaw,
        };

        retrieveEmailTemplateCount(
            emailTemplateCountQueryParams,
            true,
            (data) => onDataEmailTemplateCountRetrieved(data, form),
            // tslint:disable-next-line
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onDataEmailTemplateCountRetrieved = (data: EmailTemplateData, form?: FormApi<Enquiry>) => {
        if (data && data.templates && data.templates.emailTemplateCount
            && data.templates.emailTemplateCount.count !== undefined) {

            if (form) {
                let isSentAcknowledgementEmailOldValue = form.getFieldState('isSentAcknowledgementEmail')?.value;
                let isSentAcknowledgementEmailNewValue = false;

                if (isSentAcknowledgementEmailOldValue === true) {
                    if (data.templates.emailTemplateCount.count > 0) {
                        isSentAcknowledgementEmailNewValue = true;
                    } else {
                        isSentAcknowledgementEmailNewValue = false;
                    }
                }

                // If the value was ticked, and if we don't have any templates now, then untick it.
                form.batch(() => {
                    form.change('isSentAcknowledgementEmail', isSentAcknowledgementEmailNewValue);
                });
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    hideSendAcknowledgement: data.templates.emailTemplateCount.count > 0 ? false : true
                };
            });
        }
    };

    const onDataRetrieved = (data: EnquiryData) => {

        onGetCustomFields({
            customFieldGroupGuid: null,
            areaOfLawGuid: data.enquiry.detail.practiceAreaGuidID,
            // locationGuid: data.enquiry.detail.officeGuidID ? data.enquiry.detail.officeGuidID : null,
        });

        const detail = data.enquiry.detail;

        // tslint:disable-next-line: no-console
        // console.log('Other details', detail);

        setEnquiryDetails(data.enquiry.detail);

        checkEmailTemplateCount(data.enquiry.detail.areaOfLaw);

        setState((prevState) => {
            return {
                ...prevState,
                isFormChanged: false,
                tab: detail.assignedTo && detail.assignedToName ? EnquiryFormTab.activity : EnquiryFormTab.details
            };
        });

        if (data.enquiry.actions) {
            setEnquiryActionData(data.enquiry.actions);
        }

        if (detail.matterId !== null && detail.matterId !== 0) {
            fetchMatterDetails(detail.matterId);
        } else {
            // No matter linked yet - nothing for isMatterLoading to wait on, so the Matter
            // column should show its real "no matter" state immediately rather than stay on
            // a skeleton that would otherwise never resolve.
            setIsMatterLoading(false);
        }

        // setKey('' + data.enquiry.detail.guid);

        setIsLoading(false);
    };

    const fetchTenantDataOnEffect = () => {
        fetchTenantData(
            false,
            (data: TenantData) => {
                handleTenantDataFetch(data);
            },
            (reason) => {
                showNotification('Failed to Fetch Tenant Data', reason, 'error');
            }
        );
    };

    const handleTenantDataFetch = (tenantsData?: TenantData) => {
        if (
            tenantsData !== null &&
            tenantsData?.tenant !== undefined &&
            tenantsData.tenant.sourceSystem !== undefined
        ) {
            setState((prevState) => {
                return {
                    ...prevState,
                    sourceSystem: tenantsData.tenant.sourceSystem
                };
            });
        }
    };

    const fetchHomeCountryOnEffect = () => {
        fetchHomeCountry(
            false,
            (data: OptionData) => {
                handleHomeCountryFetch(data);
            },
            (reason) => {
                showNotification('Failed to Fetch Home Country Settings', reason, 'error');
            }
        );
    };

    const handleHomeCountryFetch = (optionData?: OptionData) => {
        if (
            optionData !== null &&
            optionData?.options !== undefined &&
            optionData.options.homeCountry !== undefined
        ) {
            setState((prevState) => {
                return {
                    ...prevState,
                    homeCountry: optionData.options.homeCountry.stringValue === null ? 'au' : optionData.options.homeCountry.stringValue,
                };
            });
        }
    };

    // ----------------------------------------------------------------------------------------------------
    // Validators
    // ----------------------------------------------------------------------------------------------------

    // tslint:disable-next-line: no-any
    const required = (value: any) => {
        return value ? undefined : 'Required';
    };

    // tslint:disable-next-line: no-any
    const requiredDateValidator = (value: any) => {
        if (value) {
            // check for a valid date and check for sql's min date
            var date = moment(value);

            if (date.isValid() && date.year() >= 1753) {
                return undefined;
            } else {
                return 'Incorrect Date';
            }
        } else {
            return 'Required';
        }
    };

    // tslint:disable-next-line: no-any
    const dateValidator = (value: any) => {
        if (value) {
            // check for a valid date and check for sql's min date
            var date = moment(value);

            if (date.isValid() && date.year() >= 1753) {
                return undefined;
            } else {
                return 'Incorrect Date';
            }
        }

        return undefined;
    };

    // tslint:disable-next-line: no-any
    const birthDateValidator = (value: any) => {
        if (value) {
            // check for a valid date and check for sql's min date
            var date = moment(value);

            if (date.isValid() && date.year() >= 1753 && date.toDate() <= moment().toDate()) {
                return undefined;
            } else {
                return 'Incorrect Date';
            }
        }

        return undefined;
    };

    // tslint:disable-next-line
    const emailRegex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // tslint:disable-next-line: no-any
    const EmailValidateWithRequiredNew = (value: any) => {
        let error: string = '';

        if (value === undefined || value === null) {
            return value ? '' : 'One of Email/Telephone/Mobile are required'; // 'Email is required';
        } else if (value.length === 0) {
            return value ? '' : 'One of Email/Telephone/Mobile are required'; // 'Email is required';
        } else if (!emailRegex.test(value)) {
            error = 'Email is not valid';
        }
        return error;
    };

     const ValidateEmail = (value: any) => {
        let error: string = '';

        if (value === undefined || value === null) {
            return value ? '' : 'Email is required';
        } else if (value.length === 0) {
            return value ? '' : 'Email is required';
        } else if (!emailRegex.test(value)) {
            error = 'Email is not valid';
        }
        return error;
    };

    // ----------------------------------------------------------------------------------------------------
    // Small helpers (current tab, PO box rules)
    // ----------------------------------------------------------------------------------------------------

    const isTabActivity = () => {
        return state.tab === EnquiryFormTab.activity;
    };

    const isTabMatter = () => {
        return state.tab === EnquiryFormTab.matterDetails;
    };

    // tslint:disable-next-line: no-any
    const isPoBoxRequired = (values: any) => {
        if (values.postalSuburb || values.postalState || values.postalPostCode || values.postalCountry) {
            return true;
        }
        return false;
    };

    // tslint:disable-next-line: no-any
    const isSecondClientPoBoxRequired = (values: any) => {
        if (values.secondClientPostalSuburb || values.secondClientPostalState || values.secondClientPostalPostCode || values.secondClientPostalCountry) {
            return true;
        }
        return false;
    };

    // tslint:disable-next-line: no-any
    const isOtherPartyPoBoxRequired = (values: any) => {
        if (values.otherPartyPostalSuburb || values.otherPartyPostalState || values.otherPartyPostalPostCode || values.otherPartyPostalCountry) {
            return true;
        }
        return false;
    };

    // ----------------------------------------------------------------------------------------------------
    // Save: create / update / follow-up / link matter
    // ----------------------------------------------------------------------------------------------------

    // tslint:disable-next-line: no-any
    const onSubmit = (form: FormApi<Enquiry>, values: any, errors?: SubmissionErrors) => {
        setIsSubmitting(true);

        // Check if we have new Files
        const newFiles = values.files.filter((documentFile: DocumentFile) => {
            return documentFile.status === 1;
        });

        // tslint:disable-next-line: no-console
        // console.log('On Submit New Files', newFiles);

        if (newFiles.length > 0) {
            setIsLoading(true);
        }

        if (values.handleCreateAndClose) {
            createEnquiry(form, values);
        } else if (values.handleCreateAndNew) {
            createEnquiry(form, values);
        } else {

            // update enquiry details
            if (isTabMatter()) {
                if (!values.matterSelector) {
                    unlinkMatter(form, values);
                } else {
                    linkMatter(form, values);
                }
                // Explicit fix: wide layout's Follow Up panel now saves itself directly
                // (onSaveFollowUp, bypassing this dispatch entirely) - so the shared Save
                // button only ever means "save Details" there, instead of guessing from
                // state.tab (the middle column's own Activity/Further Details toggle, which
                // has no relationship to the always-visible Details column in wide layout).
                // Narrow layout keeps today's exact tab-based behaviour, unchanged.
            } else if (isWideLayout || isMediumLayout || !isTabActivity()) {

                const existingEnquiryDetails = getEnquiryDetails(false);

                const updatedValues = updatedDiff(existingEnquiryDetails, values);

                updateEnquiry(form, values, JSON.stringify(updatedValues));

            } else {

                if (values.followUpSystemAction === 'BookMeeting') {
                    saveBookMetting(form, values);
                } else {
                    saveFollowUp(form, values);
                }
            }
        }

        if (values.followUpBotUrl && values.followUpSystemAction === 'CallForm') {
            window.open(`${values.followUpBotUrl}`, '_blank');
        }
    };

    // tslint:disable-next-line: no-any
    const saveBookMetting = (form: FormApi<any>, values: AnyObject) => {

        let startDate = values.startTime === null ? moment() : moment(values.startTime);
        let endDate = values.endTime === null ? moment() : moment(values.endTime);

        let startDateValue = values.startTime === null ? moment().toDate() : moment(values.startTime).toDate();
        let endDateValue = values.endTime === null ? moment().toDate() : moment(values.endTime).toDate();

        // If UI timezone is different from location's timezone, then add the offset difference to start and end time.
        // let locationUtcOffset = values.officeLocation.baseUtcOffset;
        let selectedTimezoneUtcOffset = values.timezone.secondaryValue;
        let uiUtcOffset = new Date().getTimezoneOffset() * -1; // comparing with UI's offset because the graphql will convert to UTC based on the UI timezone

        if (selectedTimezoneUtcOffset !== uiUtcOffset && selectedTimezoneUtcOffset > 0) {
            let difference = uiUtcOffset - selectedTimezoneUtcOffset;
            startDateValue = moment(startDate).add(difference, 'minutes').toDate();
            endDateValue = moment(endDate).add(difference, 'minutes').toDate();
        }

        var isAssignedToTeam = (values.staff ? values.staff.entityType : 0) === 6;

        // book meeting
        return client.mutate({
            mutation: CreateMeetingBookingTaskMutation,
            variables: {
                input: {
                    enquiryGuid: props.guid ? props.guid : null,
                    assignedTo: isAssignedToTeam ? (values.staff ? values.staff!.value : null) : values.assignedTo, // Set it to the existing assigned to value // (appUser ? appUser!.userId : null),
                    followUpAction: values.followUpAction,
                    followUpActionSystemName: values.followUpActionSystemName,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    isAllDay: values.isAllDay,
                    location: values.officeLocation ? values.officeLocation!.label : null,
                    feeApplicable: values.feeApplicable ? values.feeApplicable : null,
                    sendConfirmation: values.isSendConfirmation,
                    staff: values.staff ? values.staff!.value : null,
                    staffEntityType: values.staff ? values.staff.entityType : null,
                    meetingNotes: values.meetingNotes ? values.meetingNotes : null,
                    timezone: values.timezone ? values.timezone!.value : null,
                    ...(UserFeature.HasAccess(UserFeatureEnum.hasMeetingBookingReminder) && values.staff && values.staff.entityType !== EntityTypeEnum.TEAM && {
                        meetingReminderOffset: values.periodMeetingDefaultReminder ? values.periodMeetingDefaultReminder.value : null,
                        isEmail: values.isSendMeetingDefaultReminderEmail,
                        isSms: values.isSendMeetingDefaultReminderSms
                    })
                }
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any; }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        // setIsSubmitting(false);
                        // Explicit request: medium layout's own Follow Up panel is the same
                        // independent, always-visible area wide layout already has (see
                        // tabsContentAreaMedium's own comment) - resets just its own fields here
                        // too, instead of narrow layout's full-form reset.
                        if (isWideLayout || isMediumLayout) {
                            resetFollowUpFields(form);
                        } else {
                            onReset(form, values);
                        }
                    } else {
                        showNotification('Failed to Save Follow up', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Save Follow up', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const saveFollowUp = (form: FormApi<Enquiry>, values: Enquiry) => {
        // Save the File
        return client.mutate({
            mutation: FollowUpEnquiryMutation,
            variables: {
                input: getFollowUpEnquiryInput(values)
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any; }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        // setIsSubmitting(false);
                        // Explicit request: medium layout's own Follow Up panel is the same
                        // independent, always-visible area wide layout already has (see
                        // tabsContentAreaMedium's own comment) - resets just its own fields here
                        // too, instead of narrow layout's full-form reset.
                        if (isWideLayout || isMediumLayout) {
                            resetFollowUpFields(form);
                        } else {
                            onReset(form, values);
                        }

                    } else {
                        showNotification('Failed to Save Follow up', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Save Follow up', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const linkMatter = (form: FormApi<Enquiry>, values: Enquiry) => {

        client.mutate({
            mutation: LinkEnquiryMutation,
            variables: {
                input: getLinkMatterEnquiryInput(values)
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any; }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        // setIsSubmitting(false);

                        onReset(form, values);

                    } else {
                        showNotification('Failed to Link Matter', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Link Matter', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const createEnquiry = (form: FormApi<Enquiry>, values: Enquiry) => {
        // Save the File
        client
            .mutate({
                mutation: CreateEnquiryMutation,
                variables: {
                    input: getCreateEnquiryInput(values)
                },
            })
            // tslint:disable-next-line: no-any
            .then((results: { data: any }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // move into subscription success
                        if (values.handleCreateAndNew) {
                            // tslint:disable-next-line: no-console
                            // console.log('handleCreateAndNew', values.handleCreateAndNew, 'reset');
                            // tslint:disable-next-line
                            // var link = document.getElementById('resetButton');
                            // if (link !== null) {
                            //     link.click();
                            // }
                            onReset(form, values);
                        } else {
                            setIsSubmitting(false);
                            closePanel(form, values, true);
                        }
                    } else {
                        showNotification('Failed to Save Enquiry', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Save Enquiry', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const updateEnquiry = (form: FormApi<Enquiry>, values: Enquiry, updatedValues: string) => {
        // Save the File
        var mutationInput = getUpdateEnquiryInput(values, updatedValues);

        client
            .mutate({
                mutation: UpdateEnquiryMutation,
                variables: {
                    input: mutationInput
                },
            })
            // tslint:disable-next-line: no-any
            .then((results: { data: any }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        // onReset(form, values);
                        setIsSubmitting(false);
                        // setState((prevState) => {
                        //     return {
                        //         ...prevState,
                        //         showTabsSaveAlert: false
                        //     };
                        // });

                        form.change('tabEdited', undefined);

                        // The form never re-reads its initial values (initialValuesEqual), so after a save it stayed "changed" and Save stayed
                        // enabled - it could be pressed again and again, re-sending the same update. What was just saved becomes the form's
                        // baseline instead: Save is disabled again until something else changes (keepDirtyOnReinitialize keeps anything the
                        // user typed while the save was in flight as a change).
                        // The follow-up panel saves on its own button, so its fields keep their previous baseline (still "changed" if they were typed in).
                        const savedBaseline: AnyObject = { ...values, tabEdited: undefined };
                        const previousBaseline = form.getState().initialValues as AnyObject;
                        getActivitiesTabFields().forEach((field) => {
                            savedBaseline[field] = previousBaseline ? previousBaseline[field] : undefined;
                        });
                        form.initialize(savedBaseline as Enquiry);
                        setState((prevState) => ({ ...prevState, isFormChanged: false }));

                        // onReset(form, values);
                    } else {
                        showNotification('Failed to Save Enquiry', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Save Enquiry', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const getCreateEnquiryInput = (values: Enquiry) => createEnquiryInput(values, state.isEmailNotification);

    const getUpdateEnquiryInput = (values: Enquiry, updatedValues: string) => updateEnquiryInput(values, updatedValues, state.isEmailNotification);

    // ----------------------------------------------------------------------------------------------------
    // Field change handlers
    // ----------------------------------------------------------------------------------------------------

    const onSelectionChange = (form: FormApi<Enquiry>, selection: IAreaOfLawAutoCompleteItem, name: string, values: AnyObject) => {
        if (name === 'areaOfLaw') {
            form.batch(() => {

                form.change('tempPracticeAreaGuidID', selection && selection.value ? selection.value : '');
                form.change('tempAreaOfLaw', selection && selection.label ? selection.label : '');

                if (values.customField && Object.keys(values.customField).length > 0) {
                    form.change('showCustomFieldWarning', true);
                } else {
                    form.change('practiceAreaGuidID', selection && selection.value ? selection.value : '');
                    form.change('areaOfLaw', selection && selection.label ? selection.label : '');
                    onGetCustomFields({
                        areaOfLawGuid: selection && selection.value ? selection.value : null,
                        customFieldGroupGuid: null,
                    }, form);
                }

                if (!props.guid) {
                    form.change('estimatedFees', selection && selection.estimatedFees ? selection.estimatedFees : null);
                    form.change('estimatedDisbursements', selection && selection.estimatedDisbursements ? selection.estimatedDisbursements : null);
                    form.change('isEstimatedFeesIncludesTax', selection && selection.isEstimatedFeesIncludesTax ? selection.isEstimatedFeesIncludesTax : false);
                    form.change('isEstimatedDisbursementsIncludesTax', selection && selection.isEstimatedDisbursementsIncludesTax
                        ? selection.isEstimatedDisbursementsIncludesTax
                        : false);
                }
            });

            if (selection && selection.label) {
                checkEmailTemplateCount(selection.label, form);
            }
        }
    };

    const onFollowUpChange = (
        form: FormApi<Enquiry>,
        // tslint:disable-next-line: no-any
        values: any,
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
        value: string,
        systemAction: string,
        url: string | null,
        defaultEmailTemplate: IAutoCompleteItem | null = null,
    ) => {
        const followUpActionValue = event && event.currentTarget && event.currentTarget.value ? event.currentTarget.value : '';
        const followUpActionSystemName = value ? value : '';
        const followUpSystemAction = systemAction ? systemAction : '';

        form.batch(() => {
            form.change('followUpAction', followUpActionValue);
            form.change('followUpActionSystemName', followUpActionSystemName);
            form.change('followUpSystemAction', followUpSystemAction);
            form.change('followUpBotUrl', url);

            if (systemAction && systemAction.toLowerCase() === 'internalnotes') {
                if (values.hasFollowUpNotesMentions === true && values.outcomeDateChanged === false) {
                    form.change('updateFollowUpDueForInternalNote', true);
                } else {
                    form.change('updateFollowUpDueForInternalNote', true);
                }
            }

            if (followUpSystemAction === 'CreateEmail' || followUpSystemAction === 'CreateSMS') {
                setIsSubmitting(true);
            } else {
                setIsSubmitting(false);
                form.change('emailTemplate', null);
            }

            if (followUpActionValue && !values.outcome) {
                form.change('outcome', followUpActionValue ? 'More Follow Up' : '');
            }
        });

        // an action set up with a default template picks it and opens the send dialog, as if it had been chosen in the dropdown (SMS needs a mobile number)
        if (defaultEmailTemplate && (followUpSystemAction === 'CreateEmail' || (followUpSystemAction === 'CreateSMS' && values.mobile))) {
            retrieveDefaultFollowUpTemplate(
                defaultEmailTemplate,
                values.areaOfLaw,
                followUpSystemAction === 'CreateSMS' ? EmailTemplateMessageTypeEnum.SMS : EmailTemplateMessageTypeEnum.EMAIL,
                (defaultTemplate: IAutoCompleteItem) => {
                    // the user may have picked another action while the template list was loading
                    const currentValues: AnyObject = form.getState().values;
                    if (currentValues.followUpActionSystemName === followUpActionSystemName && currentValues.followUpSystemAction === followUpSystemAction) {
                        onEmailTemplateChange(form, defaultTemplate);
                    }
                },
            );
        }
    };

    const onEmailTemplateChange =(form: FormApi<Enquiry>, selection: IAutoCompleteItem) => {
        form.change('emailTemplate', selection);

        if (selection && selection.value) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isSendEmailDialogOpen: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    const onOutcomeChange = (form: FormApi<Enquiry>, values: any, event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        const outcome = event && event.currentTarget && event.currentTarget.value ? event.currentTarget.value : '';

        form.batch(() => {
            form.change('outcome', outcome);

            if (outcome !== 'Not Proceeding') {
                form.change('reason', null);
                form.change('reasonGuidID', null);
                form.change('isShowNotProceedingReferrer', false);
            }
        });
    };

    const stringTruncate = (value: string, limit: number) => {
        if (value.length > limit) {
            return `${value.substring(0, limit)}...`;
        }
        return value;
    };

    const getInternalNotes = (value: string, limit: number) => {
        if (value.length >= limit) {
            return (
                <LightTooltip
                    title={value}
                    placement="bottom-start"
                    arrow={true}
                >
                    <p className={classes.internalNotes}>
                        {stringTruncate(value, (limit - 3))}
                    </p>
                </LightTooltip>
            );
        } else {
            return (
                <p className={classes.internalNotes}>
                    {value}
                </p>
            );
        }
    };

    const onUseThisContact = (form: FormApi<Enquiry>, values: AnyObject, matter: ContactMatterList, emaillAddress: string) => () => {
        
        if (!matter) return;

        onGetPartyAddresses(form, values, {
            nameId: parseInt(matter.nameId!),
            isFromDataSource: matter.isFromDataSource
        } as IndividualNameSummary, 'individualSelector');

        form.change('individualSelector', {
            label: matter.name,
            value: matter.nameGuid,
            isFromDataSource: matter.isFromDataSource,
            firstName: matter.firstName,
            lastName: matter.lastname,
            nameId: matter.nameId ? parseInt(matter.nameId) : undefined,
            guidID: matter.nameGuid,
            emailAddress: emaillAddress,
            phone: matter.phone,
            organisationName: matter.organisationName,
            organisationGuid: matter.organisationGuid,
            title: matter.title,
        } as IndividualNameSummary)
        
        form.change('firstName', matter.firstName ? matter.firstName : '');
        form.change('lastName', matter && matter.lastname ? matter.lastname : '');
        form.change('nameGuid', matter && matter.nameGuid ? matter.nameGuid : null);
        form.change('email', emaillAddress);
        form.change('phone', matter && matter.phone ? matter.phone : '');
        form.change('mobile', matter && matter.mobile ? matter.mobile : '');
        form.change('gender', matter && matter.gender ? matter.gender : null);
        form.change('title', matter && matter.title ? matter.title : 'None');

        if (matter && matter.organisationName && matter.organisationGuid) {
            // Only change if the selected individual has an organisation.
            const organisationSelectorValue: OrganisationIAutoCompleteItem = {
                label: matter.organisationName,
                value: matter.organisationGuid,
                isFromDataSource: matter.isFromDataSource
            } as OrganisationIAutoCompleteItem;

            // Do not switch if the organisation is selected through Last Name Search. We disable organisation field
            // form.change('isOrganisationSwitched', true);
            form.change('organisationSelector', organisationSelectorValue);
            form.change('organisation', matter.organisationName ? matter.organisationName : undefined);
            form.change('organisationGuid', matter && matter.organisationGuid ? matter.organisationGuid : null);
        }

        if (values.isNameSwitched) {
            form.change('isNameSwitched', !values.isNameSwitched);
        }

        setOpen(false);
    };

    // tslint:disable-next-line: no-any max-line-length
    const onDropDownSelect = (form: FormApi<Enquiry>, values: AnyObject, input: FieldInputProps<any, HTMLElement>, selection: IndividualNameSummary | IDownShiftItem | any, name: string) => {
        // input.OnChange(selection.value);
        if (name === 'assignedTo') {
            form.batch(() => {
                form.change('assignedTo', selection.value);
                form.change('assignedToName', selection.label ?? selection.email);

                if (selection.value === undefined) {
                    form.change('isNotProceeding', false);
                    form.change('notProceedingReason', null);
                    form.change('notProceedingReasonGuid', null);
                } else {
                    if (values.followUpDueDate === undefined || values.followUpDueDate === null) {
                        // only set assignment's follow up due value when we select assigned to value
                        let followUpDueValue = getFollowUpDueDefaultValue();
                        form.change('followUpDueDate', followUpDueValue);
                    }
                }
            });
        } else if (name === 'assignedBy') {
            form.batch(() => {
                form.change('assignedBy', selection.value);
                form.change('assignedByName', selection.label);
            });
        } else if (name === 'individualSelector') {
            form.batch(() => {
                // Update required fields
                if (selection) {
                    form.change('firstName', selection && selection.firstName ? selection.firstName : '');
                    form.change('lastName', selection && selection.lastName ? selection.lastName : '');
                    form.change('nameGuid', selection && selection.guidID ? selection.guidID : null);
                    form.change('email', selection && selection.emailAddress ? selection.emailAddress : '');
                    form.change('phone', selection && selection.phone ? selection.phone : '');
                    form.change('mobile', selection && selection.mobile ? selection.mobile : '');
                    form.change('gender', selection && selection.gender ? selection.gender : null);
                    form.change('title', selection && selection.title ? selection.title : 'None');

                    // if ((selection.firstName?.trim() && selection.lastName?.trim()) || selection.emailAddress) {
                    //     checkDuplicateEmail({
                    //         form,
                    //         values,
                    //         email: selection.emailAddress,
                    //         name: selection.firstName?.trim() && selection.lastName?.trim() ? `${selection.firstName.trim()} ${selection.lastName.trim()}` : null,
                    //     })
                    // }
                    
                    if (selection && selection.organisationName && selection.organisationGuid) {
                        // Only change if the selected individual has an organisation.
                        const organisationSelectorValue: OrganisationIAutoCompleteItem = {
                            label: selection.organisationName,
                            value: selection.organisationGuid,
                            isFromDataSource: selection.isFromDataSource
                        } as OrganisationIAutoCompleteItem;

                        // Do not switch if the organisation is selected through Last Name Search. We disable organisation field
                        // form.change('isOrganisationSwitched', true);
                        form.change('organisationSelector', organisationSelectorValue);
                        form.change('organisation', selection && selection.organisationName ? selection.organisationName : null);
                        form.change('organisationGuid', selection && selection.organisationGuid ? selection.organisationGuid : null);
                    }

                    if (values.isNameSwitched) {
                        form.change('isNameSwitched', !values.isNameSwitched);
                    }
                }
            });
        } else if (name === 'clientIndividualSelector') {
            form.batch(() => {
                // Update required fields
                if (selection) {
                    form.change('clientFirstName', selection && selection.firstName ? selection.firstName : '');
                    form.change('clientLastName', selection && selection.lastName ? selection.lastName : '');
                    form.change('clientGuid', selection && selection.guidID ? selection.guidID : null);
                    form.change('clientEmail', selection && selection.emailAddress ? selection.emailAddress : '');
                    form.change('clientPhone', selection && selection.phone ? selection.phone : '');
                    form.change('clientMobile', selection && selection.mobile ? selection.mobile : '');
                    form.change('gender', selection && selection.gender ? selection.gender : null);
                    form.change('clientTitle', selection && selection.title ? selection.title : 'None');

                    if (values.isClientNameSwitched) {
                        form.change('isClientNameSwitched', !values.isClientNameSwitched);
                    }
                }
            });
        } else if (name === 'secondClientIndividualSelector') {
            form.batch(() => {
                // Update required fields
                if (selection) {
                    form.change('secondClientFirstName', selection && selection.firstName ? selection.firstName : '');
                    form.change('secondClientLastName', selection && selection.lastName ? selection.lastName : '');
                    form.change('secondClientEmail', selection && selection.emailAddress ? selection.emailAddress : '');
                    form.change('secondClientPhone', selection && selection.phone ? selection.phone : '');
                    form.change('secondClientMobile', selection && selection.mobile ? selection.mobile : '');
                    form.change('secondClientGender', selection && selection.gender ? selection.gender : null);
                    form.change('secondClientTitle', selection && selection.title ? selection.title : 'None');
                    form.change('secondClientGuid', selection && selection.guidID ? selection.guidID : null);

                    if (values.isSecondClientNameSwitched) {
                        form.change('isSecondClientNameSwitched', !values.isSecondClientNameSwitched);
                    }
                }
            });
        } else if (name === 'organisationSelector') {
            form.batch(() => {
                form.change('organisation', selection && selection.label ? selection.label : '');
                form.change('organisationGuid', selection && selection.value ? selection.value : null);

                if (values.isOrganisationSwitched) {
                    form.change('isOrganisationSwitched', !values.isOrganisationSwitched);
                }
            });
        } else if (name === 'otherPartyIndividualSelector') {
            form.batch(() => {
                // Update required fields
                if (selection) {
                    form.change('otherPartyFirstName', selection && selection.firstName ? selection.firstName : '');
                    form.change('otherPartyLastName', selection && selection.lastName ? selection.lastName : '');
                    form.change('otherPartyNameGuid', selection && selection.guidID ? selection.guidID : null);
                    form.change('otherPartyEmail', selection && selection.emailAddress ? selection.emailAddress : '');
                    form.change('otherPartyPhone', selection && selection.phone ? selection.phone : '');
                    form.change('otherPartyMobile', selection && selection.mobile ? selection.mobile : '');

                    form.change('otherPartyAddressName', selection && selection.addressName ? selection.addressName : '');
                    form.change('otherPartyFloor', selection && selection.floor ? selection.floor : '');
                    form.change('otherPartyNumber', selection && selection.number ? selection.number : '');
                    form.change('otherPartyStreet', selection && selection.street ? selection.street : '');
                    form.change('otherPartySuburb', selection && selection.city ? selection.city : '');
                    form.change('otherPartyState', selection && selection.state ? selection.state : '');
                    form.change('otherPartyPostcode', selection && selection.postCode ? selection.postCode : '');
                    form.change('otherPartyCountry', selection && selection.country ? selection.country : '');
                    form.change('otherPartyTitle', selection && selection.title ? selection.title : 'None');

                    if (selection && selection.organisationName && selection.organisationGuid) {
                        // Do not switch if the organisation is selected through Last Name Search. We disable organisation field
                        // form.change('isOrganisationSwitched', true);
                        form.change('otherPartyOrganisation', selection && selection.organisationName ? selection.organisationName : null);
                        form.change('otherPartyOrganisationGuid', selection && selection.organisationGuid ? selection.organisationGuid : null);
                    }

                    if (values.isOtherPartyNameSwitched) {
                        form.change('isOtherPartyNameSwitched', !values.isOtherPartyNameSwitched);
                    }
                }
            });
        } else if (name === 'referredToFirmSelector') {
            form.batch(() => {
                const referredToFirmSelectorValue: IAutoCompleteItem = {
                    label: selection && selection.label ? selection.label : '',
                    value: selection && selection.value ? selection.value : null
                };

                form.change('referredToFirmSelector', referredToFirmSelectorValue);
                form.change('referredToFirmName', selection && selection.label ? selection.label : '');
                form.change('referredToFirmGuid', selection && selection.value ? selection.value : null);
            });
        } else if (name === 'referredToFirmSelectorInProceeding') {
            form.batch(() => {
                const referredToFirmSelectorInProceedingValue: IAutoCompleteItem = {
                    label: selection && selection.label ? selection.label : '',
                    value: selection && selection.value ? selection.value : null
                };

                form.change('referredToFirmSelectorInProceeding', referredToFirmSelectorInProceedingValue);
                form.change('referredToFirmNameInProceeding', selection && selection.label ? selection.label : '');
                form.change('referredToFirmGuidInProceeding', selection && selection.value ? selection.value : null);
            });
        }
    };

    const onSwitch = (form: FormApi<Enquiry>, values: AnyObject, name: string) => {
        if (name === 'lastName') {
            form.batch(() => {
                form.change('individualSelector', null); // clear the selector value

                if (!values.isNameSwitched) {
                    form.change('nameGuid', null);
                }

                form.change('isNameSwitched', !values.isNameSwitched);
            });
        } else if (name === 'organisation') {
            form.batch(() => {
                form.change('isOrganisationSwitched', !values.isOrganisationSwitched);
                form.change('organisationSelector', null);
                form.change('organisationGuid', null);
                form.change('organisation', '');
            });
        } else if (name === 'referredToFirm') {
            form.batch(() => {
                form.change('isNotProceedingReferrerSwitched', !values.isNotProceedingReferrerSwitched);
                // form.change('isShowNotProceedingReferrer', !values.isShowNotProceedingReferrer);
                form.change('referredToFirmSelector', null);
                form.change('referredToFirmGuid', null);
                form.change('referredToFirmName', '');
            });
        } else if (name === 'referredToFirmInProceeding') {
            form.batch(() => {
                form.change('isNotProceedingReferrerSwitchedInProceeding', !values.isNotProceedingReferrerSwitchedInProceeding);
                // form.change('isShowNotProceedingReferrer', !values.isShowNotProceedingReferrer);
                form.change('referredToFirmSelectorInProceeding', null);
                form.change('referredToFirmGuidInProceeding', null);
                form.change('referredToFirmNameInProceeding', '');
            });
        } else if (name === 'otherPartyLastName') {
            form.batch(() => {
                form.change('otherPartyIndividualSelector', null); // clear the selector value

                if (!values.isOtherPartyNameSwitched) {
                    form.change('otherPartyNameGuid', null);
                    form.change('otherPartyOrganisationGuid', null);
                }

                form.change('isOtherPartyNameSwitched', !values.isOtherPartyNameSwitched);
            });
        } else if (name === 'clientLastName') {
            form.batch(() => {
                form.change('clientIndividualSelector', null); // clear the selector value

                if (!values.isClientNameSwitched) {
                    form.change('clientGuid', null);
                }

                form.change('isClientNameSwitched', !values.isClientNameSwitched);
            });
        } else if (name === 'secondClientLastName') {
            form.batch(() => {
                form.change('secondClientIndividualSelector', null); // clear the selector value

                if (!values.isSecondClientNameSwitched) {
                    form.change('secondClientGuid', null);
                }

                form.change('isSecondClientNameSwitched', !values.isSecondClientNameSwitched);
            });
        }
    };

    // ----------------------------------------------------------------------------------------------------
    // Form actions: reset, close panels, expand, error panels
    // ----------------------------------------------------------------------------------------------------

    const onReset = (form: FormApi<Enquiry>, values: AnyObject) => {
        // If we are using keepDirtyOnReinitialize, then the form.Reset() will not work.
        // So we have change this to false, reset and then set it to true
        form.setConfig('keepDirtyOnReinitialize', false);

        form.batch(() => {
            form.reset();
            form.initialize(initialValues);

            // Do this to reset touched prop
            form.resetFieldState('firstName');
            form.resetFieldState('lastName');
            form.resetFieldState('email');
            form.resetFieldState('gender');
            form.resetFieldState('initialEnquiryDate');
            form.resetFieldState('phone');
            form.resetFieldState('mobile');
            form.resetFieldState('source');
            form.resetFieldState('office');
            form.resetFieldState('sourceNotes');
            form.resetFieldState('organisation');
            form.resetFieldState('positionAtOrganisation');
            form.resetFieldState('areaOfLaw');
            form.resetFieldState('natureOfEnquiry');
            form.resetFieldState('internalNotes');
            form.resetFieldState('files');
            form.resetFieldState('assignedTo');
            form.resetFieldState('assignedBy');
            form.resetFieldState('dateAssigned');
            form.resetFieldState('assignmentFollowUpDueReminder');

            // Other details
            form.resetFieldState('estimatedFees');
            form.resetFieldState('isEstimatedFeesIncludesTax');
            form.resetFieldState('estimatedDisbursements');
            form.resetFieldState('isEstimatedDisbursementsIncludesTax');
            form.resetFieldState('enquiryQuality');
            form.resetFieldState('likelihoodToProceed');
            form.resetFieldState('clientFirstName');
            form.resetFieldState('clientLastName');
            form.resetFieldState('dOB');
            form.resetFieldState('isMarketingConsent');
            form.resetFieldState('isConflictCheckPerformed');
            form.resetFieldState('isTermsAndConditionsApproved');
            form.resetFieldState('isIdentityCheckPerformed');
            form.resetFieldState('isPrivacyStatementProvided');
            form.resetFieldState('addressName');
            form.resetFieldState('floor');
            form.resetFieldState('number');
            form.resetFieldState('street');
            form.resetFieldState('street2');
            form.resetFieldState('suburb');
            form.resetFieldState('state');
            form.resetFieldState('postcode');
            form.resetFieldState('country');
            form.resetFieldState('pOBoxType');
            form.resetFieldState('pOBox');
            form.resetFieldState('postalSuburb');
            form.resetFieldState('postalState');
            form.resetFieldState('postalPostCode');
            form.resetFieldState('postalCountry');
            form.resetFieldState('isNoConflict');

            form.resetFieldState('otherPartyFirstName');
            form.resetFieldState('otherPartyLastName');
            form.resetFieldState('otherPartyNotes');
            form.resetFieldState('enquiryNotes');

            form.resetFieldState('otherPartyDOB');
            form.resetFieldState('otherPartyAddressName');
            form.resetFieldState('otherPartyFloor');
            form.resetFieldState('otherPartyNumber');
            form.resetFieldState('otherPartyStreet');
            form.resetFieldState('otherPartyStreet2');
            form.resetFieldState('otherPartySuburb');
            form.resetFieldState('otherPartyState');
            form.resetFieldState('otherPartyPostcode');
            form.resetFieldState('otherPartyCountry');

            form.resetFieldState('otherPartyPOBoxType');
            form.resetFieldState('otherPartyPOBox');
            form.resetFieldState('otherPartyPostalSuburb');
            form.resetFieldState('otherPartyPostalState');
            form.resetFieldState('otherPartyPostalPostCode');
            form.resetFieldState('otherPartyPostalCountry');

            form.change('otherPartyNameGuid', null);
            form.change('otherPartyOrganisationGuid', null);

            // We are not resetting here because, in few conditions, these fields does not exists in UI and that will throw errors.

            form.change('followUpAction', 'Emailed');

            form.change('followUpDueDate', null);
            form.change('followUpDate', null);
            form.change('outcome', null);
            form.change('outcomeDate', null);
            form.change('outcomeNotes', '');
            form.change('reason', null);
            form.change('followUpNotes', null);
            form.change('followUpDueReminder', null);

            form.change('followUpActionSystemName', '');
            form.change('followUpSystemAction', '');
            form.change('isContactDetailsChanged', false);
            form.change('isUpdateContacts', false);
            form.change('updateFollowUpDueForInternalNote', true);
            form.change('outcomeDateChanged', false);

            form.change('isNotProceedingReferrerSwitched', false);
            form.change('referredToFirmGuid', null);
            form.change('referredToFirmName', null);
            form.change('notProceedingOutcomeNotes', null);

            form.change('isNotProceedingReferrerSwitchedInProceeding', false);
            form.change('referredToFirmGuidInProceeding', null);
            form.change('referredToFirmNameInProceeding', null);
            form.change('notProceedingOutcomeNotesInProceeding', null);
            form.change('isSavedDirectly', false);

            form.change('riskNotes', null);
            form.change('riskLevelSelector', null);
            form.change('isRiskAssessed', null);

            // client 2 details
            form.change('secondClientFirstName', null);
            form.change('secondClientLastName', null);
            form.change('secondClientRelationshipToEnquirer', null);
            form.change('secondClientGender', 'Unknown');
            form.change('secondClientSuburb', null);
            form.change('secondClientState', null);
            form.change('secondClientPostCode', null);
            form.change('secondClientIsMarketingConsent', true);
            form.change('secondClientIsTermsAndConditionsApproved', false);
            form.change('secondClientIsPrivacyStatementProvided', false);
            form.change('secondClientIsConflictCheckPerformed', false);
            form.change('secondClientIsIdentityCheckPerformed', false);
            form.change('secondClientIsNoConflict', false);
            form.change('secondClientCountry', null);
            form.change('secondClientAddressName', null);
            form.change('secondClientFloor', null);
            form.change('secondClientNumber', null);
            form.change('secondClientStreet1', null);
            form.change('secondClientStreet2', null);
            form.change('secondClientDOB', null);
            form.change('secondClientPOBoxType', null);
            form.change('secondClientPOBox', null);
            form.change('secondClientPostalSuburb', null);
            form.change('secondClientPostalState', null);
            form.change('secondClientPostalPostCode', null);
            form.change('secondClientPostalCountry', null);

            if (UserFeature.HasAccess(UserFeatureEnum.hasKeyOpportunity)) {
                form.change('isKeyOpportunity', props.isKeyOpportunity);
            }

            form.change('isSentAcknowledgementEmail', false);

            if (!props.guid) {
                form.resetFieldState('isNotProceeding');
                form.resetFieldState('notProceedingReason');
            }

            form.change('hasFollowUpNotesMentions', false);

            form.change('tabEdited', undefined);
        });

        form.setConfig('keepDirtyOnReinitialize', true);

        setState((prevState) => {
            return {
                ...prevState,
                showDiscard: false,
                // showTabsSaveAlert: false,
                isFormChanged: false,
                isKeyOpportunity: props.isKeyOpportunity,
                tab: EnquiryFormTab.details,
                pendingFocusField: null,
                pendingNavigation: null,
                isOverflowMenuOpen: false,
                isDeleteConfirmOpen: false,
                isContactDetailsPanelExpand: isCreateForm,
                isEnquiryDetailsPanelExpand: isCreateForm,
                isAssignPanelExpand: false,
                isBookMeetingFromHistoryActivity: false
            };
        });

        // a different record: its duplicate check must run even for the same email / name
        lastDuplicateCheckKeyRef.current = null;
        setIsSubmitting(false);
    };

    const onHistoryCreateClient = (name: string) => (isCreate: boolean) => {
        setState((prevState) => {
            return {
                ...prevState,
                [name]: isCreate
            };
        });
    };

    // tslint:disable-next-line: no-any
    const closePanel = (form: FormApi<Enquiry>, values: any, isForceClose: boolean) => {
        if (state.isFormChanged === true && !isForceClose) {
            // If required pass the values from FormSpy and compare using updateDiff as shown above
            // form.change('showDiscard', true); // TODO: Remove if not used.  Why this?

            form.change('tabEdited', undefined);

            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: true,
                    // showTabsSaveAlert: false
                };
            });

        } else {
            onEnquiryFormClosed();
        }
    };

    const onActionButtonClick = (form: FormApi<Enquiry>, handleCreateAndClose: boolean, handleCreateAndNew: boolean, handleUpdate: boolean) => {
        setState((prevState) => {
            return {
                ...prevState,
                isFormSubmit: true
            };
        });

        form.batch(() => {
            form.change('handleCreateAndClose', handleCreateAndClose);
            form.change('handleCreateAndNew', handleCreateAndNew);
            form.change('handleUpdate', handleUpdate);
        });
    };

    const onExpandPanel = (panel: string) => (event: React.ChangeEvent<{}>, expanded: boolean) => {
        setState((prevState) => {
            return {
                ...prevState,
                [panel]: expanded
            };
        });
    };

    const onToggleExpandAllDetailsPanels = () => {
        setState((prevState) => {
            const nextExpanded = !DETAILS_TAB_PANEL_KEYS.every((panelKey) => prevState[panelKey]);
            const updates: Partial<Record<DetailsTabPanelKey, boolean>> = {};
            DETAILS_TAB_PANEL_KEYS.forEach((panelKey) => {
                updates[panelKey] = nextExpanded;
            });
            return {
                ...prevState,
                ...updates,
            };
        });
    };

    const openErrorPanel = (errors: ValidationErrors, form: FormApi<Enquiry>) => {
        if (errors && Object.keys(errors).length) {
            setState((prevState) => {

                let isContactDetailsPanelExpand = false;
                let isEnquiryDetailsPanelExpand = false;
                let isAssignPanelExpand = false;
                let isOtherDetailsPanelExpand = false;
                let isOther2DetailsPanelExpand = false;
                let isClient2PostalAddressPanelExpand = false;
                let isPostalAddressPanelExpand = false;
                let isOtherSidePanelExpand = false;
                let isDetailTabHasError = false;

                
                if (errors.hasOwnProperty('firstName')
                    || errors.hasOwnProperty('lastName')
                    || errors.hasOwnProperty('email')
                    || errors.hasOwnProperty('mobile')
                    || errors.hasOwnProperty('phone')
                    || errors.hasOwnProperty('source')
                    || errors.hasOwnProperty('office')
                    || errors.hasOwnProperty('eventAndCampaignSelector')
                    || errors.hasOwnProperty('internalNotes')
                    || errors.hasOwnProperty('sourceNotes')
                ) {
                    isContactDetailsPanelExpand = true;
                    isDetailTabHasError = true;
                }
                if (prevState.isContactDetailsPanelExpand) {
                    isContactDetailsPanelExpand = true;
                }

                if (errors.hasOwnProperty('areaOfLaw')) {
                    isEnquiryDetailsPanelExpand = true;
                    isDetailTabHasError = true;
                }

                if (prevState.isEnquiryDetailsPanelExpand) {
                    isEnquiryDetailsPanelExpand = true;
                }

                if (errors.hasOwnProperty('followUpDueDate')) {
                    isAssignPanelExpand = true;
                    isDetailTabHasError = true;
                }

                if (prevState.isAssignPanelExpand) {
                    isAssignPanelExpand = true;
                }

                if (errors.hasOwnProperty('pOBox')) {
                    isOtherDetailsPanelExpand = true;
                    isPostalAddressPanelExpand = true;
                    isDetailTabHasError = true;
                }

                if (errors.hasOwnProperty('secondClientPOBox')) {
                    isOther2DetailsPanelExpand = true;
                    isClient2PostalAddressPanelExpand = true;
                    isDetailTabHasError = true;
                }

                if (prevState.isOtherDetailsPanelExpand) {
                    isOtherDetailsPanelExpand = true;
                }

                if (prevState.isPostalAddressPanelExpand) {
                    isPostalAddressPanelExpand = true;
                }

                if (errors.hasOwnProperty('otherPartyFirstName') || errors.hasOwnProperty('otherPartyIndividualSelector') || errors.hasOwnProperty('otherPartyLastName')) {
                    isOtherSidePanelExpand = true;
                    isDetailTabHasError = true;
                    console.log('isDetailTabHasError other party details', isDetailTabHasError, errors);
                }
                
                if (prevState.tab === EnquiryFormTab.activity && isDetailTabHasError && !isSubmitting) {
                                        
                    showNotification(null, "Unable to save. Please resolve the data issues on the Details tab.", 'warning');
                    
                    form.setConfig('keepDirtyOnReinitialize', false);
                    
                    form.reset();
                    
                    form.setConfig('keepDirtyOnReinitialize', true);
                    
                    // Mark all details tab fields as touched to show errors
                    getDetailsTabFields().forEach(field => {
                        form.blur(field as keyof Enquiry);
                    });
                }
                
                return {
                    ...prevState,
                    isContactDetailsPanelExpand: isContactDetailsPanelExpand,
                    isEnquiryDetailsPanelExpand: isEnquiryDetailsPanelExpand,
                    isAssignPanelExpand: isAssignPanelExpand,
                    isOtherDetailsPanelExpand: isOtherDetailsPanelExpand,
                    isPostalAddressPanelExpand: isPostalAddressPanelExpand,
                    isOther2DetailsPanelExpand: isOther2DetailsPanelExpand,
                    isClient2PostalAddressPanelExpand: isClient2PostalAddressPanelExpand,
                    isOtherSidePanelExpand: isOtherSidePanelExpand,
                    isFormSubmit: false,
                    tab: isDetailTabHasError ? EnquiryFormTab.details : prevState.tab
                };
            });
        }
    };

    // tslint:disable-next-line: no-any max-line-length
    const onRatingChange = (name: string, isDirectCallMutation: boolean, input: FieldInputProps<any, HTMLElement>, form: FormApi<Enquiry>, values: AnyObject) => (event: React.ChangeEvent<{}>, value: number | null) => {
        // Explicit request: handed back so EnquiryRatingBadge can show the save's outcome.
        let saveRequest: Promise<boolean> | undefined;

        if (isDirectCallMutation) {
            form.change('isSavedDirectly', true);

            if (name === 'enquiryQuality') {
                saveRequest = onUpdateEnquiryQuality(value, values);
            }
            if (name === 'likelihoodToProceed') {
                saveRequest = onUpdateLikelihood(value, values);
            }
        } else {
            form.change('isSavedDirectly', false);
        }

        input.onChange(value);

        return saveRequest;
    };

    // Both mutations answer with { status, error }: status is whether the server accepted the update.
    const onUpdateEnquiryQuality = (value: number | null, values: AnyObject): Promise<boolean> => {

        return client
            // tslint:disable-next-line: no-any
            .mutate<any, UpdateEnquiryQualityParams>({
                mutation: UpdateEnquiryQualityMutation,
                variables: {
                    enquiryQuality: value,
                    guidId: props.guid ? props.guid : null,
                    isKeyOpportunity: values.isKeyOpportunity
                },
            })
            .then((result) => !result.errors?.length && !!result.data?.updateEnquiryQuality?.status);
    };

    const onUpdateLikelihood = (value: number | null, values: AnyObject): Promise<boolean> => {
        return client
            // tslint:disable-next-line: no-any
            .mutate<any, UpdateLikelihoodParams>({
                mutation: UpdateEnquiryLikelihoodMutation,
                variables: {
                    likelihoodToProceed: value,
                    guidId: props.guid ? props.guid : null,
                    isKeyOpportunity: values.isKeyOpportunity
                },
            })
            .then((result) => !result.errors?.length && !!result.data?.updateEnquiryLikelihood?.status);
    };

    const onToggleBookMeetingEmailDialog = (form: FormApi<Enquiry>, isOpen: boolean) => {
        form.change('isBookMeetingEmailDialogOpen', isOpen);
    };

    // ----------------------------------------------------------------------------------------------------
    // Footer action bar
    // ----------------------------------------------------------------------------------------------------

    const actionButton = (
        // tslint:disable-next-line: no-any
        form: FormApi<Enquiry>,
        submitting: boolean,
        pristine: boolean,
        // tslint:disable-next-line: no-any
        values: any,
        showEmailNotificationCheckbox: boolean,
        isShowTab: boolean,
        isShowKeyOpportunity: boolean,
        isShowSentAcknowledgementCheckBox: boolean,
        showModifyAndSend: boolean
    ) => {

        const isModifyAndSendPassRequirements = values.followUpSystemAction === 'BookMeeting' && values.staff
            && values.officeLocation && values.timezone && values.startTime && values.endTime
            && UserFeature.HasAccess(UserFeatureEnum.hasBookMeetingEmailPreview);

        const keyOpportunityLabel = getApplicationTerminology('Opportunity')?.singularLabel || getApplicationTerminology('Opportunity')?.defaultSingularLabel || 'Key Opportunity';

        // In the 2 and 3 column layouts the Follow Up panel saves on its own button, so what is typed there must not enable this Save: only a change to
        // something else (the Details) does. The other layouts have the one shared Save, as before.
        const isFollowUpSavedSeparately = (isWideLayout || isMediumLayout) && !isCreateForm;
        const followUpFieldNames = [...getActivitiesTabFields(), 'outcomeDate', 'autoFollowUpEmailTemplate'];
        const getIsPristineForMainSave = (dirtyFieldStates: { [fieldName: string]: boolean }) => (isFollowUpSavedSeparately
            ? Object.keys(dirtyFieldStates).filter((fieldName) => dirtyFieldStates[fieldName]).every((fieldName) => followUpFieldNames.includes(fieldName))
            : pristine);

        return (
            <div className={classes.stickyFooterBar} data-tour="enquiry-save">
            <div className={classes.buttonContainer}>
                {/* <RenderCount /> */}
                <div className={classes.mainControlWrapper}>
                    {!isCreateForm ? (
                        <div>
                            {/* The Save button re-renders when the dirty fields change: the footer itself only re-renders when the values it picks change. */}
                            <FormSpy subscription={{ dirtyFields: true }}>
                                {({ dirtyFields }) => (
                                    <SaveButtonWithValidationSummary
                                        formApi={form}
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        className={classes.button}
                                        onClick={() => {
                                            suspendFollowUpValidation(form);
                                            onActionButtonClick(form, false, false, true);
                                        }}
                                        disabled={(submitting || getIsPristineForMainSave(dirtyFields) || isSubmitting) || values.isSavedDirectly || !UserFeature.HasAccess(UserFeatureEnum.hasModifyLead)}
                                        disabledReason={
                                            !UserFeature.HasAccess(UserFeatureEnum.hasModifyLead) ? "You don't have permission to modify this enquiry"
                                                : (submitting || isSubmitting) ? 'Saving...'
                                                    : values.isSavedDirectly ? 'Already saved - change something to save again'
                                                        : 'No changes to save yet'
                                        }
                                    >
                                        {isLoading && <div><CircularProgress size={14} /> </div>}
                                        {!isLoading && 'Save'}
                                        {/* Update */}
                                    </SaveButtonWithValidationSummary>
                                )}
                            </FormSpy>
                            {isModifyAndSendPassRequirements && showModifyAndSend && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    className={classes.button}
                                    startIcon={<SendOutlinedIcon />}
                                    onClick={() => onToggleBookMeetingEmailDialog(form, true)}
                                >
                                    Review & Send
                                </Button>
                            )}
                        </div>
                    ) : (
                        <div>
                            <SaveButtonWithValidationSummary
                                formApi={form}
                                variant="contained"
                                color="primary"
                                type="submit"
                                className={classes.button}
                                onClick={() => {
                                    onActionButtonClick(form, true, false, false);
                                }}
                                disabled={submitting || (pristine && !props.taskSummary) || isSubmitting || !UserFeature.HasAccess(UserFeatureEnum.hasCreateLead)}
                                disabledReason={
                                    !UserFeature.HasAccess(UserFeatureEnum.hasCreateLead) ? "You don't have permission to create enquiries"
                                        : (submitting || isSubmitting) ? 'Saving...'
                                            : 'Enter the enquiry details to save'
                                }
                            >
                                {isLoading && <div>Saving... <CircularProgress size={14} /></div>}
                                {!isLoading && 'Save and Close'}
                            </SaveButtonWithValidationSummary>
                        </div>
                    )}
                    {!!!isCreateForm && state.tab === EnquiryFormTab.activity && isShowTab && (
                        <div className={classes.readRatingWrapper}>
                            <Field name="enquiryQuality">
                                {(
                                    { input } /* FieldRenderProps */
                                ) => {
                                    // tslint:disable-next-line: radix
                                    return (
                                        <div className={classes.ratingWrapper}>
                                            <Typography component="legend">Enquiry Quality</Typography>
                                            <Rating
                                                name={input.name}
                                                // tslint:disable-next-line: radix
                                                value={parseInt(input.value)}
                                                onChange={(event: React.ChangeEvent<{}>, value: number | null) => onRatingChange('enquiryQuality', true, input, form, form.getState().values)(event, value)}
                                            />
                                        </div>
                                    );
                                }}
                            </Field>
                            <Field name="likelihoodToProceed">
                                {(
                                    { input } /* FieldRenderProps */
                                ) => {
                                    // tslint:disable-next-line: radix
                                    return (
                                        <div className={classes.ratingWrapper}>
                                            <Typography component="legend">Likelihood to Proceed</Typography>
                                            <Rating
                                                name={input.name}
                                                // tslint:disable-next-line: radix
                                                value={parseInt(input.value)}
                                                onChange={(event: React.ChangeEvent<{}>, value: number | null) => onRatingChange('likelihoodToProceed', true, input, form, form.getState().values)(event, value)}
                                            />
                                        </div>
                                    );
                                }}
                            </Field>
                        </div>
                    )}
                    <div className={classes.checkoxContainer}>
                        <Button
                            variant="outlined"
                            type="button"
                            className={classes.button}
                            onClick={() => closePanel(form, form.getState().values, false)}
                        >
                            {isLoading && <div><CircularProgress size={14} /></div>}
                            {!isLoading && 'Close'}
                            {/* Close */}
                        </Button>
                        {/* <Button
                            id="resetButton"
                            type="button"
                            onClick={() => onReset(form, values)}
                            disabled={submitting || pristine}
                            className={classes.hidden}
                        >
                            {isLoading && <div><CircularProgress size={14} /></div>}
                            {!isLoading && 'Reset'}
                        </Button>                    */}
                    </div>
                </div>
                {state.tab === EnquiryFormTab.details && (
                    <div className={classes.checkbboxWrapper}>
                        {showEmailNotificationCheckbox && UserFeature.HasAccess(UserFeatureEnum.hasShowNotificationSendOption) && (
                            <Field
                                name="emailNotification"
                            >
                                {({ input, meta }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isEmailNotification}
                                                checkedIcon={<CheckBoxIcon className={classes.checkedIcon} />}
                                                onChange={onChangeEmailNotification}
                                                name="emailNotification"
                                            />
                                        }
                                        label="Email Notification"
                                    />
                                )}
                            </Field>
                        )}
                        {isShowSentAcknowledgementCheckBox && !state.hideSendAcknowledgement && (
                            <Field
                                name="isSentAcknowledgementEmail"
                            >
                                {({ input, meta }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values.isSentAcknowledgementEmail}
                                                checkedIcon={<CheckBoxIcon className={classes.checkedIcon} />}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                    // Another approach.
                                                    onSendAcknowledgementEmail(form, form.getState().values, input, checked);
                                                }}
                                                name="isSentAcknowledgementEmail"
                                            />
                                        }
                                        label="Send Acknowledgement"
                                    />
                                )}
                            </Field>
                        )}
                        {isShowKeyOpportunity && UserFeature.HasAccess(UserFeatureEnum.hasKeyOpportunity) && (
                            <Field
                                name="isKeyOpportunity"
                            >
                                {({ input, meta }) => (
                                    <Tooltip
                                        title={getApplicationTerminology('Opportunity')?.tooltip || ''}
                                        arrow={true}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values.isKeyOpportunity}
                                                    checkedIcon={<CheckBoxIcon className={classes.checkedIcon} />}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                        // Another approach.
                                                        onKeyOpportunity(form, form.getState().values, input, checked);
                                                    }}
                                                    name="isKeyOpportunity"
                                                />
                                            }
                                            label={keyOpportunityLabel}
                                        />
                                    </Tooltip>
                                )}
                            </Field>
                        )}
                    </div>
                )}
            </div>
            </div>
        );
    };

    // ----------------------------------------------------------------------------------------------------
    // Follow-up form: reset, save, cancel, change tracking
    // ----------------------------------------------------------------------------------------------------

    // Explicit request: wide layout's Follow Up panel now saves/cancels independently of the
    // Details Save button - onReset's own form.reset()+form.initialize() resets EVERY field,
    // which would wipe any in-progress Details edits the moment a follow-up/book-meeting save
    // succeeds. This resets only the activity-tab fields (same list detectUpdatedTab above
    // already uses to detect them), so a follow-up save or Cancel can't touch Details/Matter.
    // tslint:disable-next-line: no-any
    const resetFollowUpFields = (form: FormApi<any>) => {
        if (followUpValidationAttemptedRef.current) {
            followUpValidationAttemptedRef.current = false;
            // Re-runs every field's validator now that the follow-up rules are off again.
            form.setConfig('validate', undefined);
        }
        form.batch(() => {
            getActivitiesTabFields().forEach((field) => {
                // tslint:disable-next-line: no-any
                form.change(field as any, (initialValues as any)[field]);
            });
            // Not in getActivitiesTabFields (that list is keyed off the raw followUpAction
            // value, not its derived system action) but drives which fields the panel shows -
            // without resetting it too, Cancel left it pointing at whatever action the user
            // had picked while followUpAction itself reverted, showing mismatched fields.
            form.change('followUpSystemAction', (initialValues as any).followUpSystemAction ?? null);
            form.change('hasFollowUpNotesMentions', false);
            form.change('tabEdited', undefined);
        });
        setIsSubmitting(false);
        // With nothing else changed either, there is nothing left to discard (closing right after saving the follow-up asked "discard changes?" anyway)
        if (form.getState().pristine) {
            setState((prevState) => ({ ...prevState, isFormChanged: false }));
        }
    };

    // tslint:disable-next-line: no-any
    // Narrow layout keeps the follow-up rules exactly as they were (the single Save, tab based). In the 2 and 3 column layouts they
    // are checked only for Save follow-up: the validator does nothing until that button has been pressed, and is switched off again
    // while the main Save is being pressed so a half-filled follow-up can't stop the Details from saving.
    // tslint:disable-next-line: no-any
    const followUpFieldValidator = (validator: FieldValidator<any> | undefined): FieldValidator<any> | undefined => {
        if (!validator || !(isWideLayout || isMediumLayout)) {
            return validator;
        }
        return (value, allValues, meta) => (
            followUpValidationAttemptedRef.current && !followUpValidationSuspendedRef.current ? validator(value, allValues, meta) : undefined
        );
    };

    // tslint:disable-next-line: no-any
    const suspendFollowUpValidation = (form: FormApi<any>) => {
        if (!(isWideLayout || isMediumLayout)) {
            return;
        }
        followUpValidationSuspendedRef.current = true;
        form.setConfig('validate', undefined);
        // The browser's own "Please fill in this field" check would also stop the submit, so the follow-up panel's required inputs
        // are set aside for the length of this click. The submit event runs straight after the click handler, before the timeout.
        const followUpRequiredInputs = Array.from(document.querySelectorAll('#enquiryForm [data-follow-up-panel] [required]'));
        followUpRequiredInputs.forEach((input) => input.removeAttribute('required'));
        window.setTimeout(() => {
            followUpValidationSuspendedRef.current = false;
            followUpRequiredInputs.forEach((input) => input.setAttribute('required', ''));
            if (followUpValidationAttemptedRef.current) {
                form.setConfig('validate', undefined);
            }
        }, 0);
    };

    // tslint:disable-next-line: no-any
    const onSaveFollowUp = (form: FormApi<any>, values: AnyObject, isUnsavedDetailsAccepted: boolean = false) => {
        // One follow-up save at a time, and never one with neither an action nor an outcome: a second press right after a save (the fields had just been
        // cleared) used to send exactly that, which the server could not handle.
        if (isSavingFollowUpRef.current || (!values.followUpAction && !values.outcome)) {
            return;
        }
        if (isWideLayout || isMediumLayout) {
            followUpValidationAttemptedRef.current = true;
            form.setConfig('validate', undefined);
            // outcomeDate and autoFollowUpEmailTemplate carry rules too but are not in getActivitiesTabFields.
            const invalidFollowUpFields = [...getActivitiesTabFields(), 'outcomeDate', 'autoFollowUpEmailTemplate']
                .filter((fieldName) => !!form.getFieldState(fieldName)?.error);
            if (invalidFollowUpFields.length) {
                // Marking them touched is what makes each field show its own error. The rules stay on, so the errors clear
                // as they are fixed and the next Save follow-up goes through.
                invalidFollowUpFields.forEach((fieldName) => form.blur(fieldName));
                return;
            }
            followUpValidationAttemptedRef.current = false;
            form.setConfig('validate', undefined);
            // Saving the follow-up does not save the Details, so anything changed there but not saved yet would be lost - say so first.
            if (!isCreateForm && !isUnsavedDetailsAccepted) {
                const followUpFieldNames = [...getActivitiesTabFields(), 'outcomeDate', 'autoFollowUpEmailTemplate', 'followUpSystemAction', 'hasFollowUpNotesMentions', 'tabEdited', 'isSavedDirectly'];
                const dirtyDetailsFieldNames = Object.keys(form.getState().dirtyFields)
                    .filter((fieldName) => form.getState().dirtyFields[fieldName])
                    .filter((fieldName) => !followUpFieldNames.includes(fieldName));
                if (dirtyDetailsFieldNames.length) {
                    const labels = dirtyDetailsFieldNames.map((fieldName) => resolveFieldLabel(fieldName));
                    pendingFollowUpSaveRef.current = { form, values };
                    setUnsavedDetailsFieldLabels(labels.filter((label, index) => labels.indexOf(label) === index));
                    return;
                }
            }
        }
        setIsSubmitting(true);
        isSavingFollowUpRef.current = true;
        const savingFollowUp = values.followUpSystemAction === 'BookMeeting'
            ? saveBookMetting(form, values)
            : saveFollowUp(form, values as Enquiry);
        Promise.resolve(savingFollowUp).then(
            () => { isSavingFollowUpRef.current = false; },
            () => { isSavingFollowUpRef.current = false; },
        );
    };

    // tslint:disable-next-line: no-any
    const onCancelFollowUp = (form: FormApi<any>) => {
        resetFollowUpFields(form);
        // Explicit bug report: Cancel left the form half-reset after "Edit" on a Meeting Booked card
        // (onHistoryAcitivtyAssign). That flow also sets followUpActionSystemName and the
        // isBookMeetingFromHistoryActivity flag, which resetFollowUpFields does not touch - the flag
        // keeps the "Log" action chips hidden, so the panel never returned to its initial state.
        form.change('followUpActionSystemName', (initialValues as any).followUpActionSystemName ?? null);
        setState((prevState) => ({ ...prevState, isBookMeetingFromHistoryActivity: false }));
    };

    // tslint:disable-next-line
    const onFormValueChanged = (form: FormApi<any>, props: any, defaultValues: Enquiry) => {

        const { values } = props;

        detectUpdatedTab(form, values, defaultValues);

        // If isSavedDirectly is true, then we don't want to enable save button/ show discard messages
        let formState = form.getState().values;
        if (formState.isSavedDirectly === true) {
            // Check pristine prop for Follow Up Section's controls. if they are not pristine anymore, then the form is changed.
            if ((form.getFieldState('followUpAction') !== undefined && !form.getFieldState('followUpAction')?.pristine) ||
                (form.getFieldState('staff') !== undefined && !form.getFieldState('staff')?.pristine) ||
                (form.getFieldState('isSendConfirmation') !== undefined && !form.getFieldState('isSendConfirmation')?.pristine) ||
                (form.getFieldState('officeLocation') !== undefined && !form.getFieldState('officeLocation')?.pristine) ||
                (form.getFieldState('timezone') !== undefined && !form.getFieldState('timezone')?.pristine) ||
                (form.getFieldState('startTime') !== undefined && !form.getFieldState('startTime')?.pristine) ||
                (form.getFieldState('endTime') !== undefined && !form.getFieldState('endTime')?.pristine) ||
                (form.getFieldState('isAllDay') !== undefined && !form.getFieldState('isAllDay')?.pristine) ||
                (form.getFieldState('meetingNotes') !== undefined && !form.getFieldState('meetingNotes')?.pristine) ||
                (form.getFieldState('feeApplicable') !== undefined && !form.getFieldState('feeApplicable')?.pristine) ||
                (form.getFieldState('emailTemplate') !== undefined && !form.getFieldState('emailTemplate')?.pristine) ||
                (form.getFieldState('followUpDate') !== undefined && !form.getFieldState('followUpDate')?.pristine) ||
                (form.getFieldState('followUpNotes') !== undefined && !form.getFieldState('followUpNotes')?.pristine) ||
                (form.getFieldState('outcome') !== undefined && !form.getFieldState('outcome')?.pristine) ||
                (form.getFieldState('outcomeDate') !== undefined && !form.getFieldState('outcomeDate')?.pristine) ||
                (form.getFieldState('followUpDueReminder') !== undefined && !form.getFieldState('followUpDueReminder')?.pristine) ||
                (form.getFieldState('outcomeNotes') !== undefined && !form.getFieldState('outcomeNotes')?.pristine) ||
                (form.getFieldState('reason') !== undefined && !form.getFieldState('reason')?.pristine) ||
                (form.getFieldState('referredToFirmName') !== undefined && !form.getFieldState('referredToFirmName')?.pristine) ||
                (form.getFieldState('referredToFirmSelector') !== undefined && !form.getFieldState('referredToFirmSelector')?.pristine) ||
                (form.getFieldState('notProceedingOutcomeNotes') !== undefined && !form.getFieldState('notProceedingOutcomeNotes')?.pristine)
            ) {
                setState((prevState) => {
                    return {
                        ...prevState,
                        isFormChanged: true
                    };
                });
                form.change('isSavedDirectly', false);
            } else if (!state.isFormChanged) {
                // Set it to not changed if the values are changed from rating controls.
                setState((prevState) => {
                    return {
                        ...prevState,
                        isFormChanged: false
                    };
                });
            }
        } else if (!props.pristine) {
            if (!state.isFormChanged) {
                // let currentChangesMadeInTheDetailsTab = state.tab === EnquiryFormTab.details;

                setState((prevState) => {
                    return {
                        ...prevState,
                        isFormChanged: true,
                        // showTabsSaveAlert: true // currentChangesMadeInTheDetailsTab
                    };
                });
                form.change('isSavedDirectly', false);
            } else { // isFormChanged = true. But changes could have been made from other tabs before coming into the details tab.
                // let currentChangesMadeInTheDetailsTab = state.tab === EnquiryFormTab.details;

                // setState((prevState) => {
                //     return {
                //         ...prevState,
                //         showTabsSaveAlert: true // currentChangesMadeInTheDetailsTab
                //     };
                // });
            }
        }

        // If Estimated Fees has value then set Likelihood to Proceed to 3 stars
        if (form.getFieldState('estimatedFees')?.value) {
            if (form.getFieldState('likelihoodToProceed')?.value === null || form.getFieldState('likelihoodToProceed')?.value === 0) {
                form.change('likelihoodToProceed', 3);
            }
        }
    };

    const getFollowUpEnquiryInput = (values: Enquiry) => {
        return  {
            enquiryGuid: props.guid,
            followUpAction: values.followUpAction,
            followUpActionSystemName: values.followUpActionSystemName,
            followUpDate: values.followUpDate === null ? moment().toDate() : moment(values.followUpDate).toDate(),
            outcome: values.outcome,
            outcomeDate: values.outcomeDate === null ? null : moment(values.outcomeDate).toDate(),
            outcomeNotes: values.outcomeNotes,
            reason: values.reason,
            reasonGuid: values.reasonGuidID,
            followUpNotes: values.followUpNotes,
            reminderOffset: values.outcome === 'More Follow Up' // Only set reminderOffSet value if the outcome is More Follow Up
                ? (values.followUpDueReminder ? values.followUpDueReminder.value : null)
                : null,
            updateFollowUpDueForInternalNote: values.updateFollowUpDueForInternalNote,
            referredToFirmName: values.referredToFirmName,
            referredToFirmGuid: values.referredToFirmGuid,
            notProceedingNotes: values.notProceedingOutcomeNotes,
            autoFollowUpTemplateGuid: values.isAutoFollowUp && values.autoFollowUpEmailTemplate ? values.autoFollowUpEmailTemplate.value : null
        };
    };

    const getLinkMatterEnquiryInput = (values: Enquiry) => {
        return {
            enquiryGuid: props.guid,
            matterGuid: values.matterSelector.value
        };
    };

    const getFollowUpDueDefaultValue = () => getFollowUpDueDefaultValueFor(props.enquiryDefaultConfig);

    const getOutcomeDefaultTime = () => {
        let defaultTime = new Date().setHours(17, 0, 0, 0);

        let hours = 0;
        let minutes = 0;

        if (props.enquiryDefaultConfig && props.enquiryDefaultConfig.isManualEntry
            && props.enquiryDefaultConfig.timeOfDay && props.enquiryDefaultConfig.timeOfDay.toLowerCase() !== 'invalid date') {
            var timeOfDaySplit = props.enquiryDefaultConfig.timeOfDay ? props.enquiryDefaultConfig.timeOfDay.split(':') : null;

            if (timeOfDaySplit) {
                hours = Number(timeOfDaySplit[0]);
                minutes = Number(timeOfDaySplit[1]);
            }

            defaultTime = new Date().setHours(hours, minutes, 0, 0);
        }

        return defaultTime;
    };

    const getEnquiryDetails = (isInitialLoad: boolean): Enquiry => buildEnquiryFormValues({ enquiryDetail, isInitialLoad, isCreateForm, props, getReminderValue });

    // ----------------------------------------------------------------------------------------------------
    // Discard, delete, history report, close
    // ----------------------------------------------------------------------------------------------------

    // tslint:disable-next-line: no-any
    const closeUnsavedDetailsDialog = () => {
        pendingFollowUpSaveRef.current = null;
        setUnsavedDetailsFieldLabels([]);
    };

    const onSaveFollowUpOnly = () => {
        const pendingFollowUpSave = pendingFollowUpSaveRef.current;
        closeUnsavedDetailsDialog();
        if (pendingFollowUpSave) {
            onSaveFollowUp(pendingFollowUpSave.form, pendingFollowUpSave.values, true);
        }
    };

    const onDiscardChanges = (agree: boolean) => {
        if (agree) {
            // Explicit addition (enquiry prev/next navigation spec): resumes whichever action
            // (close/prev/next) actually triggered this guard, instead of always closing.
            if (state.pendingNavigation === 'prev' && props.listNavigation) {
                props.listNavigation.onPrev();
            } else if (state.pendingNavigation === 'next' && props.listNavigation) {
                props.listNavigation.onNext();
            } else {
                onEnquiryFormClosed();
            }
            setState((prevState) => ({ ...prevState, pendingNavigation: null, showDiscard: false }));
        } else {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: false,
                    pendingNavigation: null,
                    // showTabsSaveAlert: false
                };
            });
        }
    };

    // Explicit addition (enquiry prev/next navigation spec): bypasses the unsaved-changes guard
    // entirely on confirm - deleting the record makes any pending edit moot. No new grid-refresh
    // wiring needed: EnquirySummaryPage.tsx already listens to DeleteEnquirySubscription for any
    // delete, including this one.
    const onDeleteConfirm = (agree: boolean) => {
        setState((prevState) => ({ ...prevState, isDeleteConfirmOpen: false }));
        if (!agree || !props.guid) {
            return;
        }
        client.mutate({
            mutation: DeleteEnquiryMutation,
            variables: { guid: props.guid },
        })
        // tslint:disable-next-line: no-any
        .then((results: any) => {
            if (results.data) {
                if (results.data.error === null || results.data.error === undefined) {
                    showNotification(null, 'Successfully submitted', 'info');
                } else {
                    showNotification('Failed to Delete Enquiry', results.data.error, 'error');
                }
            }
        })
        // tslint:disable-next-line: no-any
        .catch((reason: any) => {
            showNotification('Failed to Delete Enquiry', reason, 'error');
        });
        onEnquiryFormClosed();
    };

    // Explicit addition (enquiry prev/next navigation spec): same PDF generation
    // EnquiryTaskAction.tsx's row-level "History Report" menu item already does, but zero new
    // network calls here - leadDetailsHistory/enquiryDetail/state.currency/state.timezone/
    // state.customFieldByHierarchy are already in memory (the same values
    // uploadEnquiryMatterDocument elsewhere in this file already feeds to HistoryFileV2).
    const onHistoryReport = () => {
        setState((prevState) => ({ ...prevState, isOverflowMenuOpen: false }));
        HistoryFileV2({
            enquiryDetail,
            sortDirection: 'DESC',
            currency: state.currency,
            timezone: state.timezone,
            leadDetailsHistory,
            // tslint:disable-next-line: no-any
            onSuccess: (results: any) => {
                const url = URL.createObjectURL(results);
                window.open(url, '_blank', 'noopener,noreferrer');
            },
            customFieldByHierarchy: state.customFieldByHierarchy,
        });
    };

    // tslint:disable-next-line: no-any
    const onShowMatterDetails = (values: any) => () => {

        sessionStorage.setItem('typeOfView', 'noback');

        const tempMatter = values.matterSelector;

        var href = history.createHref({
            pathname: '/matterDetail/' + tempMatter.id,
            key: 'matterManagement',
            state: {
                matterManagementState: 'false',
            }
        });

        window.open(href, '_blank');
    };

    const onEnquiryFormClosed = () => {
        if (props.onDialogClose) {
            props.onDialogClose();
        }
    };

    const handleExpandChange = (event: React.ChangeEvent<{}>, expanded: boolean, form: FormApi<Enquiry>) => {
        form.change('isAssignmentExpand', expanded);
    };

    const estimatedFeesColour = (financial: Financials | null) => {
        if (financial && (financial.billedTimeAndFees + financial.unbilledTimeAndFees) > financial.estimatedCosts) {
            return 'red';
        }
        return undefined;
    };

    // ----------------------------------------------------------------------------------------------------
    // Follow-up and contact-detail rules, duplicate check
    // ----------------------------------------------------------------------------------------------------

    // tslint:disable-next-line: no-any
    const followUpDueDateValidation = (form: FormApi<any>, values: any) => {
        if (isTabMatter()) {
            return undefined;
        } else if (!isTabActivity() && (enquiryActionData && enquiryActionData.canAssign)) {
            if (form.getFieldState('assignedTo')?.value) {
                return values.isNotProceeding === true ? undefined : requiredDateValidator;
            } else {
                return undefined;
            }
        } else {
            if (!isTabActivity()) {
                if (form.getFieldState('assignedTo')?.value) {
                    if (values.isClosed) {
                        return undefined;
                    }
                    return values.isNotProceeding === true ? undefined : requiredDateValidator;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        }
    };

    // tslint:disable-next-line: no-any
    const followUpDueDateRequired = (form: FormApi<any>, values: any) => {
        if (isTabMatter()) {
            return false;
        } else if (!isTabActivity() && (enquiryActionData && enquiryActionData.canAssign)) {
            if (form.getFieldState('assignedTo')?.value) {
                return values.isNotProceeding === true ? false : true;
            } else {
                return false;
            }
        } else {
            if (!isTabActivity()) {
                if (form.getFieldState('assignedTo')?.value) {
                    if (values.isClosed) {
                        return false;
                    }
                    return values.isNotProceeding === true ? false : true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    };

    // tslint:disable-next-line: no-any

    const checkIfEmailPhoneMobileAtleastOneRequired = () => {
        return props.enquiryDefaultConfig?.isEmailMandatory || props.enquiryDefaultConfig?.isPhoneNumberMandatory || props.enquiryDefaultConfig?.isMobileNumberMandatory;
    };

    const getCorrespondenceRequired = (values: AnyObject) => {
        if ((!values.email)
            && (!values.mobile)
            && (!values.phone)) {
            return true;
        } else if ((values.email && values.email.length === 0)
            && (values.mobile && values.mobile.length === 0)
            && (values.phone && values.phone.length === 0)) {
            return true;
        } else {
            return false;
        }
    };

    // tslint:disable-next-line: no-any
    const validateEmailField = (value: any, allValues: AnyObject) => {
        if (checkIfEmailPhoneMobileAtleastOneRequired()) {
            return props.enquiryDefaultConfig?.isEmailMandatory ? (ValidateEmail(value) || undefined) : undefined;
        }

        if (getCorrespondenceRequired(allValues)) {
            return 'One of Email/Telephone/Mobile are required';
        }

        if (value !== undefined && value !== null && value.length > 0) {
            return EmailValidateWithRequiredNew(value) || undefined;
        }

        return undefined;
    };

    // tslint:disable-next-line: no-any
    const validatePhoneField = (value: any, allValues: AnyObject) => {
        if (checkIfEmailPhoneMobileAtleastOneRequired()) {
            return props.enquiryDefaultConfig?.isPhoneNumberMandatory && (!value || value.length === 0)
                ? 'Telephone is required'
                : undefined;
        }

        return getCorrespondenceRequired(allValues) ? 'One of Email/Telephone/Mobile are required' : undefined;
    };

    // tslint:disable-next-line: no-any
    const validateMobileField = (value: any, allValues: AnyObject) => {
        if (checkIfEmailPhoneMobileAtleastOneRequired()) {
            return props.enquiryDefaultConfig?.isMobileNumberMandatory && (!value || value.length === 0)
                ? 'Mobile is required'
                : undefined;
        }

        return getCorrespondenceRequired(allValues) ? 'One of Email/Telephone/Mobile are required' : undefined;
    };

    // tslint:disable-next-line: no-any
    const onContactDetailsChanged = (form: FormApi<any>, values: AnyObject) => {
        // If we picked a contact from dropdown and then change contact details, then we need to confirm with the user whether it needs to be saved.
        if (values.nameGuid && !values.isContactDetailsChanged) {
            form.batch(() => {
                form.change('isContactDetailsChanged', true);
                form.change('isUpdateContacts', true);
            });
        }
    };

    // const fetchPartyNameSummary = (value: string, form: FormApi<Enquiry>) => {
    //     const partyQueryParams: PartyQueryParams = {
    //         filter: value,
    //         first: 1,
    //         offset: 0,
    //         includeOrganisation: null,
    //         includeIndividual: true,
    //         includeStaff: null,
    //     };

    //     retrievePartyData(
    //         partyQueryParams,
    //         false,
    //         // tslint:disable-next-line: no-console
    //         (data) => onRetrieveData(data, form),
    //         // tslint:disable-next-line:no-any
    //         function (reason: any): void {
    //             showNotification(null, reason, 'error');
    //         }
    //     );
    // };

    // const onRetrieveData = (data: PartyData, form: FormApi<Enquiry>) => {

    //     const nameSummaryData = data.party.nameSummaries.nameSummary;

    //     if (nameSummaryData.length > 0) {
    //         const defaultContact = {
    //             ...nameSummaryData[0],
    //             value: nameSummaryData[0].guidID.toString(),
    //             label: nameSummaryData[0].name,
    //         };

    //         form.change('emailAssociatedContact', defaultContact);
    //     } else {
    //         form.change('emailAssociatedContact', null);
    //     }

    // };

    // const onEnquiryDataRetrieved = (data: EnquiryData, form: FormApi<Enquiry>) => {
    //     const enquirySummaryData = data.enquiry.summaryList.summaries;

    //     if (enquirySummaryData.length > 0) {
    //         const defaultEnquiry = {
    //             ...enquirySummaryData[0],
    //             value: enquirySummaryData[0].guid,
    //             label: enquirySummaryData[0].name,
    //         };

    //         form.change('emailEnquiryAssociatedContact', defaultEnquiry);
    //     } else {
    //         form.change('emailEnquiryAssociatedContact', null);
    //     }
    // };

    // const fetchEnquirySummary = (search: string, form: FormApi<Enquiry>) => {

    //     var enquiryQueryParams: EnquirySummaryQueryParams = {
    //         offset: 0,
    //         first: 1,
    //         filter: null,
    //         emailAddress: search,
    //         isIncludeCurrent: true,
    //         isIncludeClosed: true,
    //         isMyEnquiriesOnly: false,
    //         groupBy: null,
    //         groupByValue: null,
    //         followUpDue: null,
    //         newEnquiry: null,
    //         assignedTo: null,
    //         areaOfLaw: null,
    //         teamList: null,
    //         isKeyOpportunity: null,
    //         enquiryQuality: null,
    //         enquiryLikelihoodToProceed: null,
    //         meetingWith: null,
    //         status: null,
    //         sourceList: null,
    //         location: null,
    //         // sortColumn: this.sortColumn,
    //         // sortDirection: this.sortDirection
    //     };

    //     retrieveEnquirySummaryData(
    //         enquiryQueryParams,
    //         false, // this.state.isRefresh, -- Since we are updating and creating, we do not fetch cached data
    //         (data) => onEnquiryDataRetrieved(data, form),
    //         // tslint:disable-next-line:no-any
    //         function (reason: any): void {
    //             showNotification(null, reason, 'error');
    //         }
    //     );
    // }

    // Explicit request (debounce fix): this used to be `debounce(fn, 500)` written inline, i.e. a
    // brand-new debounced function - with its own timer - on every render, so successive keystrokes
    // never cancelled each other and every keystroke fired its own duplicate-check request 500ms
    // later. The request itself (runDuplicateCheck) is now debounced once for the life of the drawer
    // (useDebouncedStableCallback: always runs the newest version, cancelled on unmount).
    // Explicit request: typing was still firing a request per pause and each one cancelled the previous. A typed
    // check now skips when the email / name are exactly what was last sent; the explicit "Check Duplicates"
    // button always runs.
    const lastDuplicateCheckKeyRef = useRef<string | null>(null);

    const runDuplicateCheck = (input: {
        form: FormApi<Enquiry>,
        values: AnyObject,
        email: string,
        name: string | null,
        isFromButton?: boolean
    }) => {

        const { form, values, email, name, isFromButton } = input;

        // tslint:disable-next-line: max-line-length no-shadow-variable
        // const emailRegex2 = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // tslint:disable-next-line: no-shadow-variable
                
        const emailValue = email || '';
        const isValidEmail = emailValue.length > 0 && emailRegex.test(emailValue);
        const isValidName = name ? name.trim().length > 0 : false;

        if (isValidEmail || isValidName) {
            const duplicateCheckKey = `${emailValue.trim().toLowerCase()}|${(name || '').trim().toLowerCase()}`;
            if (!isFromButton && duplicateCheckKey === lastDuplicateCheckKeyRef.current) {
                return;
            }
            lastDuplicateCheckKeyRef.current = duplicateCheckKey;

            const params: DuplicateCheckParams = {
                email: emailValue,
                isIncludeEnquiry: true,
                isIncludeParty: true,
                name: name
            };

            setState((prevState) => {
                return {
                    ...prevState,
                    isDuplicateChecking: true
                };
            });

            retrieveQueryData<DuplicateCheckParams, DuplicateCheckData>(
                CrmDuplicateCheckQuery,
                params,
                true,
                (data) => onDataDupicateCheckRetrieved(data, form, values, isFromButton),
                // tslint:disable-next-line: no-any
                function (reason: any): void {
                    lastDuplicateCheckKeyRef.current = null;
                    showNotification(null, reason, 'error');
                    setIsLoading(false);
                    setState((prevState) => {
                        return {
                            ...prevState,
                            isDuplicateChecking: false
                        };
                    });
                }
            );
        } else {
            lastDuplicateCheckKeyRef.current = null;
            setState((prevState) => {
                return {
                    ...prevState,
                    duplicateCheck: null,
                    isDuplicateChecking: false
                };
            });
        }
        
        // tslint:disable-next-line: align
    };

    const debouncedRunDuplicateCheck = useDebouncedStableCallback(runDuplicateCheck, 800); // 800 is the debounce delay in milliseconds (was 500: slower typists still triggered a request per pause)

    const checkDuplicateEmail = (input: {
        form: FormApi<Enquiry>,
        values: AnyObject,
        email: string,
        name: string | null,
        isFromButton?: boolean
    }) => {
        // this is not part of the email duplciate checker but need to put it in here so that we can only use 1 function in the textfield
        // If we picked a contact from dropdown and then change contact details, then we need to confirm with the user whether it needs to be saved.
        // Kept immediate (not debounced): it is cheap and idempotent, and waiting for typing to stop could let a
        // quick Save skip that confirmation.
        if (!input.isFromButton) {
            onContactDetailsChanged(input.form, input.values);
        }

        if (input.isFromButton) {
            // an explicit "Check Duplicates" click is not typing - run it now, and drop any typed check still waiting
            debouncedRunDuplicateCheck.cancel();
            runDuplicateCheck(input);
        } else {
            debouncedRunDuplicateCheck(input);
        }
    };

    const getIsEmailHasDuplicate = (duplicateCheck: DuplicateCheck) => {
        const contactEnquiries = duplicateCheck?.contactEnquiries || [];

        let isEmailHasDuplicate = false;

        if (
            duplicateCheck &&
            duplicateCheck.enquiryContactDuplicateCount === 1 &&
            contactEnquiries.length === 1 &&
            contactEnquiries[0].enquiryGuid === enquiryDetail.guid
        ) {
            isEmailHasDuplicate = false; // Only current enquiry, not a duplicate
        } else {
            isEmailHasDuplicate =
                duplicateCheck &&
                contactEnquiries.filter(x => x.enquiryGuid !== props.guid).length > 0;
        }

        if ((duplicateCheck.contactMatterList && duplicateCheck.contactMatterList.length > 0) || 
            (duplicateCheck.contactEnquriesOtherSide && duplicateCheck.contactEnquriesOtherSide.length > 0)) {
            isEmailHasDuplicate = true;
        }
        
        return isEmailHasDuplicate;
    };

    const onDataDupicateCheckRetrieved = (data: DuplicateCheckData, form: FormApi<Enquiry>, values: AnyObject, isFromButton?: boolean) => {
        setState((prevState) => {
            return {
                ...prevState,
                duplicateCheck: data.crm.duplicateCheck,
                isDuplicateChecking: false,
                isShowingDuplicateResult: true
            };
        });

        // Reverts the button back to "Check Duplicates" after a few seconds - explicit
        // request to show the result on the button itself instead of a separate chip.
        setTimeout(() => {
            setState((prevState) => {
                return {
                    ...prevState,
                    isShowingDuplicateResult: false
                };
            });
        },         2500);

        if (isFromButton) {
            
            if (props.formAction === 'edit') {
                            
                setState((prevState) => {
                    return {
                        ...prevState,
                        isContactDetailsPanelExpand: true
                    };
                });
            }
        }
    };

    // Explicit request: "Add phone"/"Add email" (shown in the header when that contact line is
    // empty) jumps to the Details tab, expands Contact Details, and focuses the actual field -
    // the effect below does the focusing once the field exists in the DOM (switching tab and
    // expanding an Accordion both take a render, and the Accordion's own expand transition means
    // the input isn't immediately there the instant this state change is applied).
    const onAddContactFieldClick = (field: 'phone' | 'email' | 'mobile') => {
        setState((prevState) => {
            return {
                ...prevState,
                tab: EnquiryFormTab.details,
                isContactDetailsPanelExpand: true,
                pendingFocusField: field,
            };
        });
    };

    useEffect(() => {
        if (!state.pendingFocusField) {
            return;
        }
        const fieldName = state.pendingFocusField;
        // Bounded poll (not indefinite) for the input to exist - covers the tab switch's own
        // render plus the Accordion's expand transition, without assuming either finishes within
        // a single tick.
        let attemptsRemaining = 20;
        const intervalId = setInterval(() => {
            const input = document.querySelector<HTMLInputElement>(`input[name="${fieldName}"]`);
            attemptsRemaining -= 1;
            if (input) {
                // Explicit request: scroll the field into view before focusing it - Contact
                // Details may still be below the fold even once expanded.
                input.scrollIntoView({ block: 'center' });
                input.focus();
                clearInterval(intervalId);
                setState((prevState) => ({ ...prevState, pendingFocusField: null }));
            } else if (attemptsRemaining <= 0) {
                clearInterval(intervalId);
                setState((prevState) => ({ ...prevState, pendingFocusField: null }));
            }
        },                               50);
        return () => clearInterval(intervalId);
    // tslint:disable-next-line: align
    }, [state.pendingFocusField]);

    // ----------------------------------------------------------------------------------------------------
    // Drawer navigation: close, previous / next
    // ----------------------------------------------------------------------------------------------------

    const onClose = () => {
        if (state.isFormChanged) {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: true,
                    pendingNavigation: 'close',
                    // showTabsSaveAlert: false
                };
            });
        } else {
            onEnquiryFormClosed();
        }
    };

    // Explicit addition (enquiry prev/next navigation spec): same guard as onClose above, reused
    // for prev/next - only calls into props.listNavigation once the form is confirmed clean (or
    // the user discards changes via onDiscardChanges below).
    const onPrevClick = () => {
        if (!props.listNavigation || state.showDiscard) {
            return;
        }
        if (state.isFormChanged) {
            setState((prevState) => ({ ...prevState, showDiscard: true, pendingNavigation: 'prev' }));
        } else {
            props.listNavigation.onPrev();
        }
    };

    const onNextClick = () => {
        if (!props.listNavigation || state.showDiscard) {
            return;
        }
        if (state.isFormChanged) {
            setState((prevState) => ({ ...prevState, showDiscard: true, pendingNavigation: 'next' }));
        } else {
            props.listNavigation.onNext();
        }
    };

    // ----------------------------------------------------------------------------------------------------
    // Create client / matter, re-open, unlink matter
    // ----------------------------------------------------------------------------------------------------

    const onCreateClientDialog = (open: boolean) => () => {
        setState((prevState) => {
            return {
                ...prevState,
                isCreateClientOpen: open
            };
        });
    };

    const onMarkClientMatterCreateDialog = (open: boolean) => () => {
        setState((prevState) => {
            return {
                ...prevState,
                isMarkClientMatterCreatedOpen: open
            };
        });
    };

    const onCompleteCreateClient = () => {
        const test = false;
        if (test) {
            completeCreateClient();
        }
        setState((prevState) => {
            return {
                ...prevState,
                isMarkClientMatterCreatedOpen: true
            };
        });
    };

    // for test only
    // const downloadEnquirySummary = (enquiryDetails: EnquiryDetail) => {
    //     console.log('alright');
    //     // HistoryFile(enquiryDetails, 'DESC', state.currency, state.timezone, leadDetailsHistory,
    //     //     (results) => {
    //     //         // tslint:disable-next-line: no-console
    //     //         var url = URL.createObjectURL(results);
    //     //         window.open(url, '_blank', 'noopener, noreferrer');
    //     //     }
    //     // );

    //     HistoryFileV2({
    //         enquiryDetail: enquiryDetails,
    //         sortDirection: 'DESC',
    //         currency: state.currency,
    //         timezone: state.timezone, 
    //         // tslint:disable-next-line: no-any
    //         leadDetailsHistory: leadDetailsHistory,
    //         // tslint:disable-next-line: no-any
    //         onSuccess: (results) => {
    //             var url = URL.createObjectURL(results);
    //             window.open(url, '_blank', 'noopener, noreferrer');
    //         },
    //         customFieldByHierarchy: state.customFieldByHierarchy
    //     });
    // };

    const completeCreateClient = () => {
        client.mutate({
            mutation: CompleteCreateClientMutation,
            variables: {
                input: getCompleteCreateClientInput()
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');
                    } else {
                        showNotification('Complete Create Client Failed', results.data.error, 'error');
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Complete Create Client Failed', reason, 'error');
            });
    };

    // tslint:disable-next-line: no-any
    const onReOpen = (form: FormApi<any>, values: AnyObject) => {
        reOpenEnquiry(form, values);
    };

    const getReOpenFollowUpInput = () => {
        return {
            enquiryGuid: props.guid,
            followUpAction: 'Re-Open Enquiry',
            followUpActionSystemName: 'ReOpenEnquiry',
            followUpDate: moment().toDate(),
            outcome: 'More Follow Up',
            outcomeDate: null,
            outcomeNotes: '',
            reason: null,
            reasonGuid: null,
            followUpNotes: null,
        };
    };

    // tslint:disable-next-line: no-any
    const reOpenEnquiry = (form: FormApi<any>, values: AnyObject) => {
        // pressed twice before the first answer arrives, this used to send two re-open follow-ups
        if (isReOpeningRef.current) {
            return;
        }
        isReOpeningRef.current = true;
        client.mutate({
            mutation: FollowUpEnquiryMutation,
            variables: {
                input: getReOpenFollowUpInput()
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any; }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        onReset(form, values);

                    } else {
                        showNotification('Failed to Re-Open Enquiry', results.data.error, 'error');
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => { showNotification('Failed to Re-Open Enquiry', reason, 'error'); })
            .finally(() => { isReOpeningRef.current = false; });
    };

    const getUnlinkMatterFollowUpInput = () => {
        return {
            enquiryGuid: props.guid,
            followUpAction: 'Unlink Matter',
            followUpActionSystemName: 'UnlinkMatter',
            followUpDate: moment().toDate(),
            outcome: 'Proceeding',
            outcomeDate: null,
            outcomeNotes: '',
            reason: null,
            reasonGuid: null,
            followUpNotes: null,
        };
    };

    // tslint:disable-next-line: no-any
    const unlinkMatter = (form: FormApi<any>, values: AnyObject) => {
        client.mutate({
            mutation: FollowUpEnquiryMutation,
            variables: {
                input: getUnlinkMatterFollowUpInput()
            },
        })
            // tslint:disable-next-line: no-any
            .then((results: { data: any; }) => {
                if (results.data) {
                    if (results.data.error === null || results.data.error === undefined) {
                        showNotification(null, 'Successfully submitted', 'info');

                        // var link = document.getElementById('resetButton');
                        // if (link !== null) {
                        //     link.click();
                        // }
                        onReset(form, values);

                    } else {
                        showNotification('Failed to Unlink Matter', results.data.error, 'error');
                        setIsSubmitting(false);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Unlink Matter', reason, 'error');
                setIsSubmitting(false);
            });
    };

    const getCompleteCreateClientInput = () => {
        return {
            enquiryGuid: props.guid,
            matterGuid: null
        };
    };

    const showDateEndOfFromNow = (value: Date) => {

        // return moment.utc(value).local().endOf('day').fromNow();
        return moment(value).fromNow();
    };

    const formatDate = (value: Date, format: string) => {

        // return moment.utc(value).local().format(format);
        return moment(value).format(format);
    };

    // ----------------------------------------------------------------------------------------------------
    // Further field handlers
    // ----------------------------------------------------------------------------------------------------

    const handleTabChange = (values: Enquiry) => (event: React.ChangeEvent<{}>, newValue: EnquiryFormTab) => {
        if ((values.tabEdited === 'activityTab' && newValue !== EnquiryFormTab.activity) ||
            (values.tabEdited === 'detailsTab' && newValue !== EnquiryFormTab.details && newValue !== EnquiryFormTab.customFields)) {
            showNotification('warning', 'Please save the changes before continuing', 'warning');
        } else {
            setState((prevState) => {
                return {
                    ...prevState,
                    tab: newValue
                };
            });
        }

        // if (!state.showTabsSaveAlert) {
        //     setState((prevState) => {
        //         return {
        //             ...prevState,
        //             tab: newValue
        //         };
        //     });
        // } else {
        //     showNotification('warning', 'Please save the changes before continuing', 'warning');
        // }        
    };

    // tslint:disable-next-line: no-any max-line-length
    const onDropdownChange = (selection: IAutoCompleteItem, name: string, input: FieldInputProps<any, HTMLElement>, form: FormApi<any>, valueGuid: string) => {
        input.onChange(selection.label.length > 0 ? selection.label : null);

        if (name === 'reason') {
            form.change('reasonGuidID', valueGuid.length > 0
                ? valueGuid
                : null);
        } else if (name === 'notProceedingReason') {
            form.change('notProceedingReasonGuid', valueGuid.length > 0
                ? valueGuid
                : null);
        }

        if (selection.secondaryValue) {
            form.change('isShowNotProceedingReferrer', selection.secondaryValue);
            form.change('isShowNotProceedingReferrerInProceeding', selection.secondaryValue);
        } else {
            form.change('isShowNotProceedingReferrer', false);
            form.change('isShowNotProceedingReferrerInProceeding', false);

            form.change('referredToFirmSelector', null);
            form.change('referredToFirmName', '');
            form.change('referredToFirmGuid', null);
            form.change('isNotProceedingReferrerSwitched', false);

            form.change('referredToFirmSelectorInProceeding', null);
            form.change('referredToFirmNameInProceeding', '');
            form.change('referredToFirmGuidInProceeding', null);
            form.change('isNotProceedingReferrerSwitchedInProceeding', false);
        }
    };

    const onChangeEmailNotification = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setState((prevState) => {
            return {
                ...prevState,
                isEmailNotification: checked
            };
        });
    };

    // tslint:disable-next-line: no-any
    const onSendAcknowledgementEmail = (form: FormApi<Enquiry>, values: AnyObject, input: any, checked: boolean) => {
        form.batch(() => {
            form.change('isSentAcknowledgementEmail', checked);
        });
    };

    // tslint:disable-next-line: no-any
    const onKeyOpportunity = (form: FormApi<Enquiry>, values: AnyObject, input: any, checked: boolean) => {
        form.batch(() => {
            form.change('isKeyOpportunity', checked);
        });
    };

    // tslint:disable-next-line: no-any
    const onUpdateContact = (form: FormApi<Enquiry>, values: AnyObject, checked: boolean) => {
        form.batch(() => {
            form.change('isUpdateContacts', checked);
        });
    };

    // tslint:disable-next-line: no-any
    const onCheckBoxChanged = (form: FormApi<Enquiry>, values: AnyObject, input: any, checked: boolean, name: string) => {
        if (name === 'isKeyOpportunity') {
            form.batch(() => {
                form.change('isKeyOpportunity', checked);
            });
        } else if (name === 'isNotProceeding') {
            form.batch(() => {
                form.change('isNotProceeding', checked);
                form.change('isSentAcknowledgementEmail', !checked); // Do not send email if not proceeding or uncheck by default

                if (checked === false) {
                    form.change('notProceedingReason', null);
                    form.change('notProceedingReasonGuid', null);
                }
            });

            // If not proceeding, then no need to send email notification to the client. But user can check again.
            setState((prevState) => {
                return {
                    ...prevState,
                    isEmailNotification: false,
                };
            });
        }
    };

    const onSourceChanged = (form: FormApi<Enquiry>, values: AnyObject, selection: IAutoCompleteItem) => {
        if (selection && selection.secondaryValue === true) {
            form.batch(() => {
                form.change('isShowReferrer', true);
                form.change('referrerGuid', null);
                form.change('referrerName', null);
            });
        } else {
            // Check against the previously selected referrer values, if there are any
            form.batch(() => {
                form.change('isShowReferrer', false);
                form.change('referrerGuid', null);
                form.change('referrerName', null);
            });
        }
    };

    // tslint:disable-next-line: no-any max-line-length
    const onDateTimePickerChange = (input: FieldInputProps<any, HTMLElement>, formApi: FormApi<any>) => (date: MaterialUiPickersDate, value?: string | null | undefined) => {
        let defaultMeetingMinutes = 60;

        if (props.enquiryDefaultConfig && props.enquiryDefaultConfig.defaultMeetingLength) {
            var defaultMeetingLength = props.enquiryDefaultConfig.defaultMeetingLength;
            var meetingLengthSplit = defaultMeetingLength.split(':'); // split it at the colons
            defaultMeetingMinutes = (+meetingLengthSplit[0]) * 60 + (+meetingLengthSplit[1]);
        }

        input.onChange(date);
        formApi.batch(() => {
            formApi.change('endTime', moment(date).add(defaultMeetingMinutes, 'minute').toDate());
        });
    };

    // tslint:disable-next-line: no-any
    const onOutcomeDateChange = (input: FieldInputProps<any, HTMLElement>, formApi: FormApi<any>) => (date: MaterialUiPickersDate, value?: string | null | undefined) => {
        input.onChange(date);

        formApi.batch(() => {
            formApi.change('updateFollowUpDueForInternalNote', true);
            formApi.change('outcomeDateChanged', true);
        });
    };

    // tslint:disable-next-line: max-line-length no-any
    const onChangeAllDay = (input: FieldInputProps<any, HTMLElement>, formApi: FormApi<any>, values: AnyObject) => (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        input.onChange(checked);
        if (checked) {
            const startDate = moment(values.startTime).set({ hours: 9, minutes: 0, seconds: 0, milliseconds: 0 }).toDate();
            const endDate = moment(values.endTime).set({ hours: 17, minutes: 0, seconds: 0, milliseconds: 0 }).toDate();
            formApi.batch(() => {
                formApi.change('startTime', startDate);
                formApi.change('endTime', endDate);
            });
        }
    };

    const onReferrerChanged = (form: FormApi<Enquiry>, values: AnyObject, selection: IAutoCompleteItem) => {
        form.batch(() => {
            form.change('referrerGuid', selection ? selection.value : null);
            form.change('referrerName', selection ? selection.label : null);
            form.change('isReferrerFromDataSource', selection ? selection.isNameFromDataSource : null);
        });
    };

    const onFileClicked = (file: DocumentFile) => {
        if (file && file.url) {
            var win = window.open(file.url, '_blank');
            if (win) {
                win.focus();
            }
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // Superseded by DocumentsDropzone's own unified file list (which shows saved files with the
    // same onFileClicked click-to-open behaviour alongside newly-added ones) - explicit request
    // to consolidate the two separate file listings the Documents panel used to show into one.
    // Not deleted, per this codebase's convention for dead code.
    // const getFileItems = (files?: DocumentFile[]) => {
    //     if (files) {
    //         const filteredFiles = files.filter((file: DocumentFile) => {
    //             return file.status !== 2 && file.url;
    //         });

    //         if (filteredFiles) {
    //             const chip = (
    //                 <div>
    //                     {
    //                         filteredFiles.length > 0
    //                             ? <Typography>{'Click on the following to open the uploaded files'}</Typography>
    //                             : null
    //                     }
    //                     <div className={classes.chips}>
    //                         {
    //                             filteredFiles.map((file: DocumentFile, index: number) => {
    //                                 return (
    //                                     <Chip
    //                                         key={index}
    //                                         className={classes.chip}
    //                                         label={normalizeFileName(file.name)}
    //                                         onClick={() => onFileClicked(file)}
    //                                     />
    //                                 );
    //                             }
    //                             )
    //                         }
    //                     </div>
    //                 </div>
    //             );

    //             return chip;
    //         } else {
    //             return (<div />);
    //         }
    //     } else {
    //         return (<div />);
    //     }
    // };

    // tslint:disable-next-line: no-any
    const onInputChanged = (form: FormApi<any>, name: string | any) => (value: string) => {
        form.change(name, value);
    };

    // tslint:disable-next-line: max-line-length
    const getAddressLabelForPanel = (buildingName: string, level: string, streetNumber: string, street1: string, street2: string, suburb: string, addressState: string, postCode: string, country: string) => {
        let address = buildingName ? buildingName : '';
        if (level && level.length > 0) {
            address = address.length > 0 ? (address + ', ' + level) : level;
        }
        if (streetNumber && streetNumber.length > 0) {
            address = address.length > 0 ? (address + (level && level.length > 0 ? '/' : ' ') + streetNumber) : streetNumber;
        }
        if (street1 && street1.length > 0) {
            address = address.length > 0 ? (address + ' ' + street1) : street1;
        }
        if (street2 && street2.length > 0) {
            address = address.length > 0 ? (address + ', ' + street2) : street2;
        }
        if (suburb && suburb.length > 0) {
            address = address.length > 0 ? (address + ', ' + suburb) : suburb;
        }
        if (addressState && addressState.length > 0) {
            address = address.length > 0 ? (address + ', ' + addressState) : addressState;
        }
        if (postCode && postCode.length > 0) {
            address = address.length > 0 ? (address + ', ' + postCode) : postCode;
        }
        if (country && country.length > 0) {
            address = address.length > 0 ? (address + ', ' + country) : country;
        }

        return address;
    };

    // tslint:disable-next-line: no-any
    const onSelection = (form: FormApi<Enquiry>, values: AnyObject) => (placeType: PlaceType | null, address: Address, name: string) => {

        if (name === 'street') {
            form.change('country', address.country ? address.country : values.country ? values.country : '');
            form.change('postcode', address.postalCode ? address.postalCode : values.postcode ? values.postcode : '');
            form.change('suburb', address.locality ? address.locality : values.suburb ? values.suburb : '');
            // tslint:disable-next-line: max-line-length
            form.change('state', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 : values.state ? values.state : '');
            form.change('addressName', address.premise ? address.premise : values.addressName ? values.addressName : '');
            // form.change('street', placeType?.structured_formatting.main_text);
            form.change('street', address.route ? address.route : values.street1 ? values.street1 : '');
            form.change('number', address.streetNumber ? address.streetNumber : values.number ? values.number : '');
            form.change('floor', address.floor ? address.floor : values.floor ? values.floor : '');
        }

        if (name === 'postalSuburb') {
            form.change('postalSuburb', address.locality ? address.locality : values.postalSuburb ? values.postalSuburb : '');
            form.change('postalPostCode', address.postalCode ? address.postalCode : values.postalPostCode ? values.postalPostCode : '');
            form.change('postalCountry', address.country ? address.country : values.postalCountry ? values.postalCountry : '');
            form.change('postalState', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 : values.postalState ? values.postalState : '');
        }

        if (name === 'street2') {
            form.change('street2', placeType?.structured_formatting.main_text);
        }

        // other side
        if (name === 'otherPartyStreet') {
            form.change('otherPartyCountry', address.country ? address.country : values.otherPartyCountry ? values.otherPartyCountry : '');
            form.change('otherPartyPostcode', address.postalCode ? address.postalCode : values.otherPartyPostcode ? values.otherPartyPostcode : '');
            form.change('otherPartySuburb', address.locality ? address.locality : values.otherPartySuburb ? values.otherPartySuburb : '');
            // tslint:disable-next-line: max-line-length
            form.change('otherPartyState', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 : values.otherPartyState ? values.otherPartyState : '');
            form.change('otherPartyAddressName', address.premise ? address.premise : values.otherPartyAddressName ? values.otherPartyAddressName : '');
            // form.change('otherPartyStreet', placeType?.structured_formatting.main_text);
            form.change('otherPartyStreet', address.route ? address.route : values.otherPartyStreet ? values.otherPartyStreet : '');
            form.change('otherPartyNumber', address.streetNumber ? address.streetNumber : values.otherPartyNumber ? values.otherPartyNumber : '');
            form.change('otherPartyFloor', address.floor ? address.floor : values.otherPartyFloor ? values.otherPartyFloor : '');
        }

        if (name === 'otherPartyPostalSuburb') {
            form.change('otherPartyPostalSuburb', address.locality ? address.locality : values.otherPartyPostalSuburb ? values.otherPartyPostalSuburb : '');
            form.change('otherPartyPostalPostCode', address.postalCode ? address.postalCode : values.otherPartyPostalPostCode ? values.otherPartyPostalPostCode : '');
            form.change('otherPartyPostalCountry', address.country ? address.country : values.otherPartyPostalCountry ? values.otherPartyPostalCountry : '');
            form.change('otherPartyPostalState', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 : values.otherPartyPostalState ? values.otherPartyPostalState : '');
        }

        if (name === 'otherPartyStreet2') {
            form.change('otherPartyStreet2', placeType?.structured_formatting.main_text);
        }

        // client 2
        if (name === 'secondClientStreet1') {
            form.change('secondClientCountry', address.country ? address.country : values.secondClientCountry ? values.secondClientCountry : '');
            form.change('secondClientPostCode', address.postalCode ? address.postalCode : values.secondClientPostCode ? values.secondClientPostCode : '');
            form.change('secondClientSuburb', address.locality ? address.locality : values.secondClientSuburb ? values.secondClientSuburb : '');
            // tslint:disable-next-line: max-line-length
            form.change('secondClientState', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 : values.secondClientState ? values.secondClientState : '');
            form.change('secondClientAddressName', address.premise ? address.premise : values.secondClientAddressName ? values.secondClientAddressName : '');
            // form.change('street', placeType?.structured_formatting.main_text);
            form.change('secondClientStreet1', address.route ? address.route : values.secondClientStreet1 ? values.secondClientStreet1 : '');
            form.change('secondClientNumber', address.streetNumber ? address.streetNumber : values.secondClientNumber ? values.secondClientNumber : '');
            form.change('secondClientFloor', address.floor ? address.floor : values.secondClientFloor ? values.secondClientFloor : '');
        }

        if (name === 'secondClientPostalSuburb') {
            form.change('secondClientPostalSuburb', address.locality ? address.locality : values.secondClientPostalSuburb ? values.secondClientPostalSuburb : '');
            form.change('secondClientPostalPostCode', address.postalCode ? address.postalCode : values.secondClientPostalPostCode ? values.secondClientPostalPostCode : '');
            form.change('secondClientPostalCountry', address.country ? address.country : values.secondClientPostalCountry ? values.secondClientPostalCountry : '');
            form.change('secondClientPostalState', address.administrativeAreaLevel1 ? address.administrativeAreaLevel1 :
                values.secondClientPostalState ? values.secondClientPostalState : '');
        }

        if (name === 'secondClientStreet2') {
            form.change('secondClientStreet2', placeType?.structured_formatting.main_text);
        }
    };

    // tslint:disable-next-line: no-any
    const onChangeSelection = (selection: any, input: FieldInputProps<Enquiry, any>, form: FormApi<Enquiry>, name: string) => {
        if (name === 'staff') {

            input.onChange(selection);

            if (selection) {
                if (selection && selection.hasOwnProperty('entityType') && selection.entityType === EntityTypeEnum.TEAM) {
                    form.change('isSendConfirmation', false);
                }
                if (selection && selection.hasOwnProperty('entityType') && selection.entityType === EntityTypeEnum.STAFF) {
                    form.change('isSendConfirmation', true);
                }
            } else {
                form.change('isSendConfirmation', true);
            }
        }
        if (name === 'officeLocation') {
            input.onChange(selection);

            if (selection && selection.hasOwnProperty('timezone') && selection.hasOwnProperty('timezoneDescription')
                && selection.timezone && selection.timezoneDescription) {
                const timezoneSelector = {
                    label: selection.timezoneDescription,
                    value: selection.timezone,
                    secondaryValue: selection.baseUtcOffset
                };
                form.change('timezone', timezoneSelector);
            } else {

                const { timeZone, timeZoneDescription, baseUtcOffset } = regionSettings.data!.settings.systems.regionSettings.config;

                const timezoneSelector = {
                    label: timeZoneDescription,
                    value: timeZone,
                    secondaryValue: baseUtcOffset,
                };

                form.change('timezone', timezoneSelector);
            }
        }
    };

    // ----------------------------------------------------------------------------------------------------
    // Documents
    // ----------------------------------------------------------------------------------------------------

    const getEnquiryMatterDocumentInput = (historyDocument?: Blob) => {
        return {
            entityGuid: props.guid,
            matterGuid: enquiryDetail.matterGuid,
            file: {
                file: historyDocument,
                name: 'RedView CRM Enquiry History.pdf',
                guidID: null,
                status: 1,
            }
        }
      }
    
    const saveEnquiryMatterDocument = (historyDocument?: Blob) => {
        client
            .mutate({
                mutation: UploadEnquiryMatterDocumentMutation,
                variables: {
                input: getEnquiryMatterDocumentInput(historyDocument),
            },
        })
        // tslint:disable-next-line: no-any
        .then((results: { data: any }) => {
            if (results.data) {
                if (results.data.error === null || results.data.error === undefined) {
                    setIsLoading(true);
                    // Explicit request: this only means the upload was accepted - the actual result arrives later as a
                    // notification (EnquirySummaryPage's subscribeUploadEnquiryMatterDocument), so don't say it succeeded yet.
                    showNotification(null, 'Upload started. You\'ll get a notification when it\'s finished.', 'info');
                    setIsSubmitting(false);
                    setState((prevState) => ({ ...prevState, isUploadingMatterDocument: false }));
                } else {
                    showNotification('Failed to Upload Enquiry Matter Document', results.data.error, 'error');
                    setIsSubmitting(false);
                    setState((prevState) => ({ ...prevState, isUploadingMatterDocument: false }));
              }
            }
        })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Upload Enquiry Matter Document', reason, 'error');
                setIsSubmitting(false);
                setState((prevState) => ({ ...prevState, isUploadingMatterDocument: false }));
        });
    };
    
      // save history document and upload to leap
    const uploadEnquiryMatterDocument = (enquiryDetails: EnquiryDetail) => {
        setIsSubmitting(true);
        setState((prevState) => ({ ...prevState, isUploadingMatterDocument: true }));
        // Generate the history Document.
        let documentBlob: Blob | undefined;
        
        HistoryFileV2({
            enquiryDetail: enquiryDetails,
            sortDirection: 'DESC',
            currency: state.currency,
            timezone: state.timezone, 
            // tslint:disable-next-line: no-any
            leadDetailsHistory: leadDetailsHistory,
            // tslint:disable-next-line: no-any
            onSuccess: (results) => {
                documentBlob = results;
                saveEnquiryMatterDocument(documentBlob);
            },
            customFieldByHierarchy: state.customFieldByHierarchy
        });
        
        // HistoryFile(enquiryDetails, 'DESC', state.currency, state.timezone, leadDetailsHistory, (results) => {
        //   // console.log('blob in getHistoryStringFile', results);
        //   documentBlob = results;
        //   saveEnquiryMatterDocument(documentBlob);
        // },state.customFieldByHierarchy ? state.customFieldByHierarchy : []);
    };

    // tslint:disable-next-line: max-line-length

    const countValidFiles = (data: DocumentFile[]): number => {

        let validFileCount = 0;

        for (const item of data) {
            if ((item.url && item.url.length > 0) || (item.file && Object.keys(item.file).length > 0)) {
                validFileCount++;
            }
        }

        return validFileCount;
    };
    
    const generateUniqueFileName = (name: string, existing: DocumentFile[]) => {
        const dot = name.lastIndexOf('.');
        const base = dot >= 0 ? name.slice(0, dot) : name;
        const ext = dot >= 0 ? name.slice(dot) : '';

        let i = 0;
        let newName = name;

        const used = existing
            .filter(f => f.status !== 2)
            .map(f => f.name.toLowerCase());

        while (used.includes(newName.toLowerCase())) {
            i++;
            newName = `${base}(${i})${ext}`;
        }

        return newName;
    };

    // Same fields as this drawer's own header identity block (infoIdentity below) - passed
    // through to the AI chat dialog so it can show "whose enquiry is this" at a glance, per
    // explicit request, without needing its own separate query for it. Shared by both AI entry
    // points (the Documents panel's own button/dropzone and the header's own EnquiryAiHeaderBadge)
    // since they start/show the same enquiry-level session.
    // tslint:disable-next-line: no-any
    const buildDocumentAiEnquirySummary = (values: AnyObject): DocumentAiEnquirySummary => ({
        name: (values.firstName && values.lastName) ? `${values.firstName} ${values.lastName}` : (values.organisation || 'Enquiry'),
        email: values.email || null,
        areaOfLaw: values.areaOfLaw || null,
    });

    // tslint:disable-next-line: max-line-length

    // ----------------------------------------------------------------------------------------------------
    // Stable callbacks for the memoised panels (see panels/)
    // ----------------------------------------------------------------------------------------------------

    const onEnquiryRowClick = (row: ContactEnquiry) => () => {
         const href = history.createHref({
            pathname: `/enquiriesSummary`,
            search: `?enquiryGuid=${encodeURIComponent(row.enquiryGuid)}`,
        });
        window.open(href, '_blank');
    };

    // Explicit request (EnquiryFormDrawer split): the popup content is its own memoised component
    // (components/DuplicateContactInfoPopup.tsx). It only receives stable props, so it is not rebuilt
    // on every drawer render. The handlers below keep their existing logic and run the latest version.
    const stableCloseDuplicateContactInfo = useStableCallback(() => setOpen(false));
    const stableOnUseThisContact = useStableCallback(onUseThisContact);
    const stableOnEnquiryRowClick = useStableCallback(onEnquiryRowClick);

    const showAllContactInfo = (form: FormApi<Enquiry>, values: AnyObject, duplicateCheck: DuplicateCheck | null) => (
        <DuplicateContactInfoPopup
            form={form}
            duplicateCheck={duplicateCheck}
            classes={classes}
            history={history}
            onClose={stableCloseDuplicateContactInfo}
            onUseThisContact={stableOnUseThisContact}
            onEnquiryRowClick={stableOnEnquiryRowClick}
        />
    );

    // Explicit request (EnquiryFormDrawer split): ContactDetailsPanel is memoized, so every function it
    // receives has to keep one identity between renders. useStableCallback wraps the existing
    // handlers/validators unchanged - each call still runs the latest version of the function. (The
    // panel's render-time use of getCorrespondenceRequired is safe: it is a pure function of the values
    // it is given.)
    const stableOnContactDetailsPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isContactDetailsPanelExpand')(event, expanded),
    );
    const stableRequiredValidator = useStableCallback(required);
    const stableRequiredDateValidator = useStableCallback(requiredDateValidator);
    const stableDateValidator = useStableCallback(dateValidator);
    const stableValidateEmailField = useStableCallback(validateEmailField);
    const stableValidatePhoneField = useStableCallback(validatePhoneField);
    const stableValidateMobileField = useStableCallback(validateMobileField);
    const stableGetCorrespondenceRequired = useStableCallback(getCorrespondenceRequired);
    const stableCheckDuplicateEmail = useStableCallback(checkDuplicateEmail);
    const stableOnContactDetailsChanged = useStableCallback(onContactDetailsChanged);
    const stableOnSwitch = useStableCallback(onSwitch);
    const stableOnDropDownSelect = useStableCallback(onDropDownSelect);
    const stableOnGetPartyAddresses = useStableCallback(onGetPartyAddresses);
    const stableOnSourceChanged = useStableCallback(onSourceChanged);
    const stableOnReferrerChanged = useStableCallback(onReferrerChanged);
    const stableShowAllContactInfo = useStableCallback(showAllContactInfo);
    const stableOnOtherSidePanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOtherSidePanelExpand')(event, expanded),
    );
    const stableOnOtherDetails2PanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOther2DetailsPanelExpand')(event, expanded),
    );
    const stableBirthDateValidator = useStableCallback(birthDateValidator);
    const stableOnOtherDetailsPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOtherDetailsPanelExpand')(event, expanded),
    );
    const stableOnOtherContactDetailsPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOtherContactDetailsPanelExpand')(event, expanded),
    );
    const stableIsOtherPartyPoBoxRequired = useStableCallback(isOtherPartyPoBoxRequired);
    const stableOnOtherSidePostalAddressPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOtherSidePostalAddressPanelExpand')(event, expanded),
    );
    const stableIsSecondClientPoBoxRequired = useStableCallback(isSecondClientPoBoxRequired);
    const stableOnClient2PostalAddressPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isClient2PostalAddressPanelExpand')(event, expanded),
    );
    const stableIsPoBoxRequired = useStableCallback(isPoBoxRequired);
    const stableOnPostalAddressPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isPostalAddressPanelExpand')(event, expanded),
    );
    const stableGetAddressLabelForPanel = useStableCallback(getAddressLabelForPanel);
    const stableOnAddressSelection = useStableCallback(onSelection);
    const stableOnInputChanged = useStableCallback(onInputChanged);
    const stableOnRatingChange = useStableCallback(onRatingChange);
    const stableOnSelectionChange = useStableCallback(onSelectionChange);
    // Explicit request (EnquiryFormDrawer split): AssignmentPanel is memoised, so everything it receives
    // keeps one identity between renders (each call still runs the latest version of the function).
    const stableHandleExpandChange = useStableCallback(handleExpandChange);
    const stableOnCheckBoxChanged = useStableCallback(onCheckBoxChanged);
    const stableOnDropdownChange = useStableCallback(onDropdownChange);
    const stableOnAssignPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isAssignPanelExpand')(event, expanded),
    );
    const stableFollowUpDueDateValidation = useStableCallback(followUpDueDateValidation);
    const stableFollowUpDueDateRequired = useStableCallback(followUpDueDateRequired);
    const stableGetOutcomeDefaultTime = useStableCallback(getOutcomeDefaultTime);
    const stableOnEnquiryDetailsPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isEnquiryDetailsPanelExpand')(event, expanded),
    );
    const stableOnDigitalTrackingPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isDigitalTrackingPanelExpand')(event, expanded),
    );
    const stableCountValidFiles = useStableCallback(countValidFiles);
    const stableOnFileClicked = useStableCallback(onFileClicked);
    const stableGenerateUniqueFileName = useStableCallback(generateUniqueFileName);
    const stableOnDetailedEnquiryNotesPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isDetailedEnquiryNotesPanelExpand')(event, expanded),
    );
    const stableOnOrganisationPanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isOrganisationPanelExpand')(event, expanded),
    );
    const stableOnEnquiryValuePanelExpand = useStableCallback(
        (event: React.ChangeEvent<{}>, expanded: boolean) => onExpandPanel('isEnquiryValuePanelExpand')(event, expanded),
    );

    // ----------------------------------------------------------------------------------------------------
    // Render helpers: Details tab, custom fields, create dialogs
    // ----------------------------------------------------------------------------------------------------

    // tslint:disable-next-line: no-any
    const detailsTab = (form: FormApi<any>, pristine: boolean, values: Enquiry, submitting: boolean) => {
        // let files: DocumentFile[] = form.getFieldState('files')?.value;

        return (
            <FormSpy subscription={{ values: true, validating: true, errors: true, submitting: true, modifiedSinceLastSubmit: true }}>
                {/* tslint:disable-next-line: no-shadowed-variable */}
                {({ values, errors }) => {
                    if (state.isFormSubmit) {
                        openErrorPanel(errors, form);
                    }

                    return (
                        <div
                            style={{
                                display: (isWideLayout || state.tab === EnquiryFormTab.details) ? 'block' : 'none',
                                ...(isWideLayout ? { gridArea: 'details', minWidth: 0 } : {}),
                                // Explicit request: medium layout shares this slot with Activity/
                                // Further Details (see isMiddleShowingActivity's own medium
                                // branch, which is what keeps this and those mutually exclusive).
                                ...(isMediumLayout ? { gridArea: 'left', minWidth: 0 } : {}),
                            }}
                        >
                            {/* Contact Detail */}

                            {props.formAction === 'edit' && !!enquiryDetail.guid && !isLoading && (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                        paddingBottom: '10px',
                                    }}
                                >
                                    {/* Relocated here from the drawer's own action-button row, which
                                        only ever showed these while on this same Details tab anyway -
                                        explicit request, same line as Check Duplicates so this row
                                        carries all of a Details-tab-specific controls together. */}
                                    <div className={clsx(classes.checkbboxWrapper, classes.checkChipWrapperGap)}>
                                        {/* Explicit request: the same 3 boolean toggles, now as
                                            chip-style controls (ToggleChip) matching the chip
                                            language used elsewhere on the page, instead of plain
                                            checkboxes - same fields, same handlers, same gating
                                            conditions, purely a visual swap. */}
                                        {UserFeature.HasAccess(UserFeatureEnum.hasShowNotificationSendOption) && (
                                            <Field
                                                name="emailNotification"
                                            >
                                                {() => (
                                                    <ToggleChip
                                                        name="emailNotification"
                                                        checked={state.isEmailNotification}
                                                        onChange={(checked) => onChangeEmailNotification({} as React.ChangeEvent<HTMLInputElement>, checked)}
                                                        label="Email Notification"
                                                    />
                                                )}
                                            </Field>
                                        )}
                                        {!state.hideSendAcknowledgement && (
                                            <Field
                                                name="isSentAcknowledgementEmail"
                                            >
                                                {({ input }) => (
                                                    <ToggleChip
                                                        name="isSentAcknowledgementEmail"
                                                        checked={values.isSentAcknowledgementEmail}
                                                        onChange={(checked) => {
                                                            onSendAcknowledgementEmail(form, values, input, checked);
                                                        }}
                                                        label="Send Acknowledgement"
                                                    />
                                                )}
                                            </Field>
                                        )}
                                        {UserFeature.HasAccess(UserFeatureEnum.hasKeyOpportunity) && (
                                            <Field
                                                name="isKeyOpportunity"
                                            >
                                                {({ input }) => (
                                                    <Tooltip
                                                        title={getApplicationTerminology('Opportunity')?.tooltip || ''}
                                                        arrow={true}
                                                    >
                                                        <span>
                                                            <ToggleChip
                                                                name="isKeyOpportunity"
                                                                checked={values.isKeyOpportunity}
                                                                onChange={(checked) => {
                                                                    onKeyOpportunity(form, values, input, checked);
                                                                }}
                                                                label={getApplicationTerminology('Opportunity')?.singularLabel || getApplicationTerminology('Opportunity')?.defaultSingularLabel || 'Key Opportunity'}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </Field>
                                        )}
                                    </div>
                                    <LightTooltip
                                        title="Check if the email address entered is already in use by another contact or client."
                                    >
                                        <Button
                                            variant="outlined"
                                            type="button"
                                            onClick={() => {
                                                checkDuplicateEmail({
                                                    form,
                                                    values,
                                                    email: values.email,
                                                    name: values.firstName?.trim() && values.lastName?.trim() ? `${values.firstName.trim()} ${values.lastName.trim()}` : null,
                                                    isFromButton: true
                                                });
                                            }}
                                            size='small'
                                            disabled={state.isDuplicateChecking}
                                            className={clsx(
                                                classes.checkDuplicatesButton,
                                                !state.isDuplicateChecking && state.isShowingDuplicateResult && state.duplicateCheck && (
                                                    getIsEmailHasDuplicate(state.duplicateCheck) ? classes.checkDuplicatesButtonWarning : classes.checkDuplicatesButtonOk
                                                ),
                                            )}
                                        >
                                            {/* Explicit request: no separate result chip - the button's own
                                                text/icon/colour shows the result for a few seconds (see
                                                isShowingDuplicateResult's own setTimeout) then reverts.
                                                Keyed per state so AnimatedItem replays the fade/rise on every
                                                swap, not just the first. */}
                                            <AnimatedItem
                                                key={state.isDuplicateChecking
                                                    ? 'checking'
                                                    : (state.isShowingDuplicateResult && state.duplicateCheck)
                                                        ? (getIsEmailHasDuplicate(state.duplicateCheck) ? 'warning' : 'ok')
                                                        : 'idle'}
                                                noFill={true}
                                            >
                                                <span className={classes.checkDuplicatesButtonContent}>
                                                    {state.isDuplicateChecking ? (
                                                        <>
                                                            <CircularProgress size={14} />
                                                            Checking…
                                                        </>
                                                    ) : (state.isShowingDuplicateResult && state.duplicateCheck) ? (
                                                        getIsEmailHasDuplicate(state.duplicateCheck) ? (
                                                            <>
                                                                <ReportProblemOutlinedIcon fontSize="small" />
                                                                Possible duplicate found
                                                            </>
                                                        ) : (
                                                            <>
                                                                <CheckCircleOutlineIcon fontSize="small" />
                                                                No duplicates found
                                                            </>
                                                        )
                                                    ) : (
                                                        <>
                                                            <CompareArrowsIcon fontSize="small" />
                                                            Check Duplicates
                                                        </>
                                                    )}
                                                </span>
                                            </AnimatedItem>
                                        </Button>
                                    </LightTooltip>
                                </div>
                            )}

                            <ContactDetailsPanel
                                form={form}
                                classes={classes}
                                translate={t}
                                formAction={props.formAction}
                                enquiryDefaultConfig={props.enquiryDefaultConfig}
                                isExpanded={state.isContactDetailsPanelExpand}
                                onExpandChange={stableOnContactDetailsPanelExpand}
                                duplicateCheck={state.duplicateCheck}
                                isEmailHasDuplicate={props.formAction === 'edit' && !!state.duplicateCheck && !!getIsEmailHasDuplicate(state.duplicateCheck)}
                                isUSClient={countryQuery.data?.options.homeCountry.stringValue === 'US'}
                                isActivityTab={isTabActivity()}
                                isAnyContactMethodMandatory={!!checkIfEmailPhoneMobileAtleastOneRequired()}
                                isSourceTypeClientOnly={tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'affinity' ? true : undefined}
                                isDuplicatePopperOpen={open}
                                setIsDuplicatePopperOpen={setOpen}
                                duplicatePopperAnchorRef={anchorRef}
                                renderDuplicateContactInfo={stableShowAllContactInfo}
                                getCorrespondenceRequired={stableGetCorrespondenceRequired}
                                requiredValidator={stableRequiredValidator}
                                requiredDateValidator={stableRequiredDateValidator}
                                dateValidator={stableDateValidator}
                                validateEmailField={stableValidateEmailField}
                                validatePhoneField={stableValidatePhoneField}
                                validateMobileField={stableValidateMobileField}
                                checkDuplicateEmail={stableCheckDuplicateEmail}
                                onContactDetailsChanged={stableOnContactDetailsChanged}
                                onSwitch={stableOnSwitch}
                                onDropDownSelect={stableOnDropDownSelect}
                                onGetPartyAddresses={stableOnGetPartyAddresses}
                                onSourceChanged={stableOnSourceChanged}
                                onReferrerChanged={stableOnReferrerChanged}
                            />

                            {/* Organisation */}
                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryOrganisation) || !isCreateForm) && (
                                <OrganisationPanel
                                    form={form}
                                    classes={classes}
                                    translate={t}
                                    isSourceTypeClientOnly={tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'affinity' ? true : undefined}
                                    isExpanded={state.isOrganisationPanelExpand}
                                    onExpandChange={stableOnOrganisationPanelExpand}
                                    onSwitch={stableOnSwitch}
                                    onDropDownSelect={stableOnDropDownSelect}
                                />
                            )}

                            <EnquiryDetailsPanel
                                form={form}
                                classes={classes}
                                isExpanded={state.isEnquiryDetailsPanelExpand}
                                isKeyOpportunity={props.isKeyOpportunity}
                                enquiryDefaultConfig={props.enquiryDefaultConfig}
                                translate={t}
                                requiredValidator={stableRequiredValidator}
                                onSelectionChange={stableOnSelectionChange}
                                onExpandChange={stableOnEnquiryDetailsPanelExpand}
                                isActivityTab={isTabActivity()}
                            />

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryValue) || !isCreateForm) && (
                                <EnquiryValuePanel
                                    form={form}
                                    classes={classes}
                                    currency={state.currency}
                                    translate={t}
                                    isExpanded={state.isEnquiryValuePanelExpand}
                                    onExpandChange={stableOnEnquiryValuePanelExpand}
                                    onRatingChange={stableOnRatingChange}
                                />
                            )}

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryDetailedNotes) || !isCreateForm) && (
                                <DetailedEnquiryNotesPanel
                                    form={form}
                                    classes={classes}
                                    isExpanded={state.isDetailedEnquiryNotesPanelExpand}
                                    onExpandChange={stableOnDetailedEnquiryNotesPanelExpand}
                                />
                            )}
                            
                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryClientDetails) || !isCreateForm) && (
                                <OtherDetailsPanel
                                    form={form}
                                    classes={classes}
                                    isExpanded={state.isOtherDetailsPanelExpand}
                                    isOtherContactDetailsPanelExpanded={state.isOtherContactDetailsPanelExpand}
                                    isPostalAddressPanelExpanded={state.isPostalAddressPanelExpand}
                                    homeCountry={props.homeCountry}
                                    onDropDownSelect={stableOnDropDownSelect}
                                    onGetPartyAddresses={stableOnGetPartyAddresses}
                                    onSwitch={stableOnSwitch}
                                    translate={t}
                                    onContactDetailsChanged={stableOnContactDetailsChanged}
                                    onOtherContactDetailsPanelExpandChange={stableOnOtherContactDetailsPanelExpand}
                                    birthDateValidator={stableBirthDateValidator}
                                    getAddressLabelForPanel={stableGetAddressLabelForPanel}
                                    createAddressSelectionHandler={stableOnAddressSelection}
                                    createInputChangedHandler={stableOnInputChanged}
                                    isPoBoxRequired={stableIsPoBoxRequired}
                                    requiredValidator={stableRequiredValidator}
                                    onPostalAddressPanelExpandChange={stableOnPostalAddressPanelExpand}
                                    onExpandChange={stableOnOtherDetailsPanelExpand}
                                    isSourceTypeClientOnly={tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'affinity' ? true : undefined}
                                />
                            )}

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryClient2Details) || !isCreateForm) && (
                                <OtherDetails2Panel
                                    form={form}
                                    classes={classes}
                                    isExpanded={state.isOther2DetailsPanelExpand}
                                    isClient2PostalAddressPanelExpanded={state.isClient2PostalAddressPanelExpand}
                                    homeCountry={props.homeCountry}
                                    onDropDownSelect={stableOnDropDownSelect}
                                    onGetPartyAddresses={stableOnGetPartyAddresses}
                                    onSwitch={stableOnSwitch}
                                    onContactDetailsChanged={stableOnContactDetailsChanged}
                                    birthDateValidator={stableBirthDateValidator}
                                    getAddressLabelForPanel={stableGetAddressLabelForPanel}
                                    createAddressSelectionHandler={stableOnAddressSelection}
                                    createInputChangedHandler={stableOnInputChanged}
                                    isSecondClientPoBoxRequired={stableIsSecondClientPoBoxRequired}
                                    requiredValidator={stableRequiredValidator}
                                    onClient2PostalAddressPanelExpandChange={stableOnClient2PostalAddressPanelExpand}
                                    onExpandChange={stableOnOtherDetails2PanelExpand}
                                    isSourceTypeClientOnly={tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'affinity' ? true : undefined}
                                />
                            )}

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryOtherSide) || !isCreateForm) && (
                                <OtherSidePanel
                                    form={form}
                                    classes={classes}
                                    isExpanded={state.isOtherSidePanelExpand}
                                    isOtherSidePostalAddressPanelExpanded={state.isOtherSidePostalAddressPanelExpand}
                                    homeCountry={props.homeCountry}
                                    enquiryDefaultConfig={props.enquiryDefaultConfig}
                                    requiredValidator={stableRequiredValidator}
                                    onDropDownSelect={stableOnDropDownSelect}
                                    onGetPartyAddresses={stableOnGetPartyAddresses}
                                    onSwitch={stableOnSwitch}
                                    birthDateValidator={stableBirthDateValidator}
                                    translate={t}
                                    getAddressLabelForPanel={stableGetAddressLabelForPanel}
                                    createAddressSelectionHandler={stableOnAddressSelection}
                                    createInputChangedHandler={stableOnInputChanged}
                                    isOtherPartyPoBoxRequired={stableIsOtherPartyPoBoxRequired}
                                    onOtherSidePostalAddressPanelExpandChange={stableOnOtherSidePostalAddressPanelExpand}
                                    onExpandChange={stableOnOtherSidePanelExpand}
                                    isSourceTypeClientOnly={tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'affinity' ? true : undefined}
                                />
                            )}

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryDocuments) || !isCreateForm) && (
                                <DocumentsPanel
                                    form={form}
                                    classes={classes}
                                    countValidFiles={stableCountValidFiles}
                                    onFileClicked={stableOnFileClicked}
                                    generateUniqueFileName={stableGenerateUniqueFileName}
                                    setSnackbar={setSnackbar}
                                />
                            )}

                            {UserFeature.HasAccess(UserFeatureEnum.hasDigitalTracking) && (UserFeature.HasAccess(UserFeatureEnum.hasEnquiryDigitalTracking) || !isCreateForm) && (
                                <DigitalTrackingPanel
                                    form={form}
                                    classes={classes}
                                    isExpanded={state.isDigitalTrackingPanelExpand}
                                    validateUrl={validateUrl}
                                    onExpandChange={stableOnDigitalTrackingPanelExpand}
                                />
                            )}

                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryRiskAssessment) || !isCreateForm) && (
                                <RiskAssessedPanel
                                    form={form}
                                    classes={classes}
                                />
                            )}

                            {/* Assign */}
                            <AssignmentPanel
                                form={form}
                                classes={classes}
                                enquiryActionData={enquiryActionData}
                                isAssignPanelExpand={state.isAssignPanelExpand}
                                isActivityTab={isTabActivity()}
                                onExpandChange={stableOnAssignPanelExpand}
                                requiredValidator={stableRequiredValidator}
                                requiredDateValidator={stableRequiredDateValidator}
                                dateValidator={stableDateValidator}
                                onDropDownSelect={stableOnDropDownSelect}
                                getOutcomeDefaultTime={stableGetOutcomeDefaultTime}
                                followUpDueDateValidation={stableFollowUpDueDateValidation}
                                followUpDueDateRequired={stableFollowUpDueDateRequired}
                            />

                            {/* Proceeding */}
                            {(UserFeature.HasAccess(UserFeatureEnum.hasEnquiryProceeding) || !isCreateForm) && (
                                <ProceedingPanel
                                    form={form}
                                    classes={classes}
                                    isHidePanel={!!props.guid}
                                    requiredValidator={stableRequiredValidator}
                                    handleExpandChange={stableHandleExpandChange}
                                    onCheckBoxChanged={stableOnCheckBoxChanged}
                                    onDropdownChange={stableOnDropdownChange}
                                    onDropDownSelect={stableOnDropDownSelect}
                                    onSwitch={stableOnSwitch}
                                />
                            )}
                        </div>
                    );
                }}
            </FormSpy>
        );
    };
    // end of contact details

    // tslint:disable-next-line: no-any
    const onSendEmailDialogClose = (form: FormApi<any>) => {
        setState((prevState) => {
            return {
                ...prevState,
                isSendEmailDialogOpen: false
            };
        });

        // Change back to default value
        form.batch(() => {
            form.change('emailTemplate', null);
            form.change('followUpAction', 'Emailed');
            form.change('followUpActionSystemName', 'Emailed');
            form.change('followUpSystemAction', null);
        });

        setIsSubmitting(false);
    };

    const isMarkClientMatterWidthLong = () => {

        let i = 0;
        // create contact
        if (enquiryActionData?.canCreateContactForLostEnquiry && UserFeature.HasAccess(UserFeatureEnum.hasCreateClient)) {
            i += 1;
        }
        // create client
        if (state.isCreateClient && UserFeature.HasAccess(UserFeatureEnum.hasCreateClient)) {
            i += 1;
        }
        // re-open
        if (enquiryActionData && enquiryActionData.canReOpen && enquiryActionData.canReOpen === true) {
            i += 1;
        }

        if (i >= 2) {
            return true;
        }

        return false;

    };

    // tslint:disable-next-line: no-any
    const onHistoryAcitivtyAssign = (form: FormApi<any>) => (task: TaskDetails) => {

        const staff = task.staff && task.staffGuid ?
            { label: task.staff, value: task.staffGuid, entityType: task.isAssignedToTeam ? EntityTypeEnum.TEAM : EntityTypeEnum.STAFF } : null;
        const officeLocation = task.firmOffice && task.firmOfficeGuid ? { label: task.firmOffice, value: task.firmOfficeGuid } : null;

        const tempTimezone = state.timezone.map((tzome: TimezoneOption) => {
            return {
                value: tzome.timezoneValue,
                label: tzome.displayName,
                secondaryValue: tzome.baseUtcOffset
            };
        }).find((tzome: { value: string; label: string; secondaryValue: number; }) => tzome.value === task.timezone && tzome.secondaryValue === task.timezoneOffset);

        form.batch(() => {
            form.change('followUpAction', task.followUpAction);
            form.change('followUpActionSystemName', task.followUpActionSystemName);
            form.change('followUpSystemAction', task.systemAction);
            form.change('staff', staff);
            form.change('officeLocation', officeLocation);
            form.change('timezone', tempTimezone ? tempTimezone : null);
            // set false if assign task is a team
            form.change('isSendConfirmation', !task.isAssignedToTeam);
            form.change('startTime', task.bookMeetingStartDate);
            form.change('endTime', task.bookMeetingEndDate);
            form.change('meetingNotes', task.meetingNotes);
            form.change('feeApplicable', task.feeApplicable);
        });

        setState((prevState) => {
            return {
                ...prevState,
                isBookMeetingFromHistoryActivity: true
            };
        });
    };

    
    const OnRemoveAutFollowUp = (taskGuid: string) => {
        setIsSubmitting(true);

        client.mutate(
            {
                mutation: RemoveAutoFollowUp,
                variables: {
                    enquiryGuid: enquiryDetail.guid,
                    taskGuid: taskGuid
                }
            }
        )
        .then((result: { data : any}) => {
            if (result.data) {
                showNotification(null, 'Removing auto follow up.', 'info');
            }
        })
        .catch((reason: any) => {
            showNotification('Failed to remove auto follow up.', reason, 'error');
        })
        .finally(() => {
            setIsSubmitting(false);
        });
    }

    // const futherDetailsTab = (form: FormApi<Enquiry>, pristine: boolean, values: Enquiry) => {
    //     return (
    //         <div style={{ display: state.tab === EnquiryFormTab.customFields ? 'block' : 'none' }}>
    //             {getCustomFields(form, values)}
    //         </div>
    //     );
    // };

    // tslint:disable-next-line: no-any

    const getCustomFields = (form: FormApi<Enquiry>, values: Enquiry) => (
        <CustomFieldsSection
            isLoading={isCustomFieldLoading}
            customFieldGroups={state.customFieldByHierarchy}
            isExistingEnquiry={!!props.guid}
            enquiryDetail={enquiryDetail}
            currency={state.currency}
            classes={classes}
        />
    );

    // ----------------------------------------------------------------------------------------------------
    // Layout flags
    // ----------------------------------------------------------------------------------------------------

    const hasCustomField = UserFeature.HasAccess(UserFeatureEnum.hasCustomFieldMaintenance) && isCreateForm && state.customFieldByHierarchy && state.customFieldByHierarchy.length > 0 ? true : false;

    const defaultValues = props.guid ? getEnquiryDetails(true) : initialValues;

    const isStandAlone = tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'standalone';

    // Never on for the create form - its Activity/Follow-Up/Matter tabs don't apply until the
    // enquiry is actually saved.
    // The firm picks how many columns it prefers (Enquiry Default settings: 3, 2 or 1) and that layout is rendered first. Nothing chosen, or anything other
    // than 1, 2 or 3, means 3. A preferred layout that does not fit the window still falls back to the next one down, as before.
    const preferredColumnCount = [1, 2, 3].includes(Number(props.enquiryDefaultConfig?.pageLayout)) ? Number(props.enquiryDefaultConfig?.pageLayout) : 3;
    const isWideLayout = preferredColumnCount >= 3 && isWideViewport && !!props.guid;

    // Explicit request: the new in-between 2-column layout - only once 3-column no longer fits
    // (isWideLayout false), same !props.guid exclusion as isWideLayout for the same reason.
    const isMediumLayout = !isWideLayout && preferredColumnCount >= 2 && isMediumViewport && !!props.guid;

    // Same condition the Matter <Tab> itself already uses to decide whether it exists at all
    // (see the Tabs block below) - named here so the wide layout's own 3rd-column heading can
    // reuse it too, rather than duplicating the raw expression a third time.
    const isMatterAvailable = !!(enquiryActionData && enquiryActionData.canLinkMatter) && !isStandAlone;

    // Reused here, not a new rule, to decide whether the 3rd column shows Matter instead of
    // Follow Up. Medium layout's own right column is the same independent 'third' area wide
    // layout already has (see tabsContentAreaMedium's own comment), so it follows the same rule.
    const showMatterIn3rdColumn = (isWideLayout || isMediumLayout) && isMatterAvailable;

    // In wide layout Details/Matter are their own fixed columns, not switchable tabs (see the
    // Tabs block below, which hides those two Tab buttons there) - so the middle column falls
    // back to Activity unless the user has explicitly picked Further Details, rather than going
    // blank whenever state.tab happens to be 'details' or 'matterDetails' (e.g. on first mount,
    // or after narrowing then widening the window while one of those was selected).
    // Explicit request: medium layout's own left column additionally shares space with Details
    // (wide layout's Details has its own separate column, so it never competes for this slot) -
    // an exact EnquiryFormTab.activity match, not wide's "isn't Further Details" rule, so
    // picking the Details tab correctly shows only Details, not Details overlapping Activity.
    const isMiddleShowingActivity = isWideLayout
        ? state.tab !== EnquiryFormTab.customFields
        : isMediumLayout
            ? state.tab === EnquiryFormTab.activity
            : isTabActivity();

    const isAllDetailsPanelsExpanded = DETAILS_TAB_PANEL_KEYS.every((panelKey) => state[panelKey]);

    const getCorrectCreateMatterDialog = () => {
        
        switch(tenantQuery.data?.tenant.sourceSystem.toLowerCase()) {
            case 'affinity': //3998
                return (
                    <AffinityCreateMatterDialog 
                        anchor="right"
                        anchorOffset={isQuickViewPinned ? QUICK_VIEW_WIDTH : undefined}
                        guid={props.guid}
                        homeCountry={state.homeCountry}
                        sourceSystem={state.sourceSystem}
                        onDialogClose={onCreateClientDialog(false)}
                        title={enquiryDetail.title}
                        firstName={enquiryDetail.firstName}
                        lastName={enquiryDetail.lastName}
                        organisation={enquiryDetail.organisation}
                        email={enquiryDetail.email}
                        mobile={enquiryDetail.mobile}
                        phone={enquiryDetail.phone}
                        sourceNotes={enquiryDetail.sourceNotes}
                        source={enquiryDetail.source}
                        enquiryActions={enquiryActionData}
                        enquiryDetail={enquiryDetail}
                        poBoxType={enquiryDetail.pOBoxType ? enquiryDetail.pOBoxType : props.pOBoxType}
                        timezone={state.timezone}
                        customFieldByHierarchy={state.customFieldByHierarchy}
                    />
                )
            case 'smokeball': // 11999
                return (
                    <SmokeBallCreateMatterDialog
                        anchor="right"
                        anchorOffset={isQuickViewPinned ? QUICK_VIEW_WIDTH : undefined}
                        guid={props.guid}
                        homeCountry={state.homeCountry}
                        sourceSystem={state.sourceSystem}
                        onDialogClose={onCreateClientDialog(false)}
                        title={enquiryDetail.title}
                        firstName={enquiryDetail.firstName}
                        lastName={enquiryDetail.lastName}
                        organisation={enquiryDetail.organisation}
                        email={enquiryDetail.email}
                        mobile={enquiryDetail.mobile}
                        phone={enquiryDetail.phone}
                        sourceNotes={enquiryDetail.sourceNotes}
                        source={enquiryDetail.source}
                        enquiryActions={enquiryActionData}
                        enquiryDetail={enquiryDetail}
                        poBoxType={enquiryDetail.pOBoxType ? enquiryDetail.pOBoxType : props.pOBoxType}
                        timezone={state.timezone}
                        customFieldByHierarchy={state.customFieldByHierarchy}
                    />
                )
            case 'actionstep': // 8998
                return (
                    <ActionStepCreateMatterDialog 
                        anchor="right"
                        anchorOffset={isQuickViewPinned ? QUICK_VIEW_WIDTH : undefined}
                        guid={props.guid}
                        homeCountry={state.homeCountry}
                        sourceSystem={state.sourceSystem}
                        onDialogClose={onCreateClientDialog(false)}
                        title={enquiryDetail.title}
                        firstName={enquiryDetail.firstName}
                        lastName={enquiryDetail.lastName}
                        organisation={enquiryDetail.organisation}
                        email={enquiryDetail.email}
                        mobile={enquiryDetail.mobile}
                        phone={enquiryDetail.phone}
                        sourceNotes={enquiryDetail.sourceNotes}
                        source={enquiryDetail.source}
                        enquiryActions={enquiryActionData}
                        enquiryDetail={enquiryDetail}
                        poBoxType={enquiryDetail.pOBoxType ? enquiryDetail.pOBoxType : props.pOBoxType}
                        timezone={state.timezone}
                        customFieldByHierarchy={state.customFieldByHierarchy}
                    />
                )
            default:
                return (
                    <CreateClientDialog
                        anchor="right"
                        anchorOffset={isQuickViewPinned ? QUICK_VIEW_WIDTH : undefined}
                        guid={props.guid}
                        homeCountry={state.homeCountry}
                        sourceSystem={state.sourceSystem}
                        onDialogClose={onCreateClientDialog(false)}
                        title={enquiryDetail.title}
                        firstName={enquiryDetail.firstName}
                        lastName={enquiryDetail.lastName}
                        organisation={enquiryDetail.organisation}
                        email={enquiryDetail.email}
                        mobile={enquiryDetail.mobile}
                        phone={enquiryDetail.phone}
                        sourceNotes={enquiryDetail.sourceNotes}
                        source={enquiryDetail.source}
                        enquiryActions={enquiryActionData}
                        enquiryDetail={enquiryDetail}
                        poBoxType={enquiryDetail.pOBoxType ? enquiryDetail.pOBoxType : props.pOBoxType}
                        timezone={state.timezone}
                        customFieldByHierarchy={state.customFieldByHierarchy}
                    />
                )
                
        }
    };
    
    // ----------------------------------------------------------------------------------------------------
    // Render
    // ----------------------------------------------------------------------------------------------------

    return (
        <>
            <React.Fragment>
      
                {state.showDiscard && (
                    <DialogBox
                        title="Discard unsaved changes?"
                        // tslint:disable-next-line:max-line-length
                        content={`You have changes that haven't been saved. If you close now they'll be lost.`}
                        show={state.showDiscard ? state.showDiscard : false}
                        isAgree={onDiscardChanges}
                        disAgreeLabel={'Keep editing'}
                        agreeLabel={'Discard changes'}
                        isAgreeDestructive={true}
                    />
                )}

                {unsavedDetailsFieldLabels.length > 0 && (
                    <UnsavedDetailsFollowUpDialog
                        fieldLabels={unsavedDetailsFieldLabels}
                        onGoBack={closeUnsavedDetailsDialog}
                        onSaveFollowUpOnly={onSaveFollowUpOnly}
                    />
                )}

                {state.isDeleteConfirmOpen && (
                    <DialogBox
                        title="Delete Enquiry"
                        content="Are you sure you want to delete this enquiry? This cannot be undone."
                        show={state.isDeleteConfirmOpen}
                        isAgree={onDeleteConfirm}
                        disAgreeLabel={'No'}
                        agreeLabel={'Yes'}
                    />
                )}

                {state.isCreateClientOpen && getCorrectCreateMatterDialog()}
                
                {state.isMarkClientMatterCreatedOpen && (
                    <MarkClientAndMatterCreatedDialog
                        guid={props.guid}
                        onDialogClose={onMarkClientMatterCreateDialog(false)}
                        canCreateMatter={enquiryActionData?.canCreateMatter}
                        isStandAlone={isStandAlone}
                    />
                )}

                <AiChatDialogOpenWatcher onChange={setIsAiChatDialogOpen} />

                <Drawer
                    anchor={'right'}
                    // Shifts the Paper's right edge in from the viewport edge by
                    // effectiveAnchorOffset px instead of the default right:0 - see that
                    // constant's own comment above. undefined (Quick View not docked, and no
                    // caller-supplied override) leaves the style prop itself undefined, so
                    // nothing changes for that case.
                    PaperProps={{
                        ref: setDrawerPaperNode,
                        ...(effectiveAnchorOffset ? { style: { right: effectiveAnchorOffset } } : {}),
                    }}
                    open={props.isEnquiryFormOpen}
                    onClose={onClose}
                    // See isAiChatDialogOpen's own comment above.
                    disableEnforceFocus={isAiChatDialogOpen}
                    disableAutoFocus={isAiChatDialogOpen}
                    // MUI's Slide (which Drawer's anchor="right" uses under the hood) always
                    // computes its off-screen starting point from window.innerWidth, with no
                    // way to tell it about effectiveAnchorOffset - so with the Paper's resting
                    // position already shifted in by effectiveAnchorOffset (to sit beside a
                    // docked Quick View panel), the stock calculation still slides the full
                    // window width, i.e. in from the page's far right edge, past Quick View's
                    // own space, rather than starting right at Quick View's edge. translateX(100%)
                    // is relative to the Paper's own rendered width, so it always means "slide
                    // in/out by exactly my own width" regardless of window size or right offset -
                    // overriding the transform here (after Slide sets its own, before the
                    // browser paints either) corrects the start/end point without touching
                    // Slide's own transition timing. A slightly longer, gentler duration only
                    // for this offset case too, since covering the old, longer distance in the
                    // same default timing is what made it feel abrupt.
                    SlideProps={(effectiveAnchorOffset || props.skipEnterTransition) ? {
                        ...(effectiveAnchorOffset ? {
                            onEnter: (node: HTMLElement) => {
                                node.style.webkitTransform = 'translateX(100%)';
                                node.style.transform = 'translateX(100%)';
                            },
                            onExit: (node: HTMLElement) => {
                                node.style.webkitTransform = 'translateX(100%)';
                                node.style.transform = 'translateX(100%)';
                            },
                        } : {}),
                        // Explicit bug report: see skipEnterTransition's own comment above.
                        ...(props.skipEnterTransition ? { appear: false } : {}),
                    } : undefined}
                    BackdropProps={props.skipEnterTransition ? { appear: false } : undefined}
                    transitionDuration={effectiveAnchorOffset ? { enter: 320, exit: 280 } : undefined}
                >

                    <Snackbar 
                        open={snackbar.open} 
                        autoHideDuration={6000} 
                        onClose={() => setSnackbar({ open: false, message: null })}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                    >
                        <Alert 
                            onClose={() => setSnackbar({ open: false, message: null })} 
                            severity={snackbar.severity ?? 'success'}
                            elevation={6} 
                            variant="filled"
                        >
                            {snackbar.message}
                        </Alert>
                    </Snackbar>
                    {/* <LightTooltip title={state.isExpandDrawer ? 'Collapse' : 'Expand'}>
                        <IconButton
                            className={classes.expandDrawer}
                            size="small"
                            onClick={onExpandDrawer}
                        >
                            {state.isExpandDrawer ? <FullscreenIcon fontSize="inherit" /> : <FullscreenExitIcon fontSize="inherit" /> }

                        </IconButton>
                    </LightTooltip> */}
                    {
                        // Explicit bug report: on this drawer's first mount in a session,
                        // regionSettings/countryQuery/tenantQuery haven't been fetched by
                        // anything else yet, so they were still loading even after
                        // isLoading/partyAddressesQuery.loading had already gone false - the
                        // "loaded" branch below rendered with its own inner displayLoader()
                        // call (before the blue headerBar) still showing a spinner, inside this
                        // same padded classes.root, then popping away once those three settled a
                        // moment later. Only ever visible once per session because those three
                        // are cache-first and resolve instantly on every later open. Folding all
                        // five into this same gate means the loaded branch only ever renders
                        // once every dependency is actually ready, so its own inner
                        // displayLoader() call can never fire.
                        //
                        // Explicit request: show the real layout's shape (header + 3 columns
                        // when isWideLayout, same as the loaded branch below will render) while
                        // this gate is up, rather than a bare spinner - isWideLayout is already
                        // known synchronously at this point (see its own declaration above),
                        // independent of whether any of these five have resolved yet.
                        isLoading || partyAddressesQuery.loading || regionSettings.loading || countryQuery.loading || tenantQuery.loading
                            ? <EnquiryFormDrawerSkeleton isWideLayout={isWideLayout} isMediumLayout={isMediumLayout} anchorOffset={effectiveAnchorOffset} isCreateForm={isCreateForm} />
                            : (
                                <Form
                                    // async and await use for fixing error on submit and reset the field
                                    onSubmit={async (values, form: FormApi<Enquiry>, callback) => await onSubmit(form, values, callback)}
                                    initialValues={defaultValues}
                                    initialValuesEqual={() => true}
                                    keepDirtyOnReinitialize={true}
                                    subscription={{ submitting: true, pristine: true, errors: true, }}
                                    // debug={(values) => {
                                    //     // tslint:disable-next-line: no-console
                                    //     console.log('Debug Values', values);
                                    // }}
                                    render={({ handleSubmit, form, submitting, pristine }) => {
                                        // Explicit request (EnquiryFormDrawer split): the form no longer subscribes to every value, so this
                                        // reads the values at the moment a tab is clicked instead of a render-time snapshot.
                                        const onTabChange = (event: React.ChangeEvent<{}>, newValue: EnquiryFormTab) => (
                                            handleTabChange(form.getState().values as Enquiry)(event, newValue)
                                        );

                                        return (
                                            <PickedFormValues pick={pickDrawerShellValues}>{(values) => (
                                                <div
                                                    className={classes.root}
                                                    style={{
                                                        // Explicit bug report: calc(100vw - 40px) never accounted for
                                                        // effectiveAnchorOffset (Quick View's own docked width) - on a
                                                        // window technically wide enough for the full WIDE_LAYOUT_DRAWER_
                                                        // WIDTH, but not once that offset is subtracted, this still
                                                        // capped at the full 100vw-derived value, extending the drawer's
                                                        // own left edge past the actually-visible area. Subtracting it
                                                        // here lets this shrink to whatever room is actually left -
                                                        // tabsContentAreaWideMiddleShrink's own minmax() then narrows
                                                        // just the middle column to fit that width.
                                                        maxWidth: isWideLayout
                                                            ? `min(${WIDE_LAYOUT_DRAWER_WIDTH}px, calc(100vw - ${effectiveAnchorOffset ?? 0}px - 40px))`
                                                            : isMediumLayout
                                                                ? `min(${MEDIUM_LAYOUT_DRAWER_WIDTH}px, calc(100vw - ${effectiveAnchorOffset ?? 0}px - 40px))`
                                                                : state.isExpandDrawer ? '100%' : hasCustomField && values.practiceAreaGuidID ? '1400px' : '700px',
                                                    }}
                                                >
                                                    <form onSubmit={handleSubmit} id="enquiryForm" autoComplete="off">
                                                        {/* <h3>{isCreateForm ? 'Create Enquiry' : 'Edit Enquiry'}</h3> */}
                                                        {/* displayLoader() removed here - the outer loading gate above now
                                                            also covers regionSettings/countryQuery/tenantQuery, so by the
                                                            time this branch renders all five are already false and this
                                                            call could never return anything. See that gate's own comment. */}

                                                        <FormSpy
                                                            subscription={{ pristine: true, values: true }}
                                                            // tslint:disable-next-line: no-shadowed-variable
                                                            onChange={props => {
                                                                onFormValueChanged(form, props, defaultValues);
                                                            }}
                                                        />

                                                        {values.showCustomFieldWarning && (
                                                            <DialogBox
                                                                title="Enquiries"
                                                                // tslint:disable-next-line:max-line-length
                                                                content={`Changing the Area of Law field will cause any further detail field data entered to be lost and a new group of further details will be displayed. Do you want to proceed?`}
                                                                show={values.showCustomFieldWarning ? values.showCustomFieldWarning : false}
                                                                isAgree={(agree: boolean) => {
                                                                    if (agree) {

                                                                        onGetCustomFields({
                                                                            areaOfLawGuid: values.tempPracticeAreaGuidID || null,
                                                                            customFieldGroupGuid: null
                                                                        }, form);

                                                                        form.change('showCustomFieldWarning', false);
                                                                        form.change('practiceAreaGuidID', values.tempPracticeAreaGuidID);
                                                                        form.change('areaOfLaw', values.tempAreaOfLaw);
                                                                        form.change('customField', undefined);
                                                                        form.change('tempAreaOfLaw', undefined);
                                                                        form.change('tempPracticeAreaGuidID', undefined);
                                                                    } else {
                                                                        form.change('showCustomFieldWarning', false);
                                                                    }
                                                                }}
                                                                disAgreeLabel={'No'}
                                                                agreeLabel={'Yes'}
                                                            />
                                                        )}

                                                        <PickedFormValues pick={pickHeaderValues}>
                                                            {/* tslint:disable-next-line: no-shadowed-variable */}
                                                            {(values) => (
                                                                <>
                                                                    {values.isBookMeetingEmailDialogOpen && (
                                                                        <BookMeetingEmailDialog
                                                                            enquiryGuid={values.guid}
                                                                            followUpAction={values.followUpAction}
                                                                            followUpActionSystemName={values.followUpActionSystemName}
                                                                            isSendConfirmation={values.isSendConfirmation}
                                                                            fromAddress={appUser ? appUser.userName : null}
                                                                            toAddresses={values.email}
                                                                            onClose={() => onToggleBookMeetingEmailDialog(form, false)}
                                                                            open={values.isBookMeetingEmailDialogOpen}
                                                                            staff={values.staff}
                                                                            officeLocation={values.officeLocation ? values.officeLocation.label : null}
                                                                            timezone={values.timezone ? values.timezone.value : null}
                                                                            startTime={values.startTime}
                                                                            endTime={values.endTime}
                                                                            isAllDay={values.isAllDay}
                                                                            meetingNotes={values.meetingNotes}
                                                                            feeApplicable={values.feeApplicable}
                                                                            assignedTo={values.assignedTo}
                                                                            isSendMeetingDefaultReminderEmail={values.isSendMeetingDefaultReminderEmail}
                                                                            isSendMeetingDefaultReminderSms={values.isSendMeetingDefaultReminderSms}
                                                                            periodMeetingDefaultReminder={values.periodMeetingDefaultReminder}
                                                                        />
                                                                    )}

                                                                    <div className={classes.headerBar}>
                                                                        <button type="button" className={classes.headerBackLink} onClick={onClose}>
                                                                            <ArrowBackIcon fontSize="small" />
                                                                            Enquiries
                                                                        </button>
                                                                        {/* Explicit change (enquiry prev/next navigation spec): the "Enquiry —
                                                                            ‹name›" segment is removed by default - it only reappears once the
                                                                            header card scrolls under this bar, as a breadcrumb trail instead. */}
                                                                        {!isCreateForm && (
                                                                            <ShowWhenScrolledPast isEnabled={props.isEnquiryFormOpen} rootNode={drawerPaperNode} targetNode={infoPanelNode}>
                                                                                <span className={classes.headerBreadcrumbSeparator}>›</span>
                                                                                <span className={classes.headerBreadcrumbCurrent}>
                                                                                    {(values.firstName && values.lastName) ? `${values.firstName} ${values.lastName}` : (values.organisation || '')}
                                                                                </span>
                                                                            </ShowWhenScrolledPast>
                                                                        )}
                                                                        {isCreateForm && (
                                                                            <>
                                                                                <span className={classes.headerBreadcrumbSeparator}>|</span>
                                                                                <span className={classes.headerBreadcrumbCurrent}>New Enquiry</span>
                                                                            </>
                                                                        )}
                                                                        {!isCreateForm && props.listNavigation && (
                                                                            <span className={classes.headerNavGroup}>
                                                                                <Tooltip title="Previous enquiry">
                                                                                    <span className={classes.headerNavPillButtonWrap}>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            className={classes.headerNavPillButton}
                                                                                            disabled={!props.listNavigation.canGoPrev}
                                                                                            onClick={onPrevClick}
                                                                                            aria-label="Previous enquiry"
                                                                                        >
                                                                                            <NavigateBeforeIcon fontSize="small" />
                                                                                        </IconButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                                <Tooltip title={props.listNavigation.filterSummary}>
                                                                                    <span className={classes.headerNavCounter}>
                                                                                        {props.listNavigation.position} of {props.listNavigation.total}
                                                                                    </span>
                                                                                </Tooltip>
                                                                                <Tooltip title="Next enquiry">
                                                                                    <span className={classes.headerNavPillButtonWrap}>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            className={classes.headerNavPillButton}
                                                                                            disabled={!props.listNavigation.canGoNext}
                                                                                            onClick={onNextClick}
                                                                                            aria-label="Next enquiry"
                                                                                        >
                                                                                            <NavigateNextIcon fontSize="small" />
                                                                                        </IconButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </span>
                                                                        )}
                                                                        {!isCreateForm && (
                                                                            <span className={classes.headerStatusChip} style={!props.listNavigation ? { marginLeft: 'auto' } : undefined}>
                                                                                <FiberManualRecordIcon
                                                                                    className={clsx(classes.infoBadgeIcon, values.isClosed ? classes.statusDotClosed : classes.statusDotActive)}
                                                                                />
                                                                                {values.isClosed ? 'Closed' : 'Active'}
                                                                            </span>
                                                                        )}
                                                                        {isWideLayout && (
                                                                            <>
                                                                                <Tooltip title="Take a tour of this form">
                                                                                    <Button
                                                                                        variant="text"
                                                                                        size="small"
                                                                                        className={classes.headerTourButton}
                                                                                        onClick={() => setTourRequestId((previousId) => previousId + 1)}
                                                                                        startIcon={<ExploreOutlinedIcon style={{ fontSize: 14 }} />}
                                                                                    >
                                                                                        Take a tour
                                                                                    </Button>
                                                                                </Tooltip>
                                                                                <EnquiryFormTourHost tourRequestId={tourRequestId} />
                                                                            </>
                                                                        )}
                                                                        {!isCreateForm && (
                                                                            <>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    className={classes.headerNavButton}
                                                                                    ref={overflowMenuAnchorRef}
                                                                                    onClick={() => setState((prevState) => ({ ...prevState, isOverflowMenuOpen: true }))}
                                                                                    aria-label="More actions"
                                                                                >
                                                                                    <MoreHorizOutlinedIcon fontSize="small" />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    anchorEl={overflowMenuAnchorRef.current}
                                                                                    open={state.isOverflowMenuOpen}
                                                                                    onClose={() => setState((prevState) => ({ ...prevState, isOverflowMenuOpen: false }))}
                                                                                    // Explicit bug report: MUI v4's Menu positions itself over its anchor by default (it aligns the
                                                                                    // first item with it), covering the ⋯ button. null turns that off so the menu drops below it,
                                                                                    // right-aligned with the button, with a small gap.
                                                                                    getContentAnchorEl={null}
                                                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                                    PaperProps={{ style: { marginTop: 6 } }}
                                                                                >
                                                                                    <MenuItem onClick={onHistoryReport}>
                                                                                        <ListItemIcon className={classes.overflowMenuIcon}>
                                                                                            <AssessmentOutlinedIcon fontSize="small" />
                                                                                        </ListItemIcon>
                                                                                        <ListItemText primary="History Report" />
                                                                                    </MenuItem>
                                                                                    {UserFeature.HasAccess(UserFeatureEnum.hasDeleteLead) && (
                                                                                        <MenuItem
                                                                                            className={classes.overflowMenuDeleteItem}
                                                                                            onClick={() => setState((prevState) => ({ ...prevState, isOverflowMenuOpen: false, isDeleteConfirmOpen: true }))}
                                                                                        >
                                                                                            <ListItemIcon className={classes.overflowMenuIcon}>
                                                                                                <DeleteOutlineIcon fontSize="small" />
                                                                                            </ListItemIcon>
                                                                                            <ListItemText primary="Delete" />
                                                                                        </MenuItem>
                                                                                    )}
                                                                                </Menu>
                                                                            </>
                                                                        )}
                                                                    </div>

                                                                    <div className={classes.infoPanel} ref={setInfoPanelNode}>
                                                                        <div className={classes.infoPanelMain}>
                                                                            <div className={classes.infoIdentity}>
                                                                                <div
                                                                                    className={clsx(
                                                                                        classes.infoAvatar,
                                                                                        isCreateForm && !(values.firstName || values.lastName || values.organisation)
                                                                                            && classes.infoAvatarEmpty,
                                                                                    )}
                                                                                >
                                                                                    {(values.firstName && values.lastName)
                                                                                        ? `${values.firstName.charAt(0)}${values.lastName.charAt(0)}`.toUpperCase()
                                                                                        : (values.organisation
                                                                                            ? values.organisation.charAt(0).toUpperCase()
                                                                                            : (isCreateForm ? <PersonAddIcon fontSize="small" /> : ''))}
                                                                                </div>
                                                                                <div className={clsx(classes.headerDetails, classes.headerLeft, isCreateForm && classes.infoIdentityStack)}>
                                                                                    {/* Blank identity column looked bad on a fresh "New Enquiry" -
                                                                                        show a placeholder until a name/organisation/contact detail
                                                                                        is entered, then reveal the real details. On a new enquiry the details are always
                                                                                        laid out (hidden while nothing is entered) and the placeholder sits over them, so the
                                                                                        header keeps the same height from the first keystroke instead of growing as lines
                                                                                        appear; the two cross-fade. */}
                                                                                    {isCreateForm && (
                                                                                        <p className={clsx(classes.infoIdentityPlaceholder, classes.infoIdentityPlaceholderOverlay, (values.firstName || values.lastName || values.organisation || values.email || values.phone || values.mobile) && classes.infoIdentityFadedOut)}>
                                                                                            Enter the contact's name below to see it here
                                                                                        </p>
                                                                                    )}
                                                                                    <div className={clsx(isCreateForm && classes.infoIdentityContent, isCreateForm && !(values.firstName || values.lastName || values.organisation || values.email || values.phone || values.mobile) && classes.infoIdentityFadedOut)}>
                                                                                        <AnimatedItem noFill={true}>
                                                                                            {(isCreateForm || !!(values.firstName && values.lastName)) && (
                                                                                                <h4 className="user" title={`${values.firstName || ''} ${values.lastName || ''}`.trim()}>
                                                                                                    {isCreateForm
                                                                                                        ? (`${values.firstName || ''} ${values.lastName || ''}`.trim() || ' ')
                                                                                                        : `${values.firstName} ${values.lastName}`}
                                                                                                </h4>
                                                                                            )}
                                                                                            {!!values.organisation && (
                                                                                                <p className="company" title={values.organisation}>
                                                                                                    {values.organisation}
                                                                                                </p>
                                                                                            )}
                                                                                            {values.email ? (
                                                                                                <ContactLine
                                                                                                    icon={<MailOutlineIcon fontSize="small" />}
                                                                                                    href={`mailto:${values.email}`}
                                                                                                    displayText={values.email}
                                                                                                    copyText={values.email}
                                                                                                    fullText={values.email}
                                                                                                />
                                                                                            ) : (
                                                                                                <AddContactFieldLink
                                                                                                    icon={<MailOutlineIcon fontSize="small" />}
                                                                                                    label="Add email"
                                                                                                    ariaLabel="Add email address"
                                                                                                    onClick={() => onAddContactFieldClick('email')}
                                                                                                />
                                                                                            )}
                                                                                            <div className={classes.contactsContainer}>
                                                                                                {(values.phone || values.mobile) ? (
                                                                                                    <>
                                                                                                        {!!values.phone && (
                                                                                                            <ContactLine
                                                                                                                icon={<PhoneOutlinedIcon fontSize="small" />}
                                                                                                                href={`tel:${values.phone}`}
                                                                                                                displayText={formatAuPhoneForDisplay(values.phone)}
                                                                                                                copyText={formatAuPhoneForDisplay(values.phone)}
                                                                                                                fullText={values.phone}
                                                                                                                showCall={true}
                                                                                                            />
                                                                                                        )}
                                                                                                        {!!values.mobile && (
                                                                                                            <ContactLine
                                                                                                                icon={<PhoneIphoneIcon fontSize="small" />}
                                                                                                                href={`tel:${values.mobile}`}
                                                                                                                displayText={formatAuPhoneForDisplay(values.mobile)}
                                                                                                                copyText={formatAuPhoneForDisplay(values.mobile)}
                                                                                                                fullText={values.mobile}
                                                                                                                showCall={true}
                                                                                                            />
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <AddContactFieldLink
                                                                                                        icon={<PhoneOutlinedIcon fontSize="small" />}
                                                                                                        label="Add phone"
                                                                                                        ariaLabel="Add phone number"
                                                                                                        onClick={() => onAddContactFieldClick('phone')}
                                                                                                    />
                                                                                                )}
                                                                                                {!!values.internalNotes && getInternalNotes(values.internalNotes, 110)}
                                                                                            </div>
                                                                                        </AnimatedItem>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {/* Explicit request: the two journey widgets are centered as a
                                                                                group in the space between infoIdentity and headerRight (same as
                                                                                medium layout's lone widget below) instead of sitting flush
                                                                                against infoIdentity with the leftover space piling up in front
                                                                                of headerRight. */}
                                                                            {isWideLayout && !isCreateForm && (
                                                                                <div className={classes.journeyWidgetsCenteredGroup} data-tour="enquiry-journey">
                                                                                    <div className={classes.journeyNextFollowUpSlot}>
                                                                                        {isActivityLoading ? (
                                                                                        <HeaderWidgetSkeleton variant="nextFollowUp" />
                                                                                    ) : (
                                                                                        <EnquiryNextFollowUpWidget enquiryDetail={enquiryDetail} tasks={leadDetailsHistory.tasks} />
                                                                                    )}
                                                                                    </div>
                                                                                    {isActivityLoading ? (
                                                                                        <HeaderWidgetSkeleton variant="journey" />
                                                                                    ) : (
                                                                                        <EnquiryJourneyTimelineWidget enquiryDetail={enquiryDetail} tasks={leadDetailsHistory.tasks} />
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {/* Explicit request: medium layout's own header has less room than
                                                                                wide's - just the first (Next Follow-up) widget, not the journey
                                                                                strip. Explicit follow-up request: since the strip isn't there to
                                                                                fill the row, this widget is centered in whatever space is left
                                                                                between infoIdentity and headerRight instead of sitting flush
                                                                                against infoIdentity's own right edge - the wrapper's flex:1
                                                                                claims exactly that leftover space (the same space headerRight's
                                                                                own marginLeft:'auto' would otherwise have claimed alone), and
                                                                                justifyContent:'center' centers the widget within it. The
                                                                                widget's own flex:'0 1 330px' still governs its width/shrinking
                                                                                here, same as before this wrapper existed. */}
                                                                            {isMediumLayout && !isCreateForm && (
                                                                                <div className={classes.journeyNextFollowUpCenteredSlot} data-tour="enquiry-journey">
                                                                                    {isActivityLoading ? (
                                                                                        <HeaderWidgetSkeleton variant="nextFollowUp" />
                                                                                    ) : (
                                                                                        <EnquiryNextFollowUpWidget enquiryDetail={enquiryDetail} tasks={leadDetailsHistory.tasks} />
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {!isCreateForm && (
                                                                                <div className={`${classes.headerDetails} ${classes.headerRight}`}>
                                                                                    {!!enquiryDetail.createdDate && (
                                                                                        <LightTooltip
                                                                                            arrow={true}
                                                                                            title={formatDate(enquiryDetail.createdDate, 'DD MMM YYYY hh:mm a')}
                                                                                            placement="left-start"
                                                                                        >
                                                                                            <p className="common">Created <strong>{formatDate(enquiryDetail.createdDate, 'DD MMM YYYY')}</strong></p>
                                                                                        </LightTooltip>
                                                                                    )}
                                                                                    {!!(values.assignedToName || enquiryDetail.dateAssigned) && (
                                                                                        <LightTooltip
                                                                                            arrow={true}
                                                                                            title={enquiryDetail.dateAssigned ? formatDate(enquiryDetail.dateAssigned, 'DD MMM YYYY hh:mm a') : ''}
                                                                                            placement="left-start"
                                                                                        >
                                                                                            <p className="common">
                                                                                                Assigned
                                                                                                {values.assignedToName && <span className="assigneeChip">{values.assignedToName}</span>}
                                                                                                {!!enquiryDetail.dateAssigned && `(${showDateEndOfFromNow(enquiryDetail.dateAssigned)})`}
                                                                                            </p>
                                                                                        </LightTooltip>
                                                                                    )}
                                                                                    {
                                                                                        // Explicit request: this used to show the next follow-up's own
                                                                                        // due/overdue state - now covered by the Next Follow-up header
                                                                                        // widget (EnquiryNextFollowUpWidget) instead, so showing it here
                                                                                        // too was a duplicate. "Open for N days" instead - same
                                                                                        // still-open gate (!canReOpen) as before, no longer tied to
                                                                                        // whether a follow-up happens to be scheduled.
                                                                                        !!(enquiryActionData && !enquiryActionData.canReOpen) && (
                                                                                            <LightTooltip
                                                                                                arrow={true}
                                                                                                title={formatDate(enquiryDetail.createdDate, 'DD MMM YYYY hh:mm a')}
                                                                                                placement="left-start"
                                                                                            >
                                                                                                <span
                                                                                                    className={clsx(classes.followUpChip, classes.followUpChipNeutral)}
                                                                                                >
                                                                                                    <AccessTimeIcon />
                                                                                                    {/* Explicit bug report: "Open for 1 days" - singular/plural.
                                                                                                        Explicit request: "Open for 0 days" read badly - by calendar day it's
                                                                                                        "Opened today", and an enquiry from yesterday that's under 24h old
                                                                                                        (getDaysOpen is still 0) is "Opened yesterday". getDaysOpen itself
                                                                                                        is unchanged. */}
                                                                                                    {moment(enquiryDetail.createdDate).isSame(moment(), 'day')
                                                                                                        ? 'Opened today'
                                                                                                        : getDaysOpen(enquiryDetail) === 0
                                                                                                            ? 'Opened yesterday'
                                                                                                            : `Open for ${getDaysOpen(enquiryDetail)} day${getDaysOpen(enquiryDetail) === 1 ? '' : 's'}`}
                                                                                                </span>
                                                                                            </LightTooltip>
                                                                                        )}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        {!isCreateForm && (
                                                                            <div className={classes.badgeRow}>
                                                                                <div className={classes.badgeRowContent} data-tour="enquiry-badges">
                                                                                    <EnquiryRatingBadge fieldName="enquiryQuality" label="Quality" form={form} classes={classes} onRatingChange={onRatingChange} />
                                                                                    <EnquiryRatingBadge fieldName="likelihoodToProceed" label="Likelihood" form={form} classes={classes} onRatingChange={onRatingChange} />
                                                                                    {!!values.areaOfLaw && (
                                                                                        <LightTooltip arrow={true} title={`Area of Law: ${values.areaOfLaw}`}>
                                                                                            <div className={classes.infoBadge}>
                                                                                                <GavelIcon className={classes.infoBadgeIcon} />
                                                                                                <span className={classes.infoBadgeValue}>{values.areaOfLaw}</span>
                                                                                            </div>
                                                                                        </LightTooltip>
                                                                                    )}
                                                                                    {props.guid && UserFeature.HasAccess(UserFeatureEnum.hasCRMEnquiryAssessmentAI) && (
                                                                                        <EnquiryAiHeaderBadge
                                                                                            enquiryGuid={props.guid}
                                                                                            enquirySummary={buildDocumentAiEnquirySummary(values)}
                                                                                            badgeClassName={classes.infoBadge}
                                                                                            iconClassName={classes.infoBadgeIcon}
                                                                                            valueClassName={classes.infoBadgeValue}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </PickedFormValues>

                                                        {/* Explicit request: CreateEnquirySaga stores a warning here when the enquiry was created but some
                                                            documents / contact updates failed. Shown above every tab since it's about the whole enquiry;
                                                            the backend clears it the next time the enquiry is saved (u_Enquiry). */}
                                                        {!isCreateForm && !!enquiryDetail.creationWarning && (
                                                            <Alert severity="warning" className={classes.creationWarningAlert}>
                                                                {enquiryDetail.creationWarning}
                                                            </Alert>
                                                        )}

                                                        <Grid
                                                            container={true}
                                                            spacing={3}
                                                            // Explicit request: the sticky footer must always stay pinned to
                                                            // the drawer's bottom edge regardless of how short the active
                                                            // tab's content is - this flex:1 (filling remaining height via
                                                            // the row's own align-items:stretch) is what achieves that, so
                                                            // it stays unconditional rather than being Activity-only.
                                                            style={{ flex: 1 }}
                                                        >
                                                            <Grid
                                                                item={true}
                                                                sm={12}
                                                                xs={12}
                                                                {...(hasCustomField && values.practiceAreaGuidID ? { md: 6, lg: 6 } : { md: 12, lg: 12 })}
                                                                style={{ flex: 1, display: 'flex', flexFlow: 'column' }}
                                                            >
                                                                {values.isContactDetailsChanged && (
                                                                    <div>
                                                                        <Alert severity="warning">
                                                                            Please uncheck if you don't want to update the record in Clients & Contacts database
                                                                            <br />
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={values.isUpdateContacts}
                                                                                        // tslint:disable-next-line: max-line-length
                                                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                                                            // Another approach.
                                                                                            onUpdateContact(form, form.getState().values, checked);
                                                                                        }}
                                                                                        name="checkedB"
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Update Clients & Contacts record"
                                                                            />
                                                                        </Alert>
                                                                    </div>
                                                                )}
                                                                {/* Same condition the Further Details <Tab> below already uses to decide
                                                                    whether it exists at all - named here too so the wide layout's own
                                                                    middle-column heading (further down) can reuse it instead of
                                                                    duplicating the raw expression a third time. */}
                                                                {(() => {
                                                                    const isFurtherDetailsAvailable = UserFeature.HasAccess(UserFeatureEnum.hasCustomFieldMaintenance)
                                                                        && !isCreateForm && values.practiceAreaGuidID
                                                                        && !!(isCustomFieldLoading || (state.customFieldByHierarchy && state.customFieldByHierarchy.length > 0));

                                                                    return (
                                                                        <>
                                                                            {!isWideLayout && !isMediumLayout && (
                                                                                <Tabs
                                                                                    value={state.tab}
                                                                                    onChange={onTabChange}
                                                                                    indicatorColor="primary"
                                                                                    textColor="primary"
                                                                                    className={classes.tabs}
                                                                                >
                                                                                    <Tab className={classes.tabItem} label="Details" value={EnquiryFormTab.details} />
                                                                                    {/* Explicit bug report: this used to wait on state.customFieldByHierarchy.length > 0
                                                                                        alone, so the tab itself only popped into the bar once the fetch actually
                                                                                        resolved - shifting Activity/Matter sideways with no warning after whatever
                                                                                        delay the request took. Now shown as soon as we know it's coming
                                                                                        (isCustomFieldLoading, which starts true and is set right before this query
                                                                                        fires - see onGetCustomFields) so the tab's position is stable from the first
                                                                                        render; getCustomFields() already renders its own SkeletonLoader while
                                                                                        isCustomFieldLoading is true, so the tab has real loading content behind it
                                                                                        instead of sitting there empty. Trade-off: a practice area with zero custom
                                                                                        field groups configured will show the tab briefly then remove it once the
                                                                                        fetch resolves empty, rather than never showing it - judged the rarer,
                                                                                        less jarring case against the common one this fixes. */}
                                                                                    {isFurtherDetailsAvailable && (
                                                                                        <Tab className={classes.tabItem} label="Further Details" value={EnquiryFormTab.customFields} />
                                                                                    )}
                                                                                    <Tab
                                                                                        className={classes.tabItem}
                                                                                        label={(
                                                                                            <>
                                                                                                Activity
                                                                                                {leadDetailsHistory.tasks.length > 0 && (
                                                                                                    <span className={clsx(classes.tabCount, state.tab === EnquiryFormTab.activity && classes.tabCountSelected)}>
                                                                                                        {leadDetailsHistory.tasks.length}
                                                                                                    </span>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                        value={EnquiryFormTab.activity}
                                                                                    />
                                                                                    {isMatterAvailable && (
                                                                                        <Tab className={classes.tabItem} label="Matter" value={EnquiryFormTab.matterDetails} />
                                                                                    )}
                                                                                </Tabs>
                                                                            )}
                                                                            <div
                                                                                className={isWideLayout
                                                                                    ? clsx(classes.tabsContentAreaWide, classes.tabsContentAreaWideMiddleShrink)
                                                                                    : isMediumLayout
                                                                                        ? classes.tabsContentAreaMedium
                                                                                        : classes.tabsContentArea}
                                                                            >
                                                                            {isWideLayout && (
                                                                                <>
                                                                                    <div className={classes.columnHeadingBar} style={{ gridArea: 'detailsHead' }} data-tour="enquiry-column-details">
                                                                                        <Tabs value="details" className={classes.columnHeadingTabs}>
                                                                                            <Tab className={classes.tabItem} label="Details" value="details" />
                                                                                        </Tabs>
                                                                                        <Button
                                                                                            size="small"
                                                                                            className={classes.columnHeadingAction}
                                                                                            data-tour="enquiry-expand-all"
                                                                                            startIcon={isAllDetailsPanelsExpanded ? <UnfoldLessIcon fontSize="small" /> : <UnfoldMoreIcon fontSize="small" />}
                                                                                            onClick={onToggleExpandAllDetailsPanels}
                                                                                        >
                                                                                            {isAllDetailsPanelsExpanded ? 'Collapse all' : 'Expand all'}
                                                                                        </Button>
                                                                                    </div>
                                                                                    <div className={classes.columnHeadingBar} style={{ gridArea: 'middleHead' }} data-tour="enquiry-column-middle">
                                                                                        {isFurtherDetailsAvailable ? (
                                                                                            <Tabs
                                                                                                value={isMiddleShowingActivity ? EnquiryFormTab.activity : EnquiryFormTab.customFields}
                                                                                                onChange={onTabChange}
                                                                                                indicatorColor="primary"
                                                                                                textColor="primary"
                                                                                                className={classes.columnHeadingTabs}
                                                                                            >
                                                                                                <Tab
                                                                                                    className={classes.tabItem}
                                                                                                    label={(
                                                                                                        <>
                                                                                                            Activity
                                                                                                            {leadDetailsHistory.tasks.length > 0 && (
                                                                                                                <span className={clsx(classes.tabCount, isMiddleShowingActivity && classes.tabCountSelected)}>
                                                                                                                    {leadDetailsHistory.tasks.length}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                    value={EnquiryFormTab.activity}
                                                                                                />
                                                                                                <Tab className={classes.tabItem} label="Further Details" value={EnquiryFormTab.customFields} />
                                                                                            </Tabs>
                                                                                        ) : (
                                                                                            <Tabs value={EnquiryFormTab.activity} className={classes.columnHeadingTabs}>
                                                                                                <Tab
                                                                                                    className={classes.tabItem}
                                                                                                    label={(
                                                                                                        <>
                                                                                                            Activity
                                                                                                            {leadDetailsHistory.tasks.length > 0 && (
                                                                                                                <span className={clsx(classes.tabCount, classes.tabCountSelected)}>
                                                                                                                    {leadDetailsHistory.tasks.length}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                    value={EnquiryFormTab.activity}
                                                                                                />
                                                                                            </Tabs>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className={classes.columnHeadingBar} style={{ gridArea: 'thirdHead' }} data-tour="enquiry-column-third">
                                                                                        <Tabs value="third" className={classes.columnHeadingTabs}>
                                                                                            <Tab className={classes.tabItem} label={showMatterIn3rdColumn ? 'Matter' : 'Follow Up'} value="third" />
                                                                                        </Tabs>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                            {isMediumLayout && (
                                                                                <>
                                                                                    {/* Explicit request: Details/Activity/Further Details share this one
                                                                                        column - a real switcher (unlike wide layout's own static Details/
                                                                                        thirdHead headings), same tab values/handler the narrow single-
                                                                                        column bar above uses, just without the Matter tab (Follow-Up/
                                                                                        Matter keep their own independent column, same as wide layout). */}
                                                                                    <div className={classes.columnHeadingBar} style={{ gridArea: 'leftHead' }}>
                                                                                        <Tabs
                                                                                            value={state.tab === EnquiryFormTab.matterDetails ? EnquiryFormTab.details : state.tab}
                                                                                            onChange={onTabChange}
                                                                                            indicatorColor="primary"
                                                                                            textColor="primary"
                                                                                            className={classes.columnHeadingTabs}
                                                                                        >
                                                                                            <Tab className={classes.tabItem} label="Details" value={EnquiryFormTab.details} />
                                                                                            {isFurtherDetailsAvailable && (
                                                                                                <Tab className={classes.tabItem} label="Further Details" value={EnquiryFormTab.customFields} />
                                                                                            )}
                                                                                            <Tab
                                                                                                className={classes.tabItem}
                                                                                                label={(
                                                                                                    <>
                                                                                                        Activity
                                                                                                        {leadDetailsHistory.tasks.length > 0 && (
                                                                                                            <span className={clsx(classes.tabCount, state.tab === EnquiryFormTab.activity && classes.tabCountSelected)}>
                                                                                                                {leadDetailsHistory.tasks.length}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                                value={EnquiryFormTab.activity}
                                                                                            />
                                                                                        </Tabs>
                                                                                    </div>
                                                                                    <div className={classes.columnHeadingBar} style={{ gridArea: 'thirdHead' }}>
                                                                                        <Tabs value="third" className={classes.columnHeadingTabs}>
                                                                                            <Tab className={classes.tabItem} label={showMatterIn3rdColumn ? 'Matter' : 'Follow Up'} value="third" />
                                                                                        </Tabs>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                {/* details tab */}
                                                                <FormSpy subscription={{ values: true }}>
                                                                    {({ values: allValues }) => detailsTab(form, pristine, allValues as Enquiry, submitting)}
                                                                </FormSpy>
                                                                {/* activity tab */}
                                                                <ActivityTabSection
                                                                    form={form}
                                                                    pristine={pristine}
                                                                    state={state}
                                                                    enquiryActionData={enquiryActionData}
                                                                    leadDetailsHistory={leadDetailsHistory}
                                                                    enquiryDetail={enquiryDetail}
                                                                    isSubmitting={isSubmitting}
                                                                    isActivityLoading={isActivityLoading}
                                                                    appUser={appUser}
                                                                    props={props}
                                                                    isWideLayout={isWideLayout}
                                                                    isMediumLayout={isMediumLayout}
                                                                    isMiddleShowingActivity={isMiddleShowingActivity}
                                                                    showMatterIn3rdColumn={showMatterIn3rdColumn}
                                                                    isTabActivity={isTabActivity}
                                                                    onHistoryCreateClient={onHistoryCreateClient}
                                                                    onHistoryAcitivtyAssign={onHistoryAcitivtyAssign}
                                                                    OnRemoveAutFollowUp={OnRemoveAutFollowUp}
                                                                    onCreateClientDialog={onCreateClientDialog}
                                                                    isMarkClientMatterWidthLong={isMarkClientMatterWidthLong}
                                                                    onCompleteCreateClient={onCompleteCreateClient}
                                                                    onReOpen={onReOpen}
                                                                    onFollowUpChange={onFollowUpChange}
                                                                    onChangeSelection={onChangeSelection}
                                                                    onDateTimePickerChange={onDateTimePickerChange}
                                                                    onChangeAllDay={onChangeAllDay}
                                                                    onEmailTemplateChange={onEmailTemplateChange}
                                                                    onSendEmailDialogClose={onSendEmailDialogClose}
                                                                    onOutcomeChange={onOutcomeChange}
                                                                    onOutcomeDateChange={onOutcomeDateChange}
                                                                    getOutcomeDefaultTime={getOutcomeDefaultTime}
                                                                    onDropdownChange={onDropdownChange}
                                                                    onDropDownSelect={onDropDownSelect}
                                                                    onSwitch={onSwitch}
                                                                    requiredDateValidator={requiredDateValidator}
                                                                    required={required}
                                                                    onSaveFollowUp={onSaveFollowUp}
                                                                    onCancelFollowUp={onCancelFollowUp}
                                                                    followUpFieldValidator={followUpFieldValidator}
                                                                    onAddContactFieldClick={onAddContactFieldClick}
                                                                />
                                                                <MatterTabSection
                                                                    form={form}
                                                                    state={state}
                                                                    isWideLayout={isWideLayout}
                                                                    isMediumLayout={isMediumLayout}
                                                                    showMatterIn3rdColumn={showMatterIn3rdColumn}
                                                                    enquiryDetail={enquiryDetail}
                                                                    enquiryActionData={enquiryActionData}
                                                                    isSubmitting={isSubmitting}
                                                                    isMatterLoading={isMatterLoading}
                                                                    fetchMatterDetails={fetchMatterDetails}
                                                                    onShowMatterDetails={onShowMatterDetails}
                                                                    estimatedFeesColour={estimatedFeesColour}
                                                                    uploadEnquiryMatterDocument={uploadEnquiryMatterDocument}
                                                                />
                                                                {/* {futherDetailsTab(form, pristine, values)} */}
                                                                {state.tab === EnquiryFormTab.customFields && (
                                                                    <div
                                                                        style={isWideLayout ? {
                                                                            gridArea: 'middle',
                                                                            minWidth: 0,
                                                                            borderLeft: `1px solid ${mainTheme.CommonColor.LightGrey2}`,
                                                                            paddingLeft: 16,
                                                                        } : isMediumLayout ? {
                                                                            gridArea: 'left',
                                                                            minWidth: 0,
                                                                            borderLeft: `1px solid ${mainTheme.CommonColor.LightGrey2}`,
                                                                            paddingLeft: 16,
                                                                        } : undefined}
                                                                    >
                                                                        <AnimatedItem key={state.tab} noFill={true}>
                                                                            {getCustomFields(form, form.getState().values as Enquiry)}
                                                                        </AnimatedItem>
                                                                    </div>
                                                                )}
                                                                </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </Grid>
                                                            {hasCustomField && values.practiceAreaGuidID && (
                                                                <Grid item={true} sm={12} xs={12} md={6} lg={6}>
                                                                    {!props.guid && (
                                                                        <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                                                                            <Tabs
                                                                                value={0}
                                                                                indicatorColor="primary"
                                                                                textColor="primary"
                                                                                className={classes.tabs}
                                                                                centered={true}
                                                                            >
                                                                                <Tab label="Further Details" disableRipple={true} />
                                                                            </Tabs>
                                                                        </Grid>
                                                                    )}
                                                                    <AnimatedItem key={values.practiceAreaGuidID} noFill={true}>
                                                                        {getCustomFields(form, form.getState().values as Enquiry)}
                                                                    </AnimatedItem>
                                                                </Grid>
                                                            )}
                                                        </Grid>

                                                        <PickedFormValues pick={pickActionButtonValues}>
                                                            {(pickedValues) => actionButton(form, submitting, pristine, pickedValues as Enquiry, false, false, false, false, !(isWideLayout || isMediumLayout))}
                                                        </PickedFormValues>

                                                        {/* {printJson()}  */}
                                                        {/* {printJson(enquiryDetail)} */}
                                                    </form>
                                                </div>
                                            )}</PickedFormValues>
                                        );
                                    }}
                                />
                            )
                    }
                </Drawer>
            </React.Fragment>
        </>
    );
};

// Other dialogs import this from here; it is the shared helper (the copy that used to live here was identical).
export { addBusinessDays } from '../../helpers/commonHelper';

// tslint:disable-next-line: no-any
// export function printJson() {

//     return (
//         <>
//             <FormSpy subscription={{ values: true }}>
//                 {({ values }) => {
//                     return (
//                         <pre>
//                             {JSON.stringify(values, undefined, 2)}
//                         </pre>
//                     );
//                 }}
//             </FormSpy>
//         </>
//     );
// }
